import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { trackEvent, track, event } from '@zillow/universal-analytics';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import { isSessionStorageSupported, isLocalStorageSupported } from '@zillow/is-local-storage-supported';
import { zillowURL } from '@zillow/url';
import abtest from '@zillow/mortgage-abtest';
import API from '@zillow/mortgage-api-client';
import _omit from 'lodash/omit';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import styled, { css } from 'styled-components';
import { Spacer, token, mediaMixin, ProgressBar, spaceMixin, Form, Card, Button, Paragraph, TextButton, Text, BUTTON_TYPES, CARD_TYPES, Flex, FormActions, TooltipPopper, Tooltip, TriggerText, Heading, Anchor, List, PageContent, Combobox, Input, FormHelp, FormField, Label, Alert, typographyMixin, AnchorMixin, TableMixin, ModalDialog, StyledDialog, StyledDialogBody, FONT_TYPES, StyledIcon, StyledText, IconCheckmark } from '@zillow/constellation';
import { dollar } from '@zillow/formatters';
import { isWebview } from '@zillow/mortgage-webview-query-params';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { RHFSchemaGeneratedField, FIELD_TYPES, useForm, RHFDownPayment } from '@zillow/zgm-react-hook-form';
import zgmYup, { types } from '@zillow/zgm-yup';
import _debounce from 'lodash/debounce';
import _toArray from '@babel/runtime/helpers/esm/toArray';
import _inheritsLoose from '@babel/runtime/helpers/esm/inheritsLoose';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
var reactIs_development_1 = reactIs_development.AsyncMode;
var reactIs_development_2 = reactIs_development.ConcurrentMode;
var reactIs_development_3 = reactIs_development.ContextConsumer;
var reactIs_development_4 = reactIs_development.ContextProvider;
var reactIs_development_5 = reactIs_development.Element;
var reactIs_development_6 = reactIs_development.ForwardRef;
var reactIs_development_7 = reactIs_development.Fragment;
var reactIs_development_8 = reactIs_development.Lazy;
var reactIs_development_9 = reactIs_development.Memo;
var reactIs_development_10 = reactIs_development.Portal;
var reactIs_development_11 = reactIs_development.Profiler;
var reactIs_development_12 = reactIs_development.StrictMode;
var reactIs_development_13 = reactIs_development.Suspense;
var reactIs_development_14 = reactIs_development.isAsyncMode;
var reactIs_development_15 = reactIs_development.isConcurrentMode;
var reactIs_development_16 = reactIs_development.isContextConsumer;
var reactIs_development_17 = reactIs_development.isContextProvider;
var reactIs_development_18 = reactIs_development.isElement;
var reactIs_development_19 = reactIs_development.isForwardRef;
var reactIs_development_20 = reactIs_development.isFragment;
var reactIs_development_21 = reactIs_development.isLazy;
var reactIs_development_22 = reactIs_development.isMemo;
var reactIs_development_23 = reactIs_development.isPortal;
var reactIs_development_24 = reactIs_development.isProfiler;
var reactIs_development_25 = reactIs_development.isStrictMode;
var reactIs_development_26 = reactIs_development.isSuspense;
var reactIs_development_27 = reactIs_development.isValidElementType;
var reactIs_development_28 = reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

/**
 * Singleton context bounded to this module
 *   designed to be usable outside of React components
 *   NOTE: changes are purposely NOT communicated back to React to avoid re-rendering concern
 */
var context = {};
var initialExternalContext = undefined;
function createContext(newContext) {
  if (initialExternalContext) {
    return;
  }
  initialExternalContext = JSON.parse(JSON.stringify(newContext));
  context = initialExternalContext;
}
function getContext() {
  return context;
}
function setContext(newContext) {
  context = Object.assign({}, context, newContext);
}
function useQuestionnaireContext(newContext) {
  createContext(newContext);
  return context;
}

// ZGMIAIR-4047 until we land on a common CQ/Connect credit score option list, don't use param answer for creditScore so that question get always asked
var unsupportedPrePopulatedParams = ['creditScore'];

/**
 * getTrustedAnswers based on URL, schema, and context (hosting app props)
 */
function getTrustedAnswers(schema) {
  var context = getContext();
  var answers = {};
  if (global.window && global.window.location.search) {
    // eg. /mortgage-rates/?location=CA&propertyValue=654321
    var searchParams = new URLSearchParams(window.location.search);
    schema.forEach(function (_ref) {
      var name = _ref.name,
        aliases = _ref.aliases;
      // TODO: ZGMIAIR-686 define all validation rule in schema so everything is covered here
      if (!unsupportedPrePopulatedParams.includes(name)) {
        var _ref2, _parseStringAnswersFr;
        answers[name] = (_ref2 = (_parseStringAnswersFr = parseStringAnswersFromParam(searchParams, name)) !== null && _parseStringAnswersFr !== void 0 ? _parseStringAnswersFr : parseStringAnswersFromParam(searchParams, aliases === null || aliases === void 0 ? void 0 : aliases.find(function (alias) {
          var _searchParams$get;
          return (_searchParams$get = searchParams.get(alias)) !== null && _searchParams$get !== void 0 ? _searchParams$get : false;
        }))) !== null && _ref2 !== void 0 ? _ref2 : undefined;
      }
    });
  }
  // TODO: ZGMIAIR-970 remove hash support in favor of location.search
  if (global.window && global.window.location.hash) {
    // eg. /mortgages/#/landing&loanType=refinance&zipCode=98360&propertyValue=575000&propertyType=SingleFamilyHome&source=Z_NotForSaleHDP_Main&hdpSource=NFS_HDP
    var searchLikeHashParams = new URLSearchParams(global.window.location.hash.replace(/^#/, ''));
    schema.forEach(function (_ref3) {
      var name = _ref3.name,
        aliases = _ref3.aliases;
      // TODO: ZGMIAIR-686 define all validation rule in schema so everything is covered here
      if (!unsupportedPrePopulatedParams.includes(name)) {
        var _ref4, _parseStringAnswersFr2;
        answers[name] = (_ref4 = (_parseStringAnswersFr2 = parseStringAnswersFromParam(searchLikeHashParams, name)) !== null && _parseStringAnswersFr2 !== void 0 ? _parseStringAnswersFr2 : parseStringAnswersFromParam(searchLikeHashParams, aliases === null || aliases === void 0 ? void 0 : aliases.find(function (alias) {
          var _searchLikeHashParams;
          return (_searchLikeHashParams = searchLikeHashParams.get(alias)) !== null && _searchLikeHashParams !== void 0 ? _searchLikeHashParams : false;
        }))) !== null && _ref4 !== void 0 ? _ref4 : answers[name];
      }
    });
  }
  if (context) {
    schema.forEach(function (_ref5) {
      var _context$name;
      var name = _ref5.name;
      return answers[name] = (_context$name = context[name]) !== null && _context$name !== void 0 ? _context$name : answers[name];
    });
  }
  return JSON.parse(JSON.stringify(answers));
}

// parse URLSearchParams into questions answer format
// TODO: ZGMIAIR-1106 define the logic in questionnaire schema
function parseStringAnswersFromParam(searchParams, name) {
  var answer = searchParams.get(name);
  if (answer === null || answer === '') {
    return;
  }
  switch (name) {
    case 'location':
      return {
        name: answer
      };
    // only populate name so all types of locations are supported
    case 'zip':
    case 'zipCode':
      return {
        name: answer,
        zipCode: answer
      };
    case 'name':
      return {
        first: answer.split(' ')[0],
        last: answer.split(' ')[1]
      };
    case 'propertyValue':
    case 'value':
    case 'downPayment':
    case 'down':
    case 'loanBalance':
    case 'annualIncome':
    case 'income':
      return Number.isNaN(Number(answer)) ? undefined : Number(answer);
    case 'firstTime':
    case 'homeOwner':
    case 'selling':
    case 'hasAgent':
    case 'vaEligible':
    case 'militaryHistory':
    case 'secondMortgage':
    case 'cashOut':
    case 'selfEmployed':
    case 'creditHistory':
      return answer === 'true';
    default:
      return answer;
  }
}
var getTargetRouteName = function getTargetRouteName(schema) {
  if (!window.location.hash) {
    return;
  }
  var hashRoute =
  // @deprecated legacy hash can contain answers as like query params
  window.location.hash.indexOf('&') === -1 ? window.location.hash : window.location.hash.substr(0, window.location.hash.indexOf('&'));
  // is a legacy query param
  if (hashRoute.indexOf('=') !== -1) {
    return;
  }
  var matchedRoute = schema.find(function (_ref6) {
    var name = _ref6.name;
    return hashRoute === "#" + name || hashRoute === "#/" + name;
  });
  return matchedRoute === null || matchedRoute === void 0 ? void 0 : matchedRoute.name;
};

/**
 * This is a utility lib to get and "upsert" item in a sessionStorage backed map
 * implemented as a light wrapper so that exposed operations won't throw error
 */
var getItem = function getItem(storageKey) {
  if (isSessionStorageSupported()) {
    return sessionStorage.getItem(storageKey);
  }
};
var getMapObject = function getMapObject(storageKey) {
  try {
    var item = JSON.parse(getItem(storageKey));
    if (item && _typeof(item) === 'object' && !Array.isArray(item)) {
      return item;
    }
  } catch (_unused) {} // eslint-disable-line no-empty
};
var setItem = function setItem(storageKey, item) {
  if (isSessionStorageSupported()) {
    sessionStorage.setItem(storageKey, JSON.stringify(item));
  }
};
var setItemInMap = function setItemInMap(storageKey, itemsMap) {
  var updatedMap = Object.assign({}, getMapObject(storageKey), itemsMap);
  setItem(storageKey, updatedMap);
};

/**
 * This is a utility lib to get and "upsert" item in a localStorage backed map
 * implemented as a light wrapper so that exposed operations won't throw error
 */
var getItem$1 = function getItem(storageKey) {
  if (isLocalStorageSupported()) {
    return localStorage.getItem(storageKey);
  }
};
var getMapObject$1 = function getMapObject(storageKey) {
  try {
    var item = JSON.parse(getItem$1(storageKey));
    if (item && _typeof(item) === 'object' && !Array.isArray(item)) {
      return item;
    }
  } catch (_unused) {} // eslint-disable-line no-empty
};
var getItemFromMap = function getItemFromMap(storageKey, itemKey) {
  var map = getMapObject$1(storageKey);
  return map === null || map === void 0 ? void 0 : map[itemKey];
};

// TODO: move JSON.strigify to caller sites so getItem and setItem are symmetric
var setItem$1 = function setItem(storageKey, item) {
  if (isLocalStorageSupported()) {
    localStorage.setItem(storageKey, JSON.stringify(item));
  }
};
var setItemInMap$1 = function setItemInMap(storageKey, itemsMap) {
  var updatedMap = Object.assign({}, getMapObject$1(storageKey), itemsMap);
  setItem$1(storageKey, updatedMap);
};

/**
 * A light userData service stub to encapsulate persisted user data, assuming they accumulates over time
 * current implemented with localStorage and sessionStorage
 */
var userDataService = {
  persist: setItemInMap$1,
  getPersisted: getItemFromMap,
  getCurrentSession: getMapObject,
  // NOTE: update should be considered aysnc and allowed to fail, hence not blocking UI updates
  update: function update(storageKey, newAnswers) {
    setItemInMap(storageKey, newAnswers);
    setItemInMap$1(storageKey, newAnswers);
  }
};

// answers should be stored as a map of { <question.name>: <question.answer>, ...}
var store = {
  storageKey: undefined,
  answers: undefined,
  getAnswers: function getAnswers() {
    return store.answers;
  },
  setAnswers: function setAnswers() {},
  updateAnswers: function updateAnswers(newAnswers) {
    return store.setAnswers(Object.assign({}, store.answers, newAnswers));
  },
  /**
   * calculate what value should be shown in a question
   * order of precedence:
   *   1. Explicit answers entered by the end user in the questionnaire flow
   *   2. Trusted or known answers from context (eg. passed from URL query)
   *   3. Inferred or saved answers (eg. local/remote storage, or from last quote, or before browser refresh)
   */
  prepopulate: function prepopulate(key) {
    var _store$answers$key, _store$answers;
    return (_store$answers$key = store === null || store === void 0 ? void 0 : (_store$answers = store.answers) === null || _store$answers === void 0 ? void 0 : _store$answers[key]) !== null && _store$answers$key !== void 0 ? _store$answers$key : userDataService.getPersisted(store.storageKey, key);
  }
};

// A light React hook to trigger UI update at attached React component node
var useAnswersStore = function useAnswersStore(storageKey, initialAnswers) {
  var _useState = useState(function () {
      store.answers = initialAnswers;
      userDataService.update(storageKey, initialAnswers);
      store.storageKey = storageKey;
      store.setAnswers = function (newAnswers) {
        store.answers = newAnswers;
        userDataService.update(storageKey, newAnswers);
        setAnswers(newAnswers);
        return newAnswers;
      };
      return store.answers;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    answers = _useState2[0],
    setAnswers = _useState2[1];
  useEffect(function () {
    return function () {
      store.answers = undefined;
      store.setAnswers = function () {};
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    answers: answers,
    getAnswers: store.getAnswers,
    setAnswers: store.setAnswers,
    updateAnswers: store.updateAnswers,
    prepopulate: store.prepopulate
  };
};

var _YES_NO_OPTIONS, _NO_YES_OPTIONS;
var ENTRYNAME_CONNECT = 'connect';
var LOAN_TYPE_PURCHASE = 'purchase';
var LOAN_TYPE_REFINANCE = 'refinance';
var YES_NO_OPTIONS = (_YES_NO_OPTIONS = {}, _YES_NO_OPTIONS[true] = 'Yes', _YES_NO_OPTIONS[false] = 'No', _YES_NO_OPTIONS);
var NO_YES_OPTIONS = (_NO_YES_OPTIONS = {}, _NO_YES_OPTIONS[false] = 'No', _NO_YES_OPTIONS[true] = 'Yes', _NO_YES_OPTIONS);
var ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT = 'ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT';
var ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT_VARIANT = 'VARIANT';
var VERMONT_DISCLAIMER_LOCAL_STORAGE_KEY = 'acceptedZCQVermontDisclaimer';

var getTrackingLabel = function getTrackingLabel(asObject) {
  var _context$originalEntr, _context$originalEntr2, _context$entry, _context$entry$toUppe, _answers$loanType, _answers$needs;
  if (asObject === void 0) {
    asObject = false;
  }
  var context = getContext();
  var answers = store.getAnswers();
  var labelObject = {
    source: context.source,
    landingPage: context.landingPage,
    enteredAs: (_context$originalEntr = context.originalEntry) === null || _context$originalEntr === void 0 ? void 0 : (_context$originalEntr2 = _context$originalEntr.toUpperCase) === null || _context$originalEntr2 === void 0 ? void 0 : _context$originalEntr2.call(_context$originalEntr),
    currentFlow: (_context$entry = context.entry) === null || _context$entry === void 0 ? void 0 : (_context$entry$toUppe = _context$entry.toUpperCase) === null || _context$entry$toUppe === void 0 ? void 0 : _context$entry$toUppe.call(_context$entry),
    loanType: (_answers$loanType = answers.loanType) !== null && _answers$loanType !== void 0 ? _answers$loanType : null,
    needs: (_answers$needs = answers.needs) !== null && _answers$needs !== void 0 ? _answers$needs : null
  };
  return asObject ? labelObject : JSON.stringify(labelObject);
};

/**
 * Collections of functions to track various events.
 * Using @zillow/universal-analytics (UA) to collect data for ZG
 */
function trackPageView(_ref) {
  var questionConfig = _ref.questionConfig,
    value = _ref.value;
  trackEvent({
    category: 'Mortgages',
    action: "page view: " + questionConfig.eventLabel,
    label: getTrackingLabel()
  });
  if (questionConfig.name === 'loanType' && value) {
    trackEvent({
      category: 'Mortgages',
      action: "loan type prepopulated: " + value.toLowerCase(),
      label: getTrackingLabel()
    });
  }
}
var sendTrackEventOnSubmitLongForm = function sendTrackEventOnSubmitLongForm() {
  trackEvent({
    category: 'Mortgages',
    action: 'completed process',
    label: getTrackingLabel()
  });
  trackEvent({
    category: 'Mortgages',
    action: 'completed process userSessionId',
    label: API.userSessionId
  });
};

var MINIMUM_PERCENT_DOWN = 0.0;
var MINIMUM_HELOC_LOAN_AMOUNT = 25000;

/*
 * Client side config for Long Form config
 * TODO: move to getStaticProps to reduce network traffic
 *   which needs build pipeline to access prod API, or use SSR instead
 */
var fetchedRequirements;
var eligibilityRequirements = {
  get minimumAnnualIncome() {
    var _fetchedRequirements;
    return (_fetchedRequirements = fetchedRequirements) === null || _fetchedRequirements === void 0 ? void 0 : _fetchedRequirements.minimumAnnualIncome;
  },
  get minimumCreditScore() {
    var _fetchedRequirements2;
    return (_fetchedRequirements2 = fetchedRequirements) === null || _fetchedRequirements2 === void 0 ? void 0 : _fetchedRequirements2.minimumCreditScore;
  },
  get minimumLoanAmount() {
    var _fetchedRequirements3;
    return (_fetchedRequirements3 = fetchedRequirements) === null || _fetchedRequirements3 === void 0 ? void 0 : _fetchedRequirements3.minimumLoanAmount;
  },
  get minimumVALoanAmount() {
    var _fetchedRequirements4;
    return (_fetchedRequirements4 = fetchedRequirements) === null || _fetchedRequirements4 === void 0 ? void 0 : _fetchedRequirements4.minimumVALoanAmount;
  },
  get minimumHELOCLoanAmount() {
    var _fetchedRequirements$, _fetchedRequirements5;
    return (_fetchedRequirements$ = (_fetchedRequirements5 = fetchedRequirements) === null || _fetchedRequirements5 === void 0 ? void 0 : _fetchedRequirements5.minimumHELOCLoanAmount) !== null && _fetchedRequirements$ !== void 0 ? _fetchedRequirements$ : MINIMUM_HELOC_LOAN_AMOUNT;
  },
  get minimumDownPaymentPercent() {
    var _fetchedRequirements$2, _fetchedRequirements6;
    return (_fetchedRequirements$2 = (_fetchedRequirements6 = fetchedRequirements) === null || _fetchedRequirements6 === void 0 ? void 0 : _fetchedRequirements6.minimumDownPaymentPercent) !== null && _fetchedRequirements$2 !== void 0 ? _fetchedRequirements$2 : MINIMUM_PERCENT_DOWN;
  }
};
var initializeEligibilityRequirements = function initializeEligibilityRequirements() {
  return fetchedRequirements || API.MAX.POST({
    action: 'getLongFormEligibilityRequirements',
    input: {
      partnerId: API.partnerId
    }
  }).then(function (response) {
    fetchedRequirements = response;
  }).catch(function (error) {
    var _global$DD_RUM, _global$DD_RUM$addErr;
    (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addErr = _global$DD_RUM.addError) === null || _global$DD_RUM$addErr === void 0 ? void 0 : _global$DD_RUM$addErr.call(_global$DD_RUM, new Error('Could not get eligibility requirements'), {
      error: error,
      level: 'warn'
    });
  });
};

var jsonStableStringifyWithoutJsonify = function (obj, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var space = opts.space || '';
    if (typeof space === 'number') space = Array(space+1).join(' ');
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;
    var replacer = opts.replacer || function(key, value) { return value; };

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (parent, key, node, level) {
        var indent = space ? ('\n' + new Array(level + 1).join(space)) : '';
        var colonSeparator = space ? ': ' : ':';

        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        node = replacer.call(parent, key, node);

        if (node === undefined) {
            return;
        }
        if (typeof node !== 'object' || node === null) {
            return JSON.stringify(node);
        }
        if (isArray(node)) {
            var out = [];
            for (var i = 0; i < node.length; i++) {
                var item = stringify(node, i, node[i], level+1) || JSON.stringify(null);
                out.push(indent + space + item);
            }
            return '[' + out.join(',') + indent + ']';
        }
        else {
            if (seen.indexOf(node) !== -1) {
                if (cycles) return JSON.stringify('__cycle__');
                throw new TypeError('Converting circular structure to JSON');
            }
            else seen.push(node);

            var keys = objectKeys(node).sort(cmp && cmp(node));
            var out = [];
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var value = stringify(node, key, node[key], level+1);

                if(!value) continue;

                var keyValue = JSON.stringify(key)
                    + colonSeparator
                    + value;
                out.push(indent + space + keyValue);
            }
            seen.splice(seen.indexOf(node), 1);
            return '{' + out.join(',') + indent + '}';
        }
    })({ '': obj }, '', obj, 0);
};

var isArray = Array.isArray || function (x) {
    return {}.toString.call(x) === '[object Array]';
};

var objectKeys = Object.keys || function (obj) {
    var has = Object.prototype.hasOwnProperty || function () { return true };
    var keys = [];
    for (var key in obj) {
        if (has.call(obj, key)) keys.push(key);
    }
    return keys;
};

function hashString(string) {
  var hash = 0;
  if (string.length === 0) {
    return hash;
  }
  for (var i = 0; i < string.length; i++) {
    var character = string.charCodeAt(i);
    hash = (hash << 5) - hash + character;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}
function hashObject(object) {
  return hashString(jsonStableStringifyWithoutJsonify(object));
}

// TODO: ZGMIAIR-1195 - move this to route config in a more reliable way (eg route.required as a function to depend on context?)
// TODO: ZGMIAIR-1195 - also rethink about back and forward skipping logic
var PII_QUESTIONS_ROUTES = ['name', 'email', 'phoneNumber'];

/**
 * A stateful module independent of React
 * It delegates to browser History to support URL change
 * hence the API aligns with window.history to be more intuitive
 * Note: only URL hash is used so server side support is NOT needed in case of distribution
 * usage: first let router take over URL hash by calling router.init with routes schema and initial data from context
 */
var router = {
  schema: [],
  onChange: function onChange() {},
  skippedRouteNames: [],
  // route with answers in context is usually skipped, they never updates, and not validated (after init)
  /**
   * take over browser history with event listeners, should call router.cleanup when unmounted.
   * onChange - called whenever route is changed, inclucing browers back/forward button clicks.
   */
  init: function init(currentRoute, onChange, schema, skippedRouteNames) {
    if (skippedRouteNames === void 0) {
      skippedRouteNames = [];
    }
    router.schema = schema;
    router.skippedRouteNames = skippedRouteNames;
    router.onChange = onChange;
    window.addEventListener('popstate', onPopstateListener);
    if (history.scrollRestoration) {
      router.previousScrollRestoration = history.scrollRestoration;
      history.scrollRestoration = 'manual';
    }
    // TODO: ZGMIAIR-684: make sure SSR serves the base route (especialy /pre-qualify), and support deferred hydration
    // NOTE: setTimeout to delay replaceState after NextJS Client-Side-Rendersing takes over
    window.setTimeout(function () {
      window.history.replaceState({
        index: schema.indexOf(currentRoute)
      }, currentRoute.name,
      // normalize url hash, either #<routeName> or no hash
      currentRoute === schema[0] && currentRoute.name !== getTargetRouteName(schema) ? window.location.pathname + window.location.search : "#" + currentRoute.name);
    }, 500);
    return currentRoute;
  },
  cleanup: function cleanup() {
    window.removeEventListener('popstate', onPopstateListener);
    if (router.previousScrollRestoration) {
      history.scrollRestoration = router.previousScrollRestoration;
      router.previousScrollRestoration = undefined;
    }
  },
  /**
   * validate onNext handler for a giving route
   * @returns undefined if validation passed, or routeConfig when failed. (Which could navigate to a different (error) route in case of internal redirection on error)
   * if it @returns false, navigation should be canceled (waiting for external redirection)
   */
  validateAsync: function validateAsync(routeConfig, answers, context) {
    return new Promise(function ($return, $error) {
      var interceptedResponse;
      if (!routeConfig.onNext) {
        return $return();
      }
      return Promise.resolve(routeConfig.onNext({
        answers: answers,
        context: context
      })).then(function ($await_3) {
        try {
          interceptedResponse = $await_3;
          if (!(interceptedResponse !== null && interceptedResponse !== void 0 && interceptedResponse.path)) {
            return $return(interceptedResponse);
          }
          return $return(router.go(interceptedResponse.path, interceptedResponse));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  forward: function forward(_temp) {
    return new Promise(function ($return, $error) {
      var _window$history$state, _ref, _ref$answers, answers, _ref$context, context, routeName, index, _global$DD_RUM, _global$DD_RUM$addErr, currentQuestion, _global$DD_RUM2, _global$DD_RUM2$addEr, interceptedRoute, nextRouteIndex, interceptedNextRoute, nextRoute;
      _ref = _temp === void 0 ? {} : _temp, _ref$answers = _ref.answers, answers = _ref$answers === void 0 ? {} : _ref$answers, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context;
      routeName = window.location.hash.replace(/^#/, '') || router.schema[0].name;
      index = (_window$history$state = window.history.state) === null || _window$history$state === void 0 ? void 0 : _window$history$state.index;
      if (index === undefined || index === null) {
        (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addErr = _global$DD_RUM.addError) === null || _global$DD_RUM$addErr === void 0 ? void 0 : _global$DD_RUM$addErr.call(_global$DD_RUM, new Error('mortgage-questionnaire: route index not retrievable, looking up...'), {
          level: 'warn',
          routeName: routeName,
          answers: answers,
          context: getContext()
        });
        index = getRouteIndex(router.schema, routeName, answers);
      }
      currentQuestion = router.schema[index];
      // TODO: remove this safety net if no errors observed in production
      if (!currentQuestion) {
        (_global$DD_RUM2 = global.DD_RUM) === null || _global$DD_RUM2 === void 0 ? void 0 : (_global$DD_RUM2$addEr = _global$DD_RUM2.addError) === null || _global$DD_RUM2$addEr === void 0 ? void 0 : _global$DD_RUM2$addEr.call(_global$DD_RUM2, new Error('mortgage-questionnaire: onNext error'), {
          routeName: routeName,
          answers: _omit(answers, PII_QUESTIONS_ROUTES),
          context: getContext()
        });
        return $return(router.go('notFound', {
          reason: "Broken navigation, route name: " + routeName
        }));
      }
      return Promise.resolve(router.validateAsync(currentQuestion, answers, context)).then(function ($await_4) {
        try {
          {
            interceptedRoute = $await_4;
            if (interceptedRoute !== undefined) {
              return $return(interceptedRoute); // stay on current route or redirect to error route
            }
            nextRouteIndex = findNextIndex(router.schema, index, answers);
            var $Loop_1_trampoline;
            function $Loop_1() {
              if (router.skippedRouteNames.includes(router.schema[nextRouteIndex].name) && !PII_QUESTIONS_ROUTES.includes(router.schema[nextRouteIndex].name)) {
                return Promise.resolve(router.validateAsync(router.schema[nextRouteIndex], answers, context)).then(function ($await_5) {
                  try {
                    interceptedNextRoute = $await_5;
                    if (interceptedNextRoute !== undefined) {
                      return $return(interceptedRoute);
                    }
                    nextRouteIndex = findNextIndex(router.schema, nextRouteIndex, answers);
                    return $Loop_1;
                  } catch ($boundEx) {
                    return $error($boundEx);
                  }
                }, $error);
              } else return [1];
            }
            return ($Loop_1_trampoline = function (q) {
              while (q) {
                if (q.then) return void q.then($Loop_1_trampoline, $error);
                try {
                  if (q.pop) {
                    if (q.length) return q.pop() ? $Loop_1_exit.call(this) : q;else q = $Loop_1;
                  } else q = q.call(this);
                } catch (_exception) {
                  return $error(_exception);
                }
              }
            }.bind(this))($Loop_1);
            function $Loop_1_exit() {
              nextRoute = router.schema[nextRouteIndex];
              window.history.pushState({
                index: nextRouteIndex
              }, nextRoute.name, "#" + nextRoute.name);
              router.onChange(nextRoute);
              return $return(nextRoute);
            }
          }
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this), $error);
    });
  },
  back: function back() {
    window.history.back();
    return onPopstateListener();
  },
  // go forward by route name and state, contrary to history.go
  go: function go(routeName, routeState) {
    var nextRoute = router.schema.find(function (_ref2) {
      var name = _ref2.name;
      return name === routeName;
    });
    if (nextRoute) {
      window.history.pushState(Object.assign({}, routeState, {
        index: router.schema.indexOf(nextRoute)
      }), nextRoute.name, "#" + nextRoute.name);
      router.onChange(nextRoute);
    }
    return nextRoute;
  },
  startOver: function startOver(skippedRouteNames) {
    if (skippedRouteNames === void 0) {
      skippedRouteNames = [];
    }
    var firstRoute = router.schema[0];
    router.skippedRouteNames = skippedRouteNames;
    window.history.pushState({
      index: 0
    }, firstRoute.name);
    router.onChange(firstRoute);
    return firstRoute;
  }
};

/**
 * To find initial route when calling router.init, when loading the browser page.
 * Order of precedence:
 *   1. existing hash - if validation passes
 *   2. history.state, eg. refresh page or browser back/forward from different JS app
 *   3. derive from routes schema and context answers (eg. known location from URL query)
 */
function findInitialRoute(schema, initialAnswers, targetRouteName) {
  // Simulate user going down flow with initialAnswers
  // This will "restore" the context to whatever state it was in when the user last entered (asuuming all context changes are controlled via schema)
  for (var routeIndex = 0; routeIndex < schema.length; routeIndex++) {
    var routeConfig = schema[routeIndex];
    if (isPartOfFlow(schema, routeConfig, initialAnswers)) {
      // exit ternimal routes and handle with "back to results" page
      if (routeConfig.type === 'terminal') {
        return schema[0];
      }
      if (targetRouteName && routeConfig.name === targetRouteName) {
        return routeConfig;
      }
      var answer = initialAnswers[routeConfig.name];
      if (answer === undefined ||
      // TODO: ZGMIAIR-1208 ran actual validations (potentially asynchronously), and discard invalid context entries
      // this should not be done because current validation could redirect to Not Found cryptic error page
      // where "valid" is not defined
      routeConfig.validate && !routeConfig.validate({
        answers: initialAnswers
      })) {
        // If unanswered question was found before target, return schema[0] or if there was no target, return the last question in route
        return targetRouteName ? schema[0] : routeConfig;
      } else {
        var _ret = function (_routeConfig$onNext) {
          var interceptedRoute = (_routeConfig$onNext = routeConfig.onNext) === null || _routeConfig$onNext === void 0 ? void 0 : _routeConfig$onNext.call(routeConfig, {
            auto: true
          });
          if (interceptedRoute !== null && interceptedRoute !== void 0 && interceptedRoute.path) {
            routeIndex += schema.slice(routeIndex + 1).findIndex(function (_ref3) {
              var name = _ref3.name;
              return name === interceptedRoute.path;
            }) + 1;
          } else if (interceptedRoute === false) {
            return {
              v: targetRouteName ? schema[0] : routeConfig
            };
          }
        }();
        if (_typeof(_ret) === "object") return _ret.v;
      }
    }
  }
  return schema[0];
}
function findNextIndex(schema, currentRouteIndex, answers) {
  var immediateNextIndex = currentRouteIndex + 1;
  var nextRouteIndex = schema.slice(immediateNextIndex).findIndex(function (routeConfig) {
    return isPartOfFlow(schema, routeConfig, answers);
  }) + immediateNextIndex;
  return nextRouteIndex || schema.length - 1;
}

// NOTE: this won't reliably find duplicated route index, should only be used if history.index does not exist
function getRouteIndex(schema, routeName, answers) {
  if (!routeName) {
    return;
  }
  return schema.findIndex(function (routeConfig) {
    return routeConfig.name === routeName && isPartOfFlow(schema, routeConfig, answers);
  });
}

// basic logic to determing if a route should show, they may still be skipped by other means
function isPartOfFlow(schema, routeConfig, answers) {
  return !routeConfig.condition || routeConfig.condition({
    schema: schema,
    answers: answers
  });
}
function onPopstateListener() {
  var _window$history$state2;
  var routeConfig = router.schema[(_window$history$state2 = window.history.state) === null || _window$history$state2 === void 0 ? void 0 : _window$history$state2.index];
  var hashStateName = window.location.hash.replace(/^#/, '') || router.schema[0].name;
  // all route history state should have been managed, rejecting unknown hash
  if (routeConfig && routeConfig.name === hashStateName) {
    router.onChange(routeConfig);
    return routeConfig;
  }
  // NOTE: This only happens when user manually typing the URL. Reloading the page to discouraged the behavior
  window.location.reload();
}

/**
 * Wire up the router changes with React
 * by calling React set state functions during onpopstate events
 */
var useRouter = function useRouter(schema, targetRouteName, skippedRouteNames, initialAnswers) {
  if (skippedRouteNames === void 0) {
    skippedRouteNames = [];
  }
  if (initialAnswers === void 0) {
    initialAnswers = {};
  }
  var _useState = useState(function () {
      var initialRoute = findInitialRoute(schema, initialAnswers, targetRouteName);
      return initialRoute;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    currentQuestion = _useState2[0],
    setCurrentQuestion = _useState2[1];
  // leverage useState to trigger react update from router update;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmitted = _useState4[0],
    updateIsSubmitted = _useState4[1];
  useEffect(function () {
    router.init(currentQuestion, setCurrentQuestion, schema, skippedRouteNames);
    return function () {
      return router.cleanup();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // isLanding is used for removes landing specific styling, which should be excludes targeted 1st route
  var isLanding = currentQuestion.name === schema[0].name && currentQuestion.name !== targetRouteName;
  var goNext = useCallback(function (contextAndAnswers) {
    var nextRoute = router.forward(contextAndAnswers);
    if (nextRoute.name === schema[schema.length - 1]) {
      updateIsSubmitted(true);
    }
    return nextRoute;
  }, [schema]);
  var goBack = router.back;
  var startOver = router.startOver;
  return {
    currentQuestion: currentQuestion,
    isLanding: isLanding,
    submitted: isSubmitted,
    goNext: goNext,
    goBack: goBack,
    startOver: startOver
  };
};
var serverSideStub = function serverSideStub(schema) {
  return [schema[0], function () {}];
};
var useRouter$1 = typeof window === 'undefined' ? serverSideStub : useRouter;

/**
 * An enumeration of credit score ranges.
 */
var CREDIT_SCORE_CQ_OPTIONS = {
  R_760_: '760 and above',
  R_740_759: '740-759',
  R_720_739: '720-739',
  R_700_719: '700-719',
  R_680_699: '680-699',
  R_660_679: '660-679',
  R_640_659: '640-659',
  R_620_639: '620-639',
  R_600_619: '600-619',
  R_560_599: '560-599',
  R_300_559: '300-559'
};
var CREDIT_SCORE_CONNECT_OPTIONS = {
  R_720_850: 'Excellent (720 and above)',
  R_660_719: 'Good (660-719)',
  R_620_659: 'Average (620-659)',
  R_580_619: 'Poor (580-619)',
  R_300_579: 'Bad (579 or below)'
};
var CREDIT_SCORE_CONNECT_OPTIONS_VALUES = {
  R_720_850: {
    creditScoreLow: 720,
    creditScoreHigh: 850
  },
  R_660_719: {
    creditScoreLow: 660,
    creditScoreHigh: 719
  },
  R_620_659: {
    creditScoreLow: 620,
    creditScoreHigh: 659
  },
  R_580_619: {
    creditScoreLow: 580,
    creditScoreHigh: 619
  },
  R_300_579: {
    creditScoreLow: 300,
    creditScoreHigh: 579
  }
};
var CREDIT_SCORE_LOW_FOR_CONNECT = {
  '720': 'R_720_739',
  '660': 'R_660_679',
  '620': 'R_620_639',
  '580': 'R_560_599',
  '300': 'R_300_559'
};

var getContactContext = function getContactContext(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    source = _ref.source,
    landingPage = _ref.landingPage;
  var contactContext = ['ZillowLongForm', 'Landing=' + landingPage];
  if (source) {
    contactContext.push("Source=" + source);
  }
  abtest.getActiveExperiments().forEach(function (experiment) {
    contactContext.push(experiment.name + '=' + experiment.treatment);
  });
  return contactContext.join(';');
};

// ported from /src/long-form/redux/lenders.js
// TODO: unify Connect and CQ input
var mapLongFormInput = function mapLongFormInput(answers, context) {
  return new Promise(function ($return, $error) {
    var _answers$location, _await$API$MAX$GET$ca, _await$API$MAX$GET$ca2, regionId, result;
    return Promise.resolve(new Promise(function ($return, $error) {
      var $logicalOr_1;
      if (!($logicalOr_1 = (_answers$location = answers.location) === null || _answers$location === void 0 ? void 0 : _answers$location.regionId)) {
        return Promise.resolve(API.MAX.GET({
          action: 'getRegionInformation',
          input: {
            partnerId: API.partnerId,
            locationRef: {
              location: answers.location.name
            }
          }
        }).catch(function () {})).then(function ($await_3) {
          try {
            $logicalOr_1 = // TODO: ZGMIAIR-1106 move this to schema and execute during getTrustedAnswers
            (_await$API$MAX$GET$ca = $await_3) === null || _await$API$MAX$GET$ca === void 0 ? void 0 : (_await$API$MAX$GET$ca2 = _await$API$MAX$GET$ca.location) === null || _await$API$MAX$GET$ca2 === void 0 ? void 0 : _await$API$MAX$GET$ca2.regionId;
            return $If_2.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }
      function $If_2() {
        return $return($logicalOr_1);
      }
      return $If_2.call(this);
    })).then(function ($await_4) {
      try {
        regionId = $await_4;
        result = {
          partnerId: API.partnerId,
          location: {
            regionId: regionId
          },
          creditScore: answers.creditScore,
          propertyType: answers.propertyType,
          propertyUse: answers.propertyUsage,
          propertyValue: answers.propertyValue,
          vaEligible: !!answers.vaEligible && answers.propertyUsage === 'Primary' && answers.loanType !== 'heloc',
          selfEmployed: answers.selfEmployed,
          annualIncome: answers.income,
          hasBankruptcy: answers.creditHistory,
          needs: answers.needs,
          context: getContactContext(context)
        };
        if (answers.language && answers.language !== 'Other') {
          result.preferredLanguage = answers.language;
        }
        if (answers.loanType === 'purchase') {
          result.journeyStage = answers.journeyStage;
          result.sellingHome = answers.selling;
          result.homeOwner = answers.homeOwner;
          result.details = {
            purchase: {
              downPayment: answers.downPayment,
              firstTimeBuyer: answers.firstTime,
              hasAgent: answers.hasAgent
            }
          };
        } else if (answers.loanType === 'refinance') {
          result.details = {
            refinance: {
              currentBalance: answers.loanBalance,
              wantsCashOut: answers.cashOut,
              hasSecondMortgage: answers.secondMortgage
            }
          };
        } else if (answers.loanType === 'heloc') {
          result.details = {
            heloc: {
              currentBalance: answers.loanBalance,
              loanAmount: answers.helocAmount,
              hasSecondMortgage: answers.secondMortgage
            }
          };
        }
        return $return(result);
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
};

// ported from /src/custom-quotes/landing/js/autoRequest.js
var mapLongTableInput = function mapLongTableInput(answers) {
  var _answers$location2, _answers$location3, _ref2, _ref2$replace, _ref2$replace$replace, _answers$creditScore;
  // NOTE: CQ quote page treats heloc as refinance
  var isPurchase = answers.loanType === 'purchase';
  var params = {
    auto: true,
    loantype: answers.loanType,
    zip: ((_answers$location2 = answers.location) === null || _answers$location2 === void 0 ? void 0 : _answers$location2.zipCode) || ((_answers$location3 = answers.location) === null || _answers$location3 === void 0 ? void 0 : _answers$location3.name),
    value: answers.propertyValue,
    // TODO: unify Connect and CQ input
    // Check what's inside creditScore key, and if we need to do conversion
    cscore: (_ref2 = answers !== null && answers !== void 0 && (_answers$creditScore = answers.creditScore) !== null && _answers$creditScore !== void 0 && _answers$creditScore.creditScoreLow ? CREDIT_SCORE_LOW_FOR_CONNECT[answers.creditScore.creditScoreLow] : answers.creditScore) === null || _ref2 === void 0 ? void 0 : (_ref2$replace = _ref2.replace('R_', '')) === null || _ref2$replace === void 0 ? void 0 : (_ref2$replace$replace = _ref2$replace.replace('_', '-')) === null || _ref2$replace$replace === void 0 ? void 0 : _ref2$replace$replace.replace('760-', '760+'),
    va: answers.vaEligible,
    type: answers.propertyType || 'SingleFamilyHome',
    use: answers.propertyUsage || 'Primary'
  };
  if (isPurchase) {
    params.down = answers.downPayment;
  } else {
    if (answers.cashOut) {
      params.cashOut = answers.helocAmount;
    }
    params.currentbalance = answers.loanBalance;
  }
  return params;
};

var lastAnswersHash;
var lastContactPossible;
var getLongFormContactPossible = function getLongFormContactPossible(answers, context) {
  return new Promise(function ($return, $error) {
    var newHash, input, _await$API$MAX$POST$t, longFormContactPossible, affiliateDibs, longFormMissedOpportunityID, primaryLender, _global$DD_RUM2, _global$DD_RUM2$addEr, contactPossible;
    newHash = hashObject(_omit(answers, PII_QUESTIONS_ROUTES));
    if ((context === null || context === void 0 ? void 0 : context.entry) !== 'connect') {
      return $return({});
    }
    if (lastAnswersHash && lastAnswersHash === newHash) {
      return $return(lastContactPossible);
    }
    return Promise.resolve(mapLongFormInput(answers, context)).then(function ($await_1) {
      try {
        input = $await_1;
        input.allowAffiliateDibs = !context.disallowAffiliate;
        return Promise.resolve(API.MAX.POST({
          action: 'getLongFormContactPossible',
          input: input,
          timeout: 300000
        }).then(function (response) {
          return response || {};
        }).catch(function (error) {
          var _global$DD_RUM, _global$DD_RUM$addErr;
          (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addErr = _global$DD_RUM.addError) === null || _global$DD_RUM$addErr === void 0 ? void 0 : _global$DD_RUM$addErr.call(_global$DD_RUM, error, {
            action: 'getLongFormContactPossible',
            answers: _omit(answers, PII_QUESTIONS_ROUTES),
            input: input
          });
          throw new Error('Error! Failed to request getLongFormContactPossible', {
            cause: error
          });
        })).then(function ($await_2) {
          try {
            _await$API$MAX$POST$t = $await_2, longFormContactPossible = _await$API$MAX$POST$t.longFormContactPossible, affiliateDibs = _await$API$MAX$POST$t.affiliateDibs, longFormMissedOpportunityID = _await$API$MAX$POST$t.longFormMissedOpportunityID, primaryLender = _await$API$MAX$POST$t.primaryLender;
            if (longFormMissedOpportunityID) {
              trackEvent({
                category: 'Mortgages',
                action: "failure reason: getLongFormContactPossible, longFormMissedOpportunityID: " + longFormMissedOpportunityID,
                label: getTrackingLabel()
              });
              (_global$DD_RUM2 = global.DD_RUM) === null || _global$DD_RUM2 === void 0 ? void 0 : (_global$DD_RUM2$addEr = _global$DD_RUM2.addError) === null || _global$DD_RUM2$addEr === void 0 ? void 0 : _global$DD_RUM2$addEr.call(_global$DD_RUM2, new Error('mortgage-questionnaire opportunity missed with getLongFormContactPossible'), {
                action: 'opportunity missed with getLongFormContactPossible',
                answers: _omit(answers, PII_QUESTIONS_ROUTES),
                longFormMissedOpportunityID: longFormMissedOpportunityID
              });
            }
            lastAnswersHash = newHash;
            contactPossible = {
              longFormContactPossible: longFormContactPossible,
              affiliateDibs: affiliateDibs,
              longFormMissedOpportunityID: longFormMissedOpportunityID,
              primaryLender: primaryLender
            };
            lastContactPossible = contactPossible;
            return $return(contactPossible);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
};

var TEST_URL_AUTOCOMPLETE = 'https://static.qa.zillow.net/autocomplete/v3/suggestions';
var PROD_URL_AUTOCOMPLETE = 'https://www.zillowstatic.com/autocomplete/v3/suggestions';
var DOLLARS_MAX = 200000000;
var HOME_PRICE_MIN = 5000;
var INCOME_MAX = 10000000;
var LOAN_BALANCE_MIN = 1000;
var PHONENUMBER_QUESTION_TEXT = "What's the best number to reach you?";
var PHONENUMBER_CTA_TEXT = 'Contact a lender';
var VA_QUESTION_TEXT = 'Are you (or your spouse) a veteran or active military?';
var INVALID_DATA = 'INVALID DATA';
var INVALID_CONTACT_ERRORS = ['IneligibleForLongForm', 'InvalidEmailAddress', 'InvalidPhoneNumber'];

var _ctaDestinationToTopi;
var CONNECT_FORM_VERSION = '1';
var CQ_FORM_VERSION = '1';
var TRIGGER_LOCATION = {
  LANDING: 'landing',
  SUBMIT: 'submit'
};
var CONNECT_LANDING_PAGES = ['heloc', 'va', 'purchase', 'refinance', 'pre-qualify', 'pre-approval', 'generic'];
var selectConnectTriggerLocation = function selectConnectTriggerLocation(page, location) {
  if (CONNECT_LANDING_PAGES.includes(page)) {
    return "connect_" + location + "|" + page;
  }

  // eslint-disable-next-line no-console
  console.warn("Connect Trigger Location not found. Unknown page: '" + page + "'");
  return null;
};
var selectCQTriggerLocation = function selectCQTriggerLocation(page, location) {
  if (page.startsWith('refinance')) {
    return "cq_" + location + "|refinance";
  } else if (page.startsWith('mortgage-rates')) {
    return "cq_" + location + "|mortgage_rates";
  } else {
    // eslint-disable-next-line no-console
    console.warn("CQ Trigger Location not found. Unknown page: '" + page + "'");
    return null;
  }
};
var now = function now() {
  return new Date().toISOString();
};
var getDownPaymentPercent = function getDownPaymentPercent(answers) {
  if ((answers === null || answers === void 0 ? void 0 : answers.downPayment) >= 0 && (answers === null || answers === void 0 ? void 0 : answers.propertyValue) > 0 && (answers === null || answers === void 0 ? void 0 : answers.downPayment) < (answers === null || answers === void 0 ? void 0 : answers.propertyValue)) {
    return Math.round(answers.downPayment / answers.propertyValue * 1000) / 10;
  }
};
var creditRangeMapping = function creditRangeMapping(creditScore) {
  for (var key in CREDIT_SCORE_CONNECT_OPTIONS_VALUES) {
    if (CREDIT_SCORE_CONNECT_OPTIONS_VALUES[key].creditScoreLow === (creditScore === null || creditScore === void 0 ? void 0 : creditScore.creditScoreLow)) {
      return key;
    }
  }
  return;
};
var getConnectFunnelBlock = function getConnectFunnelBlock(answers, landingPage, zgmiContactId, numLenderMatches, longFormMissedOpportunityID) {
  var _answers$location, _answers$location2, _answers$location3, _answers$location4;
  return {
    connect_version_txt: landingPage,
    zip_code_txt: (_answers$location = answers.location) === null || _answers$location === void 0 ? void 0 : _answers$location.zipCode,
    state_txt: (_answers$location2 = answers.location) === null || _answers$location2 === void 0 ? void 0 : _answers$location2.state,
    city_txt: (_answers$location3 = answers.location) === null || _answers$location3 === void 0 ? void 0 : _answers$location3.city,
    county_txt: (_answers$location4 = answers.location) === null || _answers$location4 === void 0 ? void 0 : _answers$location4.county,
    loan_type_txt: answers === null || answers === void 0 ? void 0 : answers.loanType,
    first_time_ind: answers === null || answers === void 0 ? void 0 : answers.firstTime,
    home_owner_ind: answers === null || answers === void 0 ? void 0 : answers.homeOwner,
    selling_ind: answers === null || answers === void 0 ? void 0 : answers.selling,
    journey_stage_txt: answers === null || answers === void 0 ? void 0 : answers.journeyStage,
    property_type_txt: answers === null || answers === void 0 ? void 0 : answers.propertyType,
    property_usage_txt: answers === null || answers === void 0 ? void 0 : answers.propertyUsage,
    va_eligible_ind: answers === null || answers === void 0 ? void 0 : answers.vaEligible,
    property_value_amt: answers === null || answers === void 0 ? void 0 : answers.propertyValue,
    down_payment_amt: answers === null || answers === void 0 ? void 0 : answers.downPayment,
    down_payment_pct: getDownPaymentPercent(answers),
    income_amt: answers === null || answers === void 0 ? void 0 : answers.income,
    self_reported_credit_txt: creditRangeMapping(answers === null || answers === void 0 ? void 0 : answers.creditScore),
    self_employed_ind: answers === null || answers === void 0 ? void 0 : answers.selfEmployed,
    credit_history_ind: answers === null || answers === void 0 ? void 0 : answers.creditHistory,
    has_agent_ind: answers === null || answers === void 0 ? void 0 : answers.hasAgent,
    need_agent_ind: answers === null || answers === void 0 ? void 0 : answers.needAgent,
    language_txt: answers === null || answers === void 0 ? void 0 : answers.language,
    loan_balance_amt: answers === null || answers === void 0 ? void 0 : answers.loanBalance,
    second_mortgage_ind: answers === null || answers === void 0 ? void 0 : answers.secondMortgage,
    cash_out_ind: answers === null || answers === void 0 ? void 0 : answers.cashOut,
    heloc_amt: answers === null || answers === void 0 ? void 0 : answers.helocAmount,
    vermont_agreed_ind: answers === null || answers === void 0 ? void 0 : answers.vermontAgreed,
    zgmi_contact_id: zgmiContactId,
    zgmi_missed_opportunity_id: longFormMissedOpportunityID,
    lender_matches_nb: numLenderMatches
  };
};
var urlPathToLocationMap = {
  location: 'zgmi_connect_location',
  loanType: 'zgmi_connect_loantype',
  firstTime: 'zgmi_connect_firsttime',
  homeOwner: 'zgmi_connect_homeowner',
  hasAgent: 'zgmi_connect_hasagent',
  needAgent: 'zgmi_connect_needagent',
  journeyStage: 'zgmi_connect_journey',
  propertyType: 'zgmi_connect_propertytype',
  propertyValue: 'zgmi_connect_propertyvalue',
  propertyUsage: 'zgmi_connect_propertyusage',
  vaEligible: 'zgmi_connect_vaeligible',
  downPayment: 'zgmi_connect_downpayment',
  income: 'zgmi_connect_income',
  creditScore: 'zgmi_connect_creditscore',
  selfEmployed: 'zgmi_connect_selfemployed',
  creditHistory: 'zgmi_connect_credithistory',
  language: 'zgmi_connect_language',
  name: 'zgmi_connect_name',
  email: 'zgmi_connect_email',
  phoneNumber: 'zgmi_connect_phonenumber',
  secondMortgage: 'zgmi_connect_secondmortgage',
  cashOut: 'zgmi_connect_cashout',
  loanBalance: 'zgmi_connect_loanbalance',
  selling: 'zgmi_connect_selling',
  helocAmount: 'zgmi_connect_helocamount',
  vermontAgreed: 'zgmi_connect_vermontagreed'
};
var questionHasNextButtonMap = {
  location: true,
  propertyValue: true,
  downPayment: true,
  income: true,
  name: true,
  email: true,
  phoneNumber: true,
  final: true,
  loanBalance: true,
  helocAmount: true
};

/**
 * Event docs: https://docs.google.com/spreadsheets/d/1WiBhWo32QDvpEMhY1rLt7lZVGhVxBX-aBZqiHQfp8oQ/view
 */

/** Connect Events */

/** connect leadStart */
var generateConnectLeadStartEvent = function generateConnectLeadStartEvent(page, questionText, buttonsText) {
  var newLaneEvent = {
    envelope: {
      event_template_id: '38',
      event_template_version_id: '1',
      event_type_id: '639',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: selectConnectTriggerLocation(page, TRIGGER_LOCATION.LANDING),
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'begin_form_component',
      trigger_source_nm: 'button_to_get_started',
      input_selector_nm: 'mouse'
    },
    semantic: {
      semantic_event_nm: 'zgmi_form_start',
      topic_tag_txt: ['prequalify']
    },
    zgmi_form: {
      form_question_txt: questionText,
      displayed_button_txt: buttonsText,
      version_nb: CONNECT_FORM_VERSION
    }
  };
  return newLaneEvent;
};

/** connect leadSubmit */
var generateConnectLeadSubmitEvent = function generateConnectLeadSubmitEvent(page) {
  return {
    envelope: {
      event_template_id: '38',
      event_template_version_id: '1',
      event_type_id: '640',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: selectConnectTriggerLocation(page, TRIGGER_LOCATION.SUBMIT),
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'submit_form_component',
      trigger_source_nm: 'button_to_complete_form',
      input_selector_nm: 'mouse'
    },
    semantic: {
      semantic_event_nm: 'zgmi_form_complete',
      topic_tag_txt: ['prequalify']
    },
    zgmi_form: {
      form_question_txt: PHONENUMBER_QUESTION_TEXT,
      displayed_button_txt: [PHONENUMBER_CTA_TEXT],
      version_nb: CONNECT_FORM_VERSION
    }
  };
};

/**  no lender found page */
var generateConnectNoLenderEvent = function generateConnectNoLenderEvent() {
  return {
    envelope: {
      event_template_id: '37',
      event_template_version_id: '1',
      event_type_id: '641',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: 'connect|no_lender_found',
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'connect|no_lender_found',
      input_selector_nm: 'mouse'
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['prequalify']
    }
  };
};

// /** connect generateSubmitZgmiConnectQuestionPageEvent */
var generateSubmitZgmiConnectQuestionPageEvent = function generateSubmitZgmiConnectQuestionPageEvent(currentQuestion, answers, landingPage, lenderContactId, numLenderMatches) {
  var newLaneEvent = {
    envelope: {
      event_template_id: '153',
      event_template_version_id: '1',
      event_type_id: '2181',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: 'zgmi_connect_funnel',
      trigger_type_nm: 'interaction',
      trigger_object_nm: urlPathToLocationMap[currentQuestion],
      trigger_source_nm: questionHasNextButtonMap[currentQuestion] ? 'zgmi_connect_next_button' : 'zgmi_connect_answer_button'
    },
    semantic: {
      semantic_event_nm: 'zgmi_connect_submit',
      topic_tag_txt: ['zgmi', 'zgmi_connect']
    },
    zgmi_connect_funnel: getConnectFunnelBlock(answers, landingPage, lenderContactId, numLenderMatches)
  };
  return newLaneEvent;
};
var generateZgmiConnectQuestionViewEvent = function generateZgmiConnectQuestionViewEvent(currentQuestion, answers, landingPage, lenderContactId, numLenderMatches) {
  if (urlPathToLocationMap[currentQuestion] !== undefined) {
    var newLaneEvent = {
      envelope: {
        event_template_id: '153',
        event_template_version_id: '1',
        event_type_id: '2177',
        event_type_version_id: '1',
        event_client_start_dtm: now()
      },
      clickstream_trigger: {
        trigger_location_nm: 'zgmi_connect_funnel',
        trigger_type_nm: 'impression',
        trigger_object_nm: 'no_trigger_object',
        trigger_source_nm: urlPathToLocationMap[currentQuestion]
      },
      semantic: {
        semantic_event_nm: 'view_content',
        topic_tag_txt: ['zgmi', 'zgmi_connect']
      },
      zgmi_connect_funnel: getConnectFunnelBlock(answers, landingPage, lenderContactId, numLenderMatches)
    };
    return newLaneEvent;
  }
};
var generateAbadModalViewEvent = function generateAbadModalViewEvent(abadContent, abadVersion, isPAABADModal) {
  var newLaneEvent = {
    envelope: {
      event_template_id: '131',
      event_template_version_id: '1',
      event_type_id: '2143',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: 'zgmi_connect_funnel',
      trigger_type_nm: 'impression',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'abad'
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zgmi', 'zhl']
    },
    abad_info: {
      abad_context_txt: abadContent,
      abad_version_txt: abadVersion,
      abad_close_button_txt: isPAABADModal ? 'Close' : 'See your results'
    }
  };
  return newLaneEvent;
};

/** END Connect Events */

/** CQ Events */

/** cq leadStart */
var generateCQLeadStartEvent = function generateCQLeadStartEvent(page, questionText, buttonsText) {
  var newLaneEvent = {
    envelope: {
      event_template_id: '38',
      event_template_version_id: '1',
      event_type_id: '663',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: selectCQTriggerLocation(page, TRIGGER_LOCATION.LANDING),
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'begin_form_component',
      trigger_source_nm: 'button_to_get_started',
      input_selector_nm: 'mouse'
    },
    semantic: {
      semantic_event_nm: 'zgmi_form_start',
      topic_tag_txt: ['prequalify']
    },
    zgmi_form: {
      form_question_txt: questionText,
      displayed_button_txt: buttonsText,
      version_nb: CQ_FORM_VERSION
    }
  };
  return newLaneEvent;
};

/** cq leadSubmit */
var generateCQLeadSubmitEvent = function generateCQLeadSubmitEvent(page) {
  var newLaneEvent = {
    envelope: {
      event_template_id: '38',
      event_template_version_id: '1',
      event_type_id: '664',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: selectCQTriggerLocation(page, TRIGGER_LOCATION.SUBMIT),
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'submit_form_component',
      trigger_source_nm: 'button_to_complete_form',
      input_selector_nm: 'mouse'
    },
    semantic: {
      semantic_event_nm: 'zgmi_form_complete',
      topic_tag_txt: ['prequalify']
    },
    zgmi_form: {
      form_question_txt: VA_QUESTION_TEXT,
      displayed_button_txt: Object.values(NO_YES_OPTIONS),
      version_nb: CQ_FORM_VERSION
    }
  };
  return newLaneEvent;
};

/** P3 Events */
var EVENT_TRIGGER = {
  mortgagesLanding: 'mortgages_landing',
  mortgagesLandingHero: 'mortgages_landing_hero',
  mortgageRatesHero: 'mortgage_rates_hero',
  cqLanding: 'zgmi_cq_landing',
  cqFunnel: 'zgmi_cq_funnel',
  loanType: 'zgmi_cq_loantype',
  propertyValue: 'zgmi_cq_propertyvalue',
  downPayment: 'zgmi_cq_downpayment',
  creditScore: 'zgmi_cq_creditscore',
  vaEligible: 'zgmi_cq_vaeligible',
  loanBalance: 'zgmi_cq_loanbalance',
  vermontAgreed: 'zgmi_cq_vermontagreed',
  answerButton: 'zgmi_cq_answer_button',
  nextButton: 'zgmi_cq_next_button',
  resultsRefreshButton: 'cq_results_refresh_button',
  noTriggerObject: 'no_trigger_object'
};
var TRIGGER_TYPE = {
  interaction: 'interaction',
  view: 'view',
  impression: 'impression'
};
var pathBasedProperties = function pathBasedProperties(path) {
  if (path.startsWith('/mortgages/')) {
    return {
      location: EVENT_TRIGGER.mortgagesLanding,
      destination: 'ZGMI Connect',
      source: EVENT_TRIGGER.mortgagesLandingHero
    };
  } else if (path.startsWith('/mortgage-rates/') || path.startsWith('/refinance/')) {
    return {
      location: EVENT_TRIGGER.cqLanding,
      destination: 'ZGMI CQ',
      source: EVENT_TRIGGER.mortgageRatesHero
    };
  } else {
    return {};
  }
};
var CTA_DESTINATION = {
  zgmi: 'ZGMI Connect, ZGMI CQ',
  connect: 'ZGMI Connect',
  cq: 'ZGMI CQ',
  zhlPurchase: 'ZHL Purchase',
  zhlRefi: 'ZHL Refi'
};
var ctaDestinationToTopicTagsMap = (_ctaDestinationToTopi = {}, _ctaDestinationToTopi[CTA_DESTINATION.connect] = ['zgmi', 'zgmi_connect'], _ctaDestinationToTopi[CTA_DESTINATION.cq] = ['zgmi', 'zgmi_cq'], _ctaDestinationToTopi[CTA_DESTINATION.zhlPurchase] = ['zhl', 'zhl_purchase'], _ctaDestinationToTopi[CTA_DESTINATION.zhlRefi] = ['zhl', 'zhl_refi'], _ctaDestinationToTopi[CTA_DESTINATION.zgmi] = ['zgmi', 'zgmi_connect', 'zgmi_cq'], _ctaDestinationToTopi);
var CQ_BUTTON = {
  answer: 'zgmi_cq_answer_button',
  next: 'zgmi_cq_next_button'
};
var cqQuestionToTriggerMap = {
  loanType: {
    trigger: EVENT_TRIGGER.loanType,
    button: CQ_BUTTON.answer
  },
  propertyValue: {
    trigger: EVENT_TRIGGER.propertyValue,
    button: CQ_BUTTON.next
  },
  downPayment: {
    trigger: EVENT_TRIGGER.downPayment,
    button: CQ_BUTTON.next
  },
  loanBalance: {
    trigger: EVENT_TRIGGER.loanBalance,
    button: CQ_BUTTON.next
  },
  creditScore: {
    trigger: EVENT_TRIGGER.creditScore,
    button: CQ_BUTTON.next
  },
  vaEligible: {
    trigger: EVENT_TRIGGER.vaEligible,
    button: CQ_BUTTON.answer
  }
};
var generateConnectLandingEvent = function generateConnectLandingEvent() {
  return {
    envelope: {
      event_template_id: '37',
      event_template_version_id: '1',
      event_type_id: '2096',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: EVENT_TRIGGER.mortgagesLanding,
      trigger_type_nm: TRIGGER_TYPE.view,
      trigger_object_nm: EVENT_TRIGGER.noTriggerObject,
      trigger_source_nm: EVENT_TRIGGER.mortgagesLanding
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zgmi_connect', 'zgmi']
    }
  };
};
var generateMortgageFunnelCTAViewEvent = function generateMortgageFunnelCTAViewEvent(path, ctaText) {
  var eventProperties = pathBasedProperties(path);
  return {
    envelope: {
      event_template_id: '155',
      event_template_version_id: '1',
      event_type_id: '2153',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties.location,
      trigger_type_nm: TRIGGER_TYPE.impression,
      trigger_object_nm: EVENT_TRIGGER.noTriggerObject,
      trigger_source_nm: eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties.source
    },
    financing_cta: {
      language_on_cta_txt: ctaText,
      cta_destination_txt: eventProperties.destination
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ctaDestinationToTopicTagsMap[eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties.destination]
    }
  };
};
var generateMortgageFunnelCTAClickEvent = function generateMortgageFunnelCTAClickEvent(path, ctaText) {
  var eventProperties = pathBasedProperties(path);
  return {
    envelope: {
      event_template_id: '155',
      event_template_version_id: '1',
      event_type_id: '2173',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties.location,
      trigger_type_nm: TRIGGER_TYPE.interaction,
      trigger_object_nm: eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties.source,
      trigger_source_nm: 'finance_cta'
    },
    financing_cta: {
      language_on_cta_txt: ctaText,
      cta_destination_txt: eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties.destination
    },
    semantic: {
      semantic_event_nm: 'finance_cta_click',
      topic_tag_txt: ctaDestinationToTopicTagsMap[eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties.destination]
    }
  };
};
var generateCQLandingPageViewEvent = function generateCQLandingPageViewEvent(path) {
  var eventProperties = pathBasedProperties(path);
  return {
    envelope: {
      event_template_id: '37',
      event_template_version_id: '1',
      event_type_id: '2180',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties.location,
      trigger_type_nm: TRIGGER_TYPE.view,
      trigger_object_nm: EVENT_TRIGGER.noTriggerObject,
      trigger_source_nm: EVENT_TRIGGER.cqLanding
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ctaDestinationToTopicTagsMap[eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties.destination]
    }
  };
};
var getCQContextualBlock = function getCQContextualBlock(answers) {
  var _answers$location5, _answers$location6, _answers$location7, _answers$location8, _answers$location9;
  return answers ? {
    zgmi_cq_funnel: {
      loan_type_txt: answers.loanType,
      property_value_txt: answers.propertyValue,
      city_txt: (_answers$location5 = answers.location) === null || _answers$location5 === void 0 ? void 0 : _answers$location5.city,
      county_txt: (_answers$location6 = answers.location) === null || _answers$location6 === void 0 ? void 0 : _answers$location6.county,
      city_or_zip_txt: (_answers$location7 = answers.location) === null || _answers$location7 === void 0 ? void 0 : _answers$location7.name,
      state_txt: (_answers$location8 = answers.location) === null || _answers$location8 === void 0 ? void 0 : _answers$location8.state,
      zip_code_txt: (_answers$location9 = answers.location) === null || _answers$location9 === void 0 ? void 0 : _answers$location9.zipCode,
      loan_balance_amt: answers.loanBalance,
      self_reported_credit_txt: answers.creditScore,
      down_payment_amt: answers.downPayment,
      down_payment_pct: answers.downPaymentPercent,
      first_time_ind: answers.firstTime,
      va_eligible_ind: answers.vaEligible,
      vermont_agreed_ind: answers.vermontAgreed
    }
  } : null;
};
var generateCQViewQuestionEvent = function generateCQViewQuestionEvent(question, answers) {
  var _cqQuestionToTriggerM;
  return Object.assign({
    envelope: {
      event_template_id: '149',
      event_template_version_id: '1',
      event_type_id: '2144',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: EVENT_TRIGGER.cqFunnel,
      trigger_type_nm: TRIGGER_TYPE.impression,
      trigger_object_nm: EVENT_TRIGGER.noTriggerObject,
      trigger_source_nm: (_cqQuestionToTriggerM = cqQuestionToTriggerMap[question]) === null || _cqQuestionToTriggerM === void 0 ? void 0 : _cqQuestionToTriggerM.trigger
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ctaDestinationToTopicTagsMap[CTA_DESTINATION.cq]
    }
  }, getCQContextualBlock(answers));
};
var generateCQSubmitQuestionEvent = function generateCQSubmitQuestionEvent(question, answers) {
  var _cqQuestionToTriggerM2, _cqQuestionToTriggerM3;
  return Object.assign({
    envelope: {
      event_template_id: '149',
      event_template_version_id: '1',
      event_type_id: '2155',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: EVENT_TRIGGER.cqFunnel,
      trigger_type_nm: TRIGGER_TYPE.interaction,
      trigger_object_nm: (_cqQuestionToTriggerM2 = cqQuestionToTriggerMap[question]) === null || _cqQuestionToTriggerM2 === void 0 ? void 0 : _cqQuestionToTriggerM2.trigger,
      trigger_source_nm: (_cqQuestionToTriggerM3 = cqQuestionToTriggerMap[question]) === null || _cqQuestionToTriggerM3 === void 0 ? void 0 : _cqQuestionToTriggerM3.button
    },
    semantic: {
      semantic_event_nm: 'zgmi_cq_submit',
      topic_tag_txt: ctaDestinationToTopicTagsMap[CTA_DESTINATION.cq]
    }
  }, getCQContextualBlock(answers));
};
var generateCQUpdateResultsEvent = function generateCQUpdateResultsEvent(answers) {
  return Object.assign({
    envelope: {
      event_template_id: '149',
      event_template_version_id: '1',
      event_type_id: '2160',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: EVENT_TRIGGER.cqLanding,
      trigger_type_nm: TRIGGER_TYPE.interaction,
      trigger_object_nm: EVENT_TRIGGER.mortgageRatesHero,
      trigger_source_nm: EVENT_TRIGGER.resultsRefreshButton
    },
    semantic: {
      semantic_event_nm: 'zgmi_cq_update_results',
      topic_tag_txt: ctaDestinationToTopicTagsMap[CTA_DESTINATION.cq]
    }
  }, getCQContextualBlock(answers));
};
var generateCQLoanRequestEvent = function generateCQLoanRequestEvent(triggerLocation, triggerSource, triggerObject, funnelData) {
  return Object.assign({
    envelope: {
      event_template_id: '149',
      event_template_version_id: '1',
      event_type_id: '2152',
      event_type_version_id: '1',
      event_client_start_dtm: now()
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: TRIGGER_TYPE.interaction,
      trigger_object_nm: triggerObject,
      trigger_source_nm: triggerSource
    },
    semantic: {
      semantic_event_nm: 'zgmi_cq_loan_request',
      topic_tag_txt: ['zgmi', 'zgmi_cq']
    }
  }, getCQContextualBlock(funnelData));
};

var PA_LEAD_KEY = 'zgmi_pa_lead';
var shouldAllowPAContact = function shouldAllowPAContact(_ref) {
  var _ref$answers = _ref.answers,
    answers = _ref$answers === void 0 ? {} : _ref$answers,
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? {} : _ref$context;
  var loanType = answers.loanType;
  var brand = context.brand,
    disallowAffiliate = context.disallowAffiliate;
  return !disallowAffiliate &&
  // not from ABC
  loanType === 'purchase' && (brand === null || brand === void 0 ? void 0 : brand.toLowerCase()) === 'zillow';
};
var doesNotHasAgent = function doesNotHasAgent(answers) {
  return (answers === null || answers === void 0 ? void 0 : answers.hasAgent) === false;
}; // compares explicitly

var getTrackingLabel$1 = function getTrackingLabel(_ref2) {
  var _context$originalEntr, _context$originalEntr2, _context$entry, _context$entry$toUppe, _answers$loanType, _answers$needs;
  var context = _ref2.context,
    answers = _ref2.answers,
    _ref2$optionals = _ref2.optionals,
    optionals = _ref2$optionals === void 0 ? {} : _ref2$optionals;
  return JSON.stringify(Object.assign({
    source: context.source,
    landingPage: context.landingPage,
    enteredAs: (_context$originalEntr = context.originalEntry) === null || _context$originalEntr === void 0 ? void 0 : (_context$originalEntr2 = _context$originalEntr.toUpperCase) === null || _context$originalEntr2 === void 0 ? void 0 : _context$originalEntr2.call(_context$originalEntr),
    currentFlow: (_context$entry = context.entry) === null || _context$entry === void 0 ? void 0 : (_context$entry$toUppe = _context$entry.toUpperCase) === null || _context$entry$toUppe === void 0 ? void 0 : _context$entry$toUppe.call(_context$entry),
    loanType: (_answers$loanType = answers.loanType) !== null && _answers$loanType !== void 0 ? _answers$loanType : null,
    needs: (_answers$needs = answers.needs) !== null && _answers$needs !== void 0 ? _answers$needs : null
  }, optionals));
};
var savePAContactResponse = function savePAContactResponse(response) {
  if (isLocalStorageSupported()) {
    localStorage.setItem(PA_LEAD_KEY, JSON.stringify(response));
  }
};
var shouldShowNeedAgentQuestionInFunnel = function shouldShowNeedAgentQuestionInFunnel(_ref3) {
  var _ref3$answers = _ref3.answers,
    answers = _ref3$answers === void 0 ? {} : _ref3$answers,
    _ref3$context = _ref3.context,
    context = _ref3$context === void 0 ? {} : _ref3$context;
  return shouldAllowPAContact({
    answers: answers,
    context: context
  }) && doesNotHasAgent(answers);
};
var shouldShowPIIQuestionInFunnel = function shouldShowPIIQuestionInFunnel(_ref4) {
  var _ref4$answers = _ref4.answers,
    answers = _ref4$answers === void 0 ? {} : _ref4$answers,
    _ref4$context = _ref4.context,
    context = _ref4$context === void 0 ? {} : _ref4$context;
  return shouldShowNeedAgentQuestionInFunnel({
    answers: answers,
    context: context
  }) && (answers === null || answers === void 0 ? void 0 : answers.needAgent) === true;
};
var submitPAContact = function submitPAContact(_ref5) {
  var answers = _ref5.answers,
    contactId = _ref5.contactId,
    isZHLLender = _ref5.isZHLLender;
  var location = answers.location,
    name = answers.name,
    email = answers.email,
    phoneNumber = answers.phoneNumber;
  var input = {
    partnerId: API === null || API === void 0 ? void 0 : API.partnerId,
    userSessionId: API === null || API === void 0 ? void 0 : API.userSessionId,
    contactId: contactId,
    location: {
      zipCode: (location === null || location === void 0 ? void 0 : location.zipCode) || (location === null || location === void 0 ? void 0 : location.name),
      regionId: location === null || location === void 0 ? void 0 : location.regionId
    },
    firstName: name === null || name === void 0 ? void 0 : name.first,
    lastName: name === null || name === void 0 ? void 0 : name.last,
    emailAddress: email,
    phoneNumber: phoneNumber,
    externalLeadType: 'PremierAgent',
    acceptedABAD: true,
    isZHLLender: isZHLLender,
    experimentABTestBucketType: 'DEEP_FUNNEL_POPUP_ABAD'
  };
  Object.keys(input).forEach(function (key) {
    return input[key] === undefined && delete input[key];
  });
  return API.MAX.POST({
    action: 'submitExternalContactLead',
    input: input
  });
};
var trackPAContactClick = function trackPAContactClick(_ref6) {
  var context = _ref6.context,
    answers = _ref6.answers,
    _ref6$optionals = _ref6.optionals,
    optionals = _ref6$optionals === void 0 ? {} : _ref6$optionals;
  trackEvent({
    category: 'Mortgages',
    action: 'next click: agent-upsell',
    label: "" + getTrackingLabel$1({
      context: context,
      answers: answers,
      optionals: optionals
    })
  });
};
var trackPAContactSuccess = function trackPAContactSuccess(_ref7) {
  var context = _ref7.context,
    answers = _ref7.answers,
    _ref7$optionals = _ref7.optionals,
    optionals = _ref7$optionals === void 0 ? {} : _ref7$optionals;
  trackEvent({
    category: 'Mortgages',
    action: 'page view: /agent-upsell-success',
    label: "" + getTrackingLabel$1({
      context: context,
      answers: answers,
      optionals: optionals
    })
  });
};

var premierAgentExperiment = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getTrackingLabel: getTrackingLabel$1,
	savePAContactResponse: savePAContactResponse,
	shouldShowNeedAgentQuestionInFunnel: shouldShowNeedAgentQuestionInFunnel,
	shouldShowPIIQuestionInFunnel: shouldShowPIIQuestionInFunnel,
	submitPAContact: submitPAContact,
	trackPAContactClick: trackPAContactClick,
	trackPAContactSuccess: trackPAContactSuccess
});

var isNeedsBasedRouting = function isNeedsBasedRouting() {
  return abtest.getTreatment(ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT) === ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT_VARIANT;
};
var jsArrayConfig = [{
  name: 'location',
  // TODO: ZGMIAIR-970 - avoid using aliases and remove support eventually
  aliases: ['zip', 'zipCode'],
  component: 'Location',
  eventLabel: 'ZIP',
  eventLabelForConnect: '/location'
}, {
  name: 'loanType',
  aliases: ['loantype'],
  component: 'LoanType',
  isVariant: isNeedsBasedRouting(),
  onNext: function onNext() {
    return setContext({
      entry: getContext().originalEntry
    });
  },
  index: 1,
  eventLabel: 'Loan Type',
  eventLabelForConnect: '/loan-type'
}, {
  name: 'firstTime',
  component: 'FirstTime',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT && store.getAnswers().loanType === LOAN_TYPE_PURCHASE;
  },
  eventLabel: 'First Time',
  eventLabelForConnect: '/first-time'
}, {
  name: 'homeOwner',
  component: 'HomeOwner',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT && store.getAnswers().loanType === LOAN_TYPE_PURCHASE;
  },
  eventLabel: 'Home Owner',
  eventLabelForConnect: '/home-owner'
}, {
  name: 'selling',
  component: 'Selling',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT && store.getAnswers().loanType === LOAN_TYPE_PURCHASE && !!store.getAnswers().homeOwner;
  },
  eventLabel: 'Selling',
  eventLabelForConnect: '/selling'
}, {
  name: 'journeyStage',
  component: 'JourneyStage',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT && store.getAnswers().loanType === LOAN_TYPE_PURCHASE;
  },
  eventLabel: 'Journey Stage',
  eventLabelForConnect: '/journey-stage'
}, {
  name: 'propertyType',
  component: 'PropertyType',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT;
  },
  eventLabel: 'Property Type',
  eventLabelForConnect: '/property-type'
}, {
  name: 'propertyUsage',
  component: 'PropertyUsage',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT;
  },
  eventLabel: 'Property Usage',
  eventLabelForConnect: '/property-usage'
}, {
  name: 'vaModeShortCircuit',
  component: 'VAModeShortCircuit',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT && store.getAnswers().propertyUsage !== 'Primary' && getContext().vaEligible;
  },
  eventLabel: 'VA Mode Short Circuit',
  eventLabelForConnect: '/vaModeShortCircuit'
}, {
  name: 'vaEligible',
  component: 'VaEligible',
  aliases: ['militaryHistory'],
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT && store.getAnswers().propertyUsage === 'Primary' && store.getAnswers().loanType !== 'heloc';
  },
  eventLabel: 'VA Eligible',
  eventLabelForConnect: '/military-history'
}, {
  name: 'propertyValue',
  aliases: ['value'],
  defaultValue: 300000,
  component: 'PropertyValue',
  onNext: function onNext(_ref) {
    var answers = _ref.answers,
      context = _ref.context;
    var ctx = context !== null && context !== void 0 ? context : getContext();
    var answs = answers !== null && answers !== void 0 ? answers : store.getAnswers();
    if (ctx.entry === ENTRYNAME_CONNECT) {
      return {
        path: answs.loanType === 'purchase' ? 'downPayment' : 'loanBalance'
      };
    }
  },
  index: 2,
  eventLabel: 'Property Value',
  eventLabelForConnect: '/property-value'
}, {
  name: 'downPayment',
  aliases: ['down'],
  defaultValue: 60000,
  component: 'DownPayment',
  condition: function condition() {
    return store.getAnswers().loanType === LOAN_TYPE_PURCHASE;
  },
  onNext: function onNext() {
    var _store$getAnswers = store.getAnswers(),
      vaEligible = _store$getAnswers.vaEligible,
      downPayment = _store$getAnswers.downPayment,
      propertyValue = _store$getAnswers.propertyValue;
    if (getContext().entry !== ENTRYNAME_CONNECT) {
      return;
    }
    var loanAmount = propertyValue - downPayment;
    if (!vaEligible && downPayment < propertyValue * eligibilityRequirements.minimumDownPaymentPercent * 0.01 - 0.001) {
      return {
        path: 'notFound',
        reason: 'Low down payment'
      };
    }
    if (vaEligible && loanAmount < eligibilityRequirements.minimumVALoanAmount || !vaEligible && loanAmount < eligibilityRequirements.minimumLoanAmount) {
      return {
        path: 'notFound',
        reason: 'Low loan amount'
      };
    }
  },
  index: 3,
  eventLabel: 'Down Payment',
  eventLabelForConnect: '/down-payment'
}, {
  name: 'loanBalance',
  component: 'LoanBalance',
  defaultValue: 200000,
  condition: function condition() {
    return store.getAnswers().loanType !== LOAN_TYPE_PURCHASE;
  },
  onNext: function onNext() {
    var _store$getAnswers2 = store.getAnswers(),
      vaEligible = _store$getAnswers2.vaEligible,
      loanBalance = _store$getAnswers2.loanBalance;
    if (getContext().entry !== ENTRYNAME_CONNECT) {
      return;
    }
    if (vaEligible && loanBalance < eligibilityRequirements.minimumVALoanAmount || !vaEligible && loanBalance < eligibilityRequirements.minimumLoanAmount) {
      return {
        path: 'notFound',
        reason: 'Low current balance'
      };
    }
  },
  index: 3,
  eventLabel: 'Loan Balance',
  eventLabelForConnect: '/loan-balance'
}, {
  name: 'secondMortgage',
  component: 'SecondMortgage',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT && store.getAnswers().loanType !== LOAN_TYPE_PURCHASE;
  },
  eventLabel: 'Second Mortgage',
  eventLabelForConnect: '/second-mortgage'
}, {
  name: 'cashOut',
  component: 'CashOut',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT && store.getAnswers().loanType === 'refinance';
  },
  eventLabel: 'Cash Out',
  eventLabelForConnect: '/cash-out'
}, {
  name: 'helocAmount',
  component: 'HelocAmount',
  defaultValue: 25000,
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT && store.getAnswers().loanType === 'heloc';
  },
  eventLabel: 'Heloc Amount',
  eventLabelForConnect: '/heloc-amount'
}, {
  name: 'income',
  aliases: ['annualIncome'],
  defaultValue: 70000,
  component: 'Income',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT && store.getAnswers().loanType !== 'heloc';
  },
  onNext: function onNext() {
    var _store$getAnswers3 = store.getAnswers(),
      income = _store$getAnswers3.income;
    if (getContext().entry !== ENTRYNAME_CONNECT) {
      return;
    }
    if (income < eligibilityRequirements.minimumAnnualIncome) {
      return {
        path: 'notFound',
        reason: 'Low annual income'
      };
    }
  },
  eventLabel: 'Income',
  eventLabelForConnect: '/income'
}, {
  name: 'creditScore',
  defaultValue: 'R_720_739',
  // TODO: ZGMIAIR-1080 standardize default value
  component: 'CreditScore',
  onNext: function onNext() {
    if (getContext().entry !== ENTRYNAME_CONNECT) {
      return;
    }
    if (store.getAnswers().creditScore < eligibilityRequirements.minimumCreditScore) {
      return {
        path: 'notFound',
        reason: 'Low credit'
      };
    }
  },
  index: 4,
  eventLabel: 'Credit Score',
  eventLabelForConnect: '/credit'
}, {
  name: 'vaEligible',
  component: 'VaEligible',
  aliases: ['militaryHistory'],
  condition: function condition() {
    return getContext().entry !== ENTRYNAME_CONNECT;
  },
  // CQ last questions
  onNext: function onNext(_ref2) {
    return new Promise(function ($return, $error) {
      var _global$DD_RUM, _global$DD_RUM$addAct;
      var auto = _ref2.auto;
      if (auto) {
        return $return(false);
      }
      var answers = store.getAnswers();
      var longTableInput = mapLongTableInput(answers);
      (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addAct = _global$DD_RUM.addAction) === null || _global$DD_RUM$addAct === void 0 ? void 0 : _global$DD_RUM$addAct.call(_global$DD_RUM, 'mortgage-questionnaire:submitted', {
        entry: getContext().entry,
        originalEntry: getContext().originalEntry,
        loanType: answers.loanType
      });
      track({
        category: 'Mortgages',
        action: "showing rates from " + getContext().originalEntry.toUpperCase(),
        label: getTrackingLabel()
      }, {
        newLaneEvent: generateCQLeadSubmitEvent(getContext().landingPage)
      });
      // NOTE submit event tracking happens at quotes page
      window.location.href = zillowURL("mortgage-rates/quotes/?" + new URLSearchParams(longTableInput).toString());
      return $return(false);
    });
  },
  index: 5,
  eventLabel: 'VA Eligibility',
  eventLabelForConnect: '/va-eligibility'
}, {
  name: 'selfEmployed',
  component: 'SelfEmployed',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT && store.getAnswers().loanType !== 'heloc';
  },
  eventLabel: 'Self Employed',
  eventLabelForConnect: '/self-employed'
}, {
  name: 'creditHistory',
  component: 'CreditHistory',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT;
  },
  eventLabel: 'Credit History',
  eventLabelForConnect: '/credit-history'
}, {
  name: 'language',
  component: 'Language',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT;
  },
  onNext: function onNext(_ref3) {
    return new Promise(function ($return, $error) {
      var auto, answers, _await$getLongFormCon, longFormContactPossible, primaryLender, affiliateDibs;
      auto = _ref3.auto;
      if (auto) {
        return $return(false);
      }
      answers = store.getAnswers();
      return Promise.resolve(getLongFormContactPossible(answers, getContext()).catch(function (error) {
        var _global$DD_RUM2, _global$DD_RUM2$addEr;
        (_global$DD_RUM2 = global.DD_RUM) === null || _global$DD_RUM2 === void 0 ? void 0 : (_global$DD_RUM2$addEr = _global$DD_RUM2.addError) === null || _global$DD_RUM2$addEr === void 0 ? void 0 : _global$DD_RUM2$addEr.call(_global$DD_RUM2, error, {
          action: 'check contact possible after language question',
          answers: answers,
          context: getContext()
        });
        return {};
      })).then(function ($await_1) {
        try {
          _await$getLongFormCon = $await_1, longFormContactPossible = _await$getLongFormCon.longFormContactPossible, primaryLender = _await$getLongFormCon.primaryLender, affiliateDibs = _await$getLongFormCon.affiliateDibs;
          if (!longFormContactPossible) {
            return $return({
              path: 'notFound',
              reason: 'No lenders found'
            });
          }
          setContext({
            longFormContactPossible: longFormContactPossible,
            primaryLender: primaryLender,
            affiliateDibs: affiliateDibs
          });
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  },
  eventLabel: 'Language',
  eventLabelForConnect: '/language'
}, {
  name: 'vermontAgreed',
  component: 'VermontAgreement',
  condition: function condition() {
    var _store$getAnswers$loc;
    var acceptedVermontDisclaimer = isLocalStorageSupported() && localStorage.getItem(VERMONT_DISCLAIMER_LOCAL_STORAGE_KEY) === 'true';
    return !acceptedVermontDisclaimer && getContext().entry === ENTRYNAME_CONNECT && ((_store$getAnswers$loc = store.getAnswers().location) === null || _store$getAnswers$loc === void 0 ? void 0 : _store$getAnswers$loc.state) === 'VT' && !store.getAnswers().vermontAgreed;
  },
  eventLabel: 'Vermont Agreed',
  eventLabelForConnect: '/vermontAgreed'
},
// ZGMI_PA deep funnel
{
  name: 'hasAgent',
  component: 'HasAgent',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT && store.getAnswers().loanType === LOAN_TYPE_PURCHASE;
  },
  eventLabel: 'Has Agent',
  eventLabelForConnect: '/has-agent'
}, {
  name: 'needAgent',
  component: 'NeedAgent',
  condition: function condition() {
    var context = getContext();
    var answers = store.getAnswers();
    return context.entry === ENTRYNAME_CONNECT && shouldShowNeedAgentQuestionInFunnel({
      answers: answers,
      context: context
    });
  },
  eventLabel: 'Need Agent',
  eventLabelForConnect: '/need-agent'
},
// Deep funnel ZGMI_PA
{
  name: 'name',
  component: 'PAName',
  condition: function condition() {
    var context = getContext();
    var answers = store.getAnswers();
    return (context === null || context === void 0 ? void 0 : context.entry) === ENTRYNAME_CONNECT && shouldShowPIIQuestionInFunnel({
      answers: answers,
      context: context
    });
  },
  eventLabel: 'Name',
  eventLabelForConnect: '/name'
}, {
  name: 'name',
  component: 'Name',
  condition: function condition() {
    var context = getContext();
    var answers = store.getAnswers();
    return (context === null || context === void 0 ? void 0 : context.entry) === ENTRYNAME_CONNECT && !shouldShowPIIQuestionInFunnel({
      answers: answers,
      context: context
    });
  },
  eventLabel: 'Name',
  eventLabelForConnect: '/name'
}, {
  name: 'email',
  component: 'Email',
  condition: function condition() {
    var context = getContext();
    return (context === null || context === void 0 ? void 0 : context.entry) === ENTRYNAME_CONNECT;
  },
  eventLabel: 'Email',
  eventLabelForConnect: '/email'
},
// Deep funnel ZGMI_PA phone
{
  name: 'phoneNumber',
  aliases: ['phone'],
  component: 'PAContact',
  condition: function condition() {
    var context = getContext();
    var answers = store.getAnswers();
    return (context === null || context === void 0 ? void 0 : context.entry) === ENTRYNAME_CONNECT && shouldShowPIIQuestionInFunnel({
      answers: answers,
      context: context
    });
  },
  eventLabel: 'Phone Number',
  eventLabelForConnect: '/phone-number'
}, {
  name: 'phoneNumber',
  aliases: ['phone'],
  component: 'PhoneNumber',
  condition: function condition() {
    var context = getContext();
    var answers = store.getAnswers();
    return (context === null || context === void 0 ? void 0 : context.entry) === ENTRYNAME_CONNECT && !shouldShowPIIQuestionInFunnel({
      answers: answers,
      context: context
    });
  },
  eventLabel: 'Phone Number',
  eventLabelForConnect: '/phone-number'
}, {
  name: 'final',
  type: 'terminal',
  component: 'FinalPage',
  condition: function condition() {
    return getContext().entry === ENTRYNAME_CONNECT;
  },
  eventLabel: 'Searching',
  eventLabelForConnect: '/searching',
  onNext: function onNext(_ref4) {
    var answers = _ref4.answers;
    if (answers !== null && answers !== void 0 && answers.notFound) {
      return {
        path: 'notFound',
        reason: answers === null || answers === void 0 ? void 0 : answers.notFound
      };
    }
    return;
  }
},
// Below: terminal routes
{
  name: 'notFound',
  type: 'terminal',
  component: 'LenderNotFound',
  condition: function condition() {
    return false;
  },
  eventLabel: 'Not Found',
  eventLabelForConnect: '/final:failure'
}, {
  name: 'submitted',
  type: 'terminal',
  component: 'LenderNotFound',
  // TODO: Connect submitted route UI, and CQ temporary UI
  // offer manual click to nagivate to CQ quotes page in case of "back" button click before requestId is saved
  condition: function condition() {
    return false;
  },
  eventLabel: 'submitted unexpectedly',
  eventLabelForConnect: 'submitted unexpectedly'
}];

/*
 * Client side config for Long Form config
 * TODO: move to getStaticProps to reduce network traffic
 *   which needs build pipeline to access prod API, or use SSR instead
 */
var fetchedUxConfiguration;
var initializeUxConfiguration = function initializeUxConfiguration() {
  return fetchedUxConfiguration || API.MAX.POST({
    action: 'getUXConfiguration'
  }).then(function (response) {
    var _response$configurati;
    fetchedUxConfiguration = (_response$configurati = response === null || response === void 0 ? void 0 : response.configuration) !== null && _response$configurati !== void 0 ? _response$configurati : {};
    return fetchedUxConfiguration;
  }).catch(function (error) {
    var _global$DD_RUM, _global$DD_RUM$addErr;
    (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addErr = _global$DD_RUM.addError) === null || _global$DD_RUM$addErr === void 0 ? void 0 : _global$DD_RUM$addErr.call(_global$DD_RUM, new Error('Could not get ux configuration'), {
      error: error,
      level: 'warn'
    });
  });
};
var uxConfiguration = {
  get dataShareList() {
    var _fetchedUxConfigurati;
    return (_fetchedUxConfigurati = fetchedUxConfiguration) === null || _fetchedUxConfigurati === void 0 ? void 0 : _fetchedUxConfigurati.dataShareList;
  },
  get defaultPropertyValuesByState() {
    var _fetchedUxConfigurati2;
    return ((_fetchedUxConfigurati2 = fetchedUxConfiguration) === null || _fetchedUxConfigurati2 === void 0 ? void 0 : _fetchedUxConfigurati2.defaultPropertyValuesByState) || {};
  }
};

function fullName(nameObj, lastInitial) {
  if (nameObj === void 0) {
    nameObj = {};
  }
  if (nameObj === null || _typeof(nameObj) !== 'object') {
    return nameObj;
  }
  var _nameObj = nameObj,
    _nameObj$firstName = _nameObj.firstName,
    firstName = _nameObj$firstName === void 0 ? '' : _nameObj$firstName,
    _nameObj$suffix = _nameObj.suffix,
    suffix = _nameObj$suffix === void 0 ? '' : _nameObj$suffix;
  var _nameObj2 = nameObj,
    _nameObj2$middleName = _nameObj2.middleName,
    middleName = _nameObj2$middleName === void 0 ? '' : _nameObj2$middleName,
    _nameObj2$lastName = _nameObj2.lastName,
    lastName = _nameObj2$lastName === void 0 ? '' : _nameObj2$lastName;
  middleName = middleName === '' ? '' : " " + middleName;
  if (lastInitial) {
    lastName = lastName.substring(0, 1) + ".";
  }
  var genName = "" + firstName + middleName + " " + lastName + (suffix !== '' ? ", " + suffix : '');
  if (genName.trim() === '') {
    genName = "\xA0";
  }
  return genName;
}
var getLenderDisplayName = function getLenderDisplayName(lender, fullname) {
  if ((lender === null || lender === void 0 ? void 0 : lender.nmlsType) === 'Company') {
    return lender.companyName;
  }
  if (lender !== null && lender !== void 0 && lender.individualName) {
    if (fullname) {
      return fullName(lender.individualName);
    }
    return lender.individualName.firstName;
  }
  if (lender !== null && lender !== void 0 && lender.screenName) {
    return lender.screenName;
  }
  return '';
};

var _ctaDestinationToTopi$1;
var generateInteractionEvents = function generateInteractionEvents(_ref) {
  var eventTemplateID = _ref.eventTemplateID,
    eventTypeID = _ref.eventTypeID,
    triggerLocation = _ref.triggerLocation,
    triggerSource = _ref.triggerSource,
    semanticEvent = _ref.semanticEvent,
    topicTag = _ref.topicTag,
    triggerObject = _ref.triggerObject,
    contextualBlock = _ref.contextualBlock;
  return Object.assign({
    envelope: {
      event_template_id: eventTemplateID,
      event_template_version_id: '1',
      event_type_id: eventTypeID,
      event_type_version_id: '1',
      event_client_start_dtm: new Date().toISOString()
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: triggerObject || 'no_trigger_object',
      trigger_source_nm: triggerSource
    },
    semantic: {
      semantic_event_nm: semanticEvent,
      topic_tag_txt: topicTag
    }
  }, contextualBlock);
};
var CTA_DESTINATION$1 = {
  zgmi: 'ZGMI Connect, ZGMI CQ',
  connect: 'ZGMI Connect',
  cq: 'ZGMI CQ',
  zhlPurchase: 'ZHL Purchase',
  zhlRefi: 'ZHL Refi'
};
var ctaDestinationToTopicTagsMap$1 = (_ctaDestinationToTopi$1 = {}, _ctaDestinationToTopi$1[CTA_DESTINATION$1.connect] = ['zgmi', 'zgmi_connect'], _ctaDestinationToTopi$1[CTA_DESTINATION$1.cq] = ['zgmi', 'zgmi_cq'], _ctaDestinationToTopi$1[CTA_DESTINATION$1.zhlPurchase] = ['zhl', 'zhl_purchase'], _ctaDestinationToTopi$1[CTA_DESTINATION$1.zhlRefi] = ['zhl', 'zhl_refi'], _ctaDestinationToTopi$1[CTA_DESTINATION$1.zgmi] = ['zgmi', 'zgmi_connect', 'zgmi_cq'], _ctaDestinationToTopi$1);

var _LEAD_EVENTS, _VIEW_EVENTS;
var FB_TYPES = {
  GENERIC: 'GENERIC',
  HELOC: 'HELOC',
  PURCHASE: 'PURCHASE',
  REFINANCE: 'REFINANCE',
  VA: 'VA',
  VA_REFI: 'VA_REFI',
  VA_PURCHASE: 'VA_PURCHASE'
};
var LEAD_EVENTS = (_LEAD_EVENTS = {}, _LEAD_EVENTS[FB_TYPES.GENERIC] = 'ZMM_Generic_Lead', _LEAD_EVENTS[FB_TYPES.HELOC] = 'ZMM_Heloc_Lead', _LEAD_EVENTS[FB_TYPES.PURCHASE] = 'ZMM_Purchase_Lead', _LEAD_EVENTS[FB_TYPES.REFINANCE] = 'ZMM_Refi_Lead', _LEAD_EVENTS[FB_TYPES.VA_PURCHASE] = 'ZMM_VAPurchase_Lead', _LEAD_EVENTS[FB_TYPES.VA_REFI] = 'ZMM_VARefi_Lead', _LEAD_EVENTS);
var VIEW_EVENTS = (_VIEW_EVENTS = {}, _VIEW_EVENTS[FB_TYPES.GENERIC] = 'ZMM_Generic_View', _VIEW_EVENTS[FB_TYPES.HELOC] = 'ZMM_Heloc_View', _VIEW_EVENTS[FB_TYPES.PURCHASE] = 'ZMM_Purchase_View', _VIEW_EVENTS[FB_TYPES.REFINANCE] = 'ZMM_Refi_View', _VIEW_EVENTS[FB_TYPES.VA] = 'ZMM_VA_View', _VIEW_EVENTS[FB_TYPES.VA_PURCHASE] = 'ZMM_Purchase_View', _VIEW_EVENTS[FB_TYPES.VA_REFI] = 'ZMM_Refi_View', _VIEW_EVENTS);
var getFacebookEventName = function getFacebookEventName(answers, landingPage) {
  var loanType = answers.loanType,
    vaEligible = answers.vaEligible;
  if (landingPage === 'heloc') {
    return FB_TYPES.HELOC;
  }
  if (landingPage === 'va') {
    return FB_TYPES.VA;
  }

  // military question
  if (vaEligible) {
    return loanType === LOAN_TYPE_REFINANCE ? FB_TYPES.VA_REFI : FB_TYPES.VA_PURCHASE;
  }
  if (loanType === LOAN_TYPE_REFINANCE) {
    return FB_TYPES.REFINANCE;
  }
  if (loanType === LOAN_TYPE_PURCHASE) {
    return FB_TYPES.PURCHASE;
  }
  return FB_TYPES.GENERIC;
};
var pushEvent = function pushEvent(event) {
  return (window.dataLayer || []).push({
    event: event
  });
};
var pushFacebookEvent = function pushFacebookEvent(answers, landingPage, types) {
  var name = getFacebookEventName(answers, landingPage);
  pushEvent(types[name]);
};
var pushFacebookLeadEventFailure = function pushFacebookLeadEventFailure() {
  return pushEvent('ZMM_Lead_Failure');
};
var pushFacebookLeadEvent = function pushFacebookLeadEvent(answers, landingPage) {
  pushFacebookEvent(answers, landingPage, LEAD_EVENTS);
};

/**
 * Notify ios/android webview that we are done with the flow
 *
 * ZMOB_nativeAPI docs: https://zwiki.zillowgroup.net/pages/viewpage.action?spaceKey=mobile&title=JavaScript+API+for+Embedded+Web+Views+in+Native+Apps
 */
var notifyNativeAppFormComplete = function notifyNativeAppFormComplete() {
  if (isWebview()) {
    var _window, _window$ZMOB_nativeAP, _window$ZMOB_nativeAP2;
    (_window = window) === null || _window === void 0 ? void 0 : (_window$ZMOB_nativeAP = _window.ZMOB_nativeAPI) === null || _window$ZMOB_nativeAP === void 0 ? void 0 : (_window$ZMOB_nativeAP2 = _window$ZMOB_nativeAP.formComplete) === null || _window$ZMOB_nativeAP2 === void 0 ? void 0 : _window$ZMOB_nativeAP2.call(_window$ZMOB_nativeAP);
  }
};

var BASE_INPUTS = ['imageId', 'nmlsId', 'nmlsType', 'companyName', 'individualName', 'totalReviews', 'rating', 'conventionalLoanReviews', 'jumboLoanReviews', 'fhaLoanReviews', 'usdaLoanReviews', 'newConstructionBuyerReviews', 'employerScreenName', 'screenName', 'equalHousingLogo', 'officePhone', 'cellPhone', 'externalApplicationURL'];
var LENDER_FIELD_TESTS = {
  vaEligible: function vaEligible(val) {
    return val;
  },
  selfEmployed: function selfEmployed(val) {
    return val;
  },
  details: function details(val) {
    return val.purchase && val.purchase.firstTimeBuyer;
  },
  creditScoreRange: function creditScoreRange(val) {
    return val === 'R_300_559';
  }
};
var LENDER_FIELD_MAP = {
  vaEligible: 'vaLoanReviews',
  selfEmployed: 'selfEmployedBuyerReviews',
  details: 'firstTimeBuyerReviews',
  creditScoreRange: 'lowCreditBuyerReviews'
};
var mapLenderFieldsByInputs = function mapLenderFieldsByInputs(inputs) {
  if (inputs === void 0) {
    inputs = {};
  }
  return Object.keys(inputs).reduce(function (prev, key) {
    return LENDER_FIELD_MAP[key] && LENDER_FIELD_TESTS[key](inputs[key]) ? prev.concat(LENDER_FIELD_MAP[key]) : prev;
  }, BASE_INPUTS);
};
var contactLongFormLender = function contactLongFormLender(answers, context, contactAffiliate) {
  return new Promise(function ($return, $error) {
    var _answers$name, _answers$name2, userInput, gaClientId, input, contactLenderResponse;
    if (context.entry !== 'connect') {
      return $return();
    }
    return Promise.resolve(mapLongFormInput(answers, context)).then(function ($await_1) {
      try {
        userInput = $await_1;
        return Promise.resolve(getUAClientId().catch(function () {})).then(function ($await_2) {
          try {
            gaClientId = $await_2;
            input = Object.assign({}, userInput, {
              lenderFields: mapLenderFieldsByInputs(userInput),
              userSessionId: API.userSessionId,
              firstName: (_answers$name = answers.name) === null || _answers$name === void 0 ? void 0 : _answers$name.first,
              lastName: (_answers$name2 = answers.name) === null || _answers$name2 === void 0 ? void 0 : _answers$name2.last,
              emailAddress: answers.email,
              phoneNumber: answers.phoneNumber,
              contactAffiliate: contactAffiliate,
              gaClientId: gaClientId
            });
            if (context.isZGMIPaLead && shouldShowPIIQuestionInFunnel({
              answers: answers,
              context: context
            })) {
              input.isZGMIPaLead = true;
            }
            return Promise.resolve(API.MAX.POST({
              action: 'contactLongFormLender',
              input: input,
              timeout: 300000
            }).then(function (response) {
              var _response$offeredLend, _response$offeredLend2;
              if (!(response !== null && response !== void 0 && response.contactId) || !(response !== null && response !== void 0 && response.primaryLender)) {
                throw new Error('Invalid response from contactLongFormLender');
              }
              trackEvent({
                category: 'Mortgages',
                action: 'Long form lead submitted'
              });
              trackEvent({
                category: 'Mortgages',
                action: 'completed process contactId',
                label: response === null || response === void 0 ? void 0 : response.contactId
              });
              event(generateInteractionEvents({
                eventTemplateID: '150',
                eventTypeID: '2166',
                triggerLocation: 'zgmi_connect_funnel',
                triggerSource: 'lender_profile_card',
                triggerObject: 'zgmi_connect_lendermatch',
                semanticEvent: 'zgmi_lender_profile_select',
                topicTag: ['zgmi', 'zgmi_lender_directory'],
                contextualBlock: {
                  zgmi_lender_info: {
                    lender: response === null || response === void 0 ? void 0 : response.contactId
                  }
                }
              }));

              // the 1 refers to response.primaryLender
              var totalLenders = ((_response$offeredLend = response === null || response === void 0 ? void 0 : (_response$offeredLend2 = response.offeredLenders) === null || _response$offeredLend2 === void 0 ? void 0 : _response$offeredLend2.length) !== null && _response$offeredLend !== void 0 ? _response$offeredLend : 0) + 1;
              track({
                category: 'Mortgages',
                action: 'Connect Lenders Matched',
                label: totalLenders + " lenders matched"
              });
              pushFacebookLeadEvent(answers, context.landingPage);
              return formatResponse(response, gaClientId);
            }).catch(function (error) {
              var _global$DD_RUM, _global$DD_RUM$addErr;
              (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addErr = _global$DD_RUM.addError) === null || _global$DD_RUM$addErr === void 0 ? void 0 : _global$DD_RUM$addErr.call(_global$DD_RUM, error, {
                action: 'contactLongFormLender',
                answers: _omit(answers, PII_QUESTIONS_ROUTES),
                input: _omit(input, ['firstName', 'lastName', 'emailAddress', 'phoneNumber'])
              });
              pushFacebookLeadEventFailure();
              if (error && error.error === 'IneligibleForLongForm') {
                trackEvent({
                  category: 'Mortgages',
                  action: 'longform:completed',
                  label: JSON.stringify({
                    contactType: answers.loanType,
                    landingPage: context.landingPage,
                    page: 'final',
                    ineligible: true
                  })
                });
                notifyNativeAppFormComplete();
                throw new Error('Error! Request to contactLongFormLender returns ineligible', {
                  cause: error
                });
              }
              throw new Error('Error! Failed to request contactLongFormLender', {
                cause: error
              });
            })).then(function ($await_3) {
              try {
                contactLenderResponse = $await_3;
                return $return(contactLenderResponse);
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }, $error);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
};

// duplicated from src/long-form/redux/lenders.js, there should be better way to get this
// TODO move to @zillow/universal-analytics
function getUAClientId() {
  return new Promise(function (resolve, reject) {
    if (typeof window === 'undefined' || !window.ga) {
      return reject();
    }
    // Workaround for uBlock Origin users
    var timeout = setTimeout(function () {
      return reject();
    }, 200);
    window.ga(function (tracker) {
      var _tracker$get;
      clearTimeout(timeout);
      resolve(tracker === null || tracker === void 0 ? void 0 : (_tracker$get = tracker.get) === null || _tracker$get === void 0 ? void 0 : _tracker$get.call(tracker, 'clientId'));
    });
  });
}
function formatResponse(contactLenderResponse, gaClientId) {
  var _contactLenderRespons;
  return contactLenderResponse && Object.assign({}, contactLenderResponse, {
    gaClientId: gaClientId,
    primaryLender: Object.assign({}, contactLenderResponse.primaryLender, {
      displayName: getLenderDisplayName(contactLenderResponse.primaryLender)
    }),
    offeredLenders: (_contactLenderRespons = contactLenderResponse.offeredLenders) === null || _contactLenderRespons === void 0 ? void 0 : _contactLenderRespons.map(function (lender) {
      return Object.assign(lender, {
        displayName: getLenderDisplayName(lender)
      });
    })
  });
}

var _templateObject;
var BottomSpacer = styled(Spacer)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    width: 100%;\n    max-width: ", "px;\n    bottom: 0;\n    ", ";\n"])), token('Page.maxWidth'), mediaMixin('xxl', token('Page.maxWidth') + "px;"));
var ProgressBarComponent = function ProgressBarComponent(_ref) {
  var _schema$find;
  var schema = _ref.schema,
    currentQuestion = _ref.currentQuestion;
  var indexedQuestions = useMemo(function () {
    return schema.filter(function (route) {
      return route.index && route.index > 0;
    });
  }, [schema]);
  if (!indexedQuestions.length) {
    throw new Error('Please configure schema questions with index numbers when passing showProgressBar to true');
  }
  var totalSteps = indexedQuestions[indexedQuestions.length - 1].index;
  var lastIndexedRouteIndex = 0;
  // TODO: get currentStep from router to avoid missed algorithm update
  var currentStep = ((_schema$find = schema.find(function (route) {
    lastIndexedRouteIndex = route.index || lastIndexedRouteIndex;
    return route.name === currentQuestion.name;
  })) === null || _schema$find === void 0 ? void 0 : _schema$find.index) || lastIndexedRouteIndex;
  if (!currentStep || currentStep === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  // TODO: talk with design to reduce step count by one, to align with constellation pattern and fix this case
  // NOTE: temporary fix and breaks accessibility
  if (currentStep === totalSteps) {
    return /*#__PURE__*/React.createElement(BottomSpacer, {
      margin: "sm"
    }, /*#__PURE__*/React.createElement(ProgressBar, {
      value: 99,
      maxValue: 100,
      size: "sm"
    }));
  }
  return /*#__PURE__*/React.createElement(BottomSpacer, {
    margin: "sm"
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    value: currentStep,
    maxValue: totalSteps,
    size: "sm"
  }));
};
ProgressBarComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  schema: propTypes.arrayOf(propTypes.object),
  currentQuestion: propTypes.shape({
    name: propTypes.string.isRequired,
    index: propTypes.number
  })
} : {};

var _templateObject$1, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
var widths = {
  narrow: '25%',
  medium: '50%',
  wide: '70%',
  mdMax: '480px',
  // 70% of 768(breakpoint) - 2*16(page padding sm) - 2*24(card layout padding md)
  full: '100%',
  smMax: '406px' // 480(breakpoint) - 2*16(page padding sm) - 2*24(card layout padding md)
};
var getColumnWidthCss = function getColumnWidthCss(width) {
  return css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n    flex-basis: calc(", " - ", ");\n"])), width, spaceMixin('md'));
};
var StyledField = styled(RHFSchemaGeneratedField).attrs({
  size: 'lg',
  renderLabel: function renderLabel() {}
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n"])), function (_ref) {
  var _ref$columnWidth = _ref.columnWidth,
    columnWidth = _ref$columnWidth === void 0 ? widths.full : _ref$columnWidth;
  return getColumnWidthCss(columnWidth);
}, function (_ref2) {
  var desktopColumnWidth = _ref2.desktopColumnWidth;
  return desktopColumnWidth && mediaMixin('xl', getColumnWidthCss(desktopColumnWidth));
});
var StyledToggleButtonGroup = function StyledToggleButtonGroup(_ref3) {
  var vertical = _ref3.vertical,
    props = _objectWithoutProperties(_ref3, ["vertical"]);
  return /*#__PURE__*/React.createElement(StyledField, _extends({
    type: FIELD_TYPES.TOGGLE_BUTTON_GROUP,
    fluid: true,
    direction: vertical ? 'column' : 'row'
  }, props));
};
StyledToggleButtonGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  vertical: propTypes.bool,
  conjoined: propTypes.bool
} : {};
StyledToggleButtonGroup.defaultProps = {
  vertical: true,
  conjoined: false
};
var StyledForm = styled(Form)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    width: ", ";\n    ", ";\n    ", ";\n"])), widths.full, mediaMixin('md', css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n            width: ", ";\n            min-width: ", ";\n        "])), widths.wide, widths.smMax)), mediaMixin('lg', css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n            width: ", ";\n            min-width: ", ";\n        "])), widths.medium, widths.mdMax)));
var StyledFormFlex = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-wrap: wrap;\n    margin-left: -", ";\n    ", " {\n        margin-left: ", ";\n    }\n"])), spaceMixin('md'), StyledField, spaceMixin('md'));
var QuestionnaireCardLayout = styled(Card)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n    background-color: rgba(255, 255, 255, 0.92);\n    position: relative;\n    box-sizing: border-box;\n    width: 100%;\n    max-width: 960px;\n    padding: ", " ", ";\n    ", ";\n"])), spaceMixin('lg'), spaceMixin('md'), mediaMixin('lg', css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n            width: 960px;\n        "])))));
var StyledButton = styled(Button)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    ", ";\n"])), mediaMixin('md', css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n            width: 240px;\n        "])))));

var _templateObject$2, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1;
var QUOTES_PAGE_REQUEST_ID = 'requestId';

// TODO: move FINAL_PAGE_RESPONSE to the schema in order to use import here
var FINAL_PAGE_RESPONSE = 'lenders';
var FINAL_PAGE_LEGACY_RESPONSE_ID = 'reduxPersist:lenders';
var Layout = styled(Form)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    padding: ", " ", ";\n"])), spaceMixin('lg'), spaceMixin('md'));
var CenterAlignedTableQuestionText = styled(Paragraph)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    margin-bottom: ", ";\n"])), spaceMixin('sm'));
var CenterAlignedButtonContainer = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n    width: fit-content;\n    margin-left: auto;\n    margin-right: auto;\n"])));
var CenterAlignedQuestionSecondaryAction = styled(TextButton)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n    margin-top: ", ";\n    display: block;\n    width: fit-content;\n    margin-left: auto;\n    margin-right: auto;\n    ", ";\n"])), spaceMixin('sm'), mediaMixin('md', css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n            margin-top: ", ";\n        "])), spaceMixin('lg'))));
var CompletedRequestScreen = function CompletedRequestScreen(_ref) {
  var onStartOver = _ref.onStartOver,
    onUpdatedResults = _ref.onUpdatedResults,
    onBackToResults = _ref.onBackToResults,
    context = _ref.context,
    answers = _ref.answers,
    resultsUrl = _ref.resultsUrl;
  var handleClick = function handleClick() {
    event(generateCQUpdateResultsEvent(answers));
    event(generateCQLoanRequestEvent(EVENT_TRIGGER.cqLanding, EVENT_TRIGGER.resultsRefreshButton, EVENT_TRIGGER.mortgageRatesHero, answers));
    onUpdatedResults();
  };
  return /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Text, {
    fontType: {
      default: 'h4',
      md: 'h3'
    },
    as: "h1",
    fontColor: context.themeDark ? 'textWhite' : 'textDark',
    marginBottom: "md"
  }, context.title || "Compare Today's Mortgage Rates"), /*#__PURE__*/React.createElement(CenterAlignedTableQuestionText, {
    fontColor: context.themeDark ? 'textWhite' : 'textDark',
    fontType: context.themeDark ? 'h6' : 'body'
  }, context.entry === 'connect' ? 'The information on this page has already been submitted.' : 'Rates may have changed since your last visit. Get updated results for your most recent search.'), context.entry === 'connect' ? /*#__PURE__*/React.createElement(CenterAlignedButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
    buttonType: BUTTON_TYPES.primary,
    marginTop: "md",
    fluid: {
      default: true,
      md: false
    },
    onClick: onBackToResults
  }, "Click here to go back to your results page"), /*#__PURE__*/React.createElement(Paragraph, {
    marginTop: "lg"
  }, "Or")) : /*#__PURE__*/React.createElement(CenterAlignedButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
    as: "a",
    href: resultsUrl,
    buttonType: BUTTON_TYPES.primary,
    marginTop: "md",
    fluid: {
      default: true,
      md: false
    },
    onClick: handleClick
  }, "Get updated results")), /*#__PURE__*/React.createElement(CenterAlignedQuestionSecondaryAction, {
    onClick: onStartOver
  }, "Start over"));
};
CompletedRequestScreen.propTypes = process.env.NODE_ENV !== "production" ? {
  onStartOver: propTypes.func.isRequired,
  onUpdatedResults: propTypes.func.isRequired,
  onBackToResults: propTypes.func.isRequired,
  context: propTypes.shape({
    title: propTypes.string,
    themeDark: propTypes.bool,
    entry: propTypes.string
  }),
  answers: propTypes.object,
  resultsUrl: propTypes.string
} : {};
var CompletedRequestScreenComponent = function CompletedRequestScreenComponent(props) {
  useEffect(function () {
    // remove hash when completed in case of browser back
    if (window.location.hash) {
      window.history.replaceState({
        index: 0
      }, '', window.location.pathname + window.location.search);
    }
  });
  return /*#__PURE__*/React.createElement(CompletedRequestScreen, props);
};
var QuestionnaireLayout = function QuestionnaireLayout(_ref2) {
  var children = _ref2.children,
    _onStartOver = _ref2.onStartOver,
    onUpdatedResults = _ref2.onUpdatedResults,
    showProgress = _ref2.showProgress,
    schema = _ref2.schema,
    currentQuestion = _ref2.currentQuestion,
    isLanding = _ref2.isLanding,
    answers = _ref2.answers,
    onCompletedRequestScreenRender = _ref2.onCompletedRequestScreenRender,
    resultsUrl = _ref2.resultsUrl;
  var context = getContext();
  var connectResponse;
  try {
    connectResponse = JSON.parse(getItem$1(FINAL_PAGE_RESPONSE));
    if (!connectResponse) {
      var _JSON$parse;
      connectResponse = formatResponse((_JSON$parse = JSON.parse(getItem$1(FINAL_PAGE_LEGACY_RESPONSE_ID))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.contactLenderResponse);
      connectResponse && setItem$1(FINAL_PAGE_RESPONSE, connectResponse); // for migration
    }
  } catch (error) {
    var _global$DD_RUM, _global$DD_RUM$addErr;
    (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addErr = _global$DD_RUM.addError) === null || _global$DD_RUM$addErr === void 0 ? void 0 : _global$DD_RUM$addErr.call(_global$DD_RUM, new Error('mortgage-questionnaire: connectResponse parsing error'), {
      query: location.search,
      hash: location.hash,
      error: error,
      response: connectResponse,
      level: 'warn'
    });
  }
  var cqRequestId = getItem$1(QUOTES_PAGE_REQUEST_ID);
  var _useState = useState(context.entry === 'connect' && !connectResponse || context.entry !== 'connect' && !cqRequestId),
    _useState2 = _slicedToArray(_useState, 2),
    isStartOver = _useState2[0],
    setStartOver = _useState2[1];
  var isCompletedRequest = !(context.entry === 'connect' && !connectResponse || context.entry !== 'connect' && !cqRequestId || isStartOver ||
  // final page should only use cache when properly routed to
  window.location.hash === '#final' && global.window.history.state.index);
  useEffect(function () {
    onCompletedRequestScreenRender(isCompletedRequest);
  }, [onCompletedRequestScreenRender, isCompletedRequest]);

  // NOTE: refresh the page to handle Safari issues when back-and-forward cache is loaded
  useEffect(function () {
    var backForwardCacheHandler = function backForwardCacheHandler(e) {
      if (e.persisted) {
        setStartOver(!getItem$1(QUOTES_PAGE_REQUEST_ID));
        window.location.reload();
      }
    };
    window.addEventListener('pageshow', backForwardCacheHandler);
    return function () {
      window.removeEventListener('pageshow', backForwardCacheHandler);
    };
  }, []);
  useEffect(function () {
    if (context.entry === 'connect' && (isLanding || isCompletedRequest)) {
      event(generateConnectLandingEvent());
    } else if (context.entry === 'cq' && (isLanding || isCompletedRequest)) {
      event(generateCQLandingPageViewEvent(window.location.pathname));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return !isCompletedRequest ? /*#__PURE__*/React.createElement(React.Fragment, null, isLanding ? children : /*#__PURE__*/React.createElement(QuestionnaireCardLayout, {
    cardType: CARD_TYPES.secondary
  }, /*#__PURE__*/React.cloneElement(children, {
    onSuccess: function onSuccess() {
      return setStartOver(false);
    }
  })), showProgress && /*#__PURE__*/React.createElement(ProgressBarComponent, {
    schema: schema,
    currentQuestion: currentQuestion
  })) : /*#__PURE__*/React.createElement(CompletedRequestScreenComponent, {
    onStartOver: function onStartOver(e) {
      e.preventDefault();
      setStartOver(true);
      _onStartOver();
    },
    onUpdatedResults: onUpdatedResults,
    onBackToResults: function onBackToResults(e) {
      e.preventDefault();
      onUpdatedResults(e);
      setStartOver(false);
      // TODO: ZGMIAIR-1116 remove abadAccepted here and get abadAccepted from API instead
      router.go('final', Object.assign({}, connectResponse, {
        abadAccepted: true
      }));
    },
    context: context,
    answers: answers,
    resultsUrl: resultsUrl
  });
};
QuestionnaireLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  children: propTypes.node,
  onStartOver: propTypes.func,
  onUpdatedResults: propTypes.func,
  showProgress: propTypes.bool,
  schema: propTypes.array,
  currentQuestion: propTypes.object,
  isLanding: propTypes.bool,
  answers: propTypes.object,
  onCompletedRequestScreenRender: propTypes.func,
  resultsUrl: propTypes.string
} : {};
QuestionnaireLayout.defaultProps = {
  onStartOver: function onStartOver() {},
  onUpdatedResults: function onUpdatedResults() {}
};

var getLendersFromLocalStorage = function getLendersFromLocalStorage() {
  try {
    return JSON.parse(getItem$1(FINAL_PAGE_RESPONSE));
  } catch (_unused) {
    return null;
  }
};

var _templateObject$3;
var Layout$1 = styled(Flex)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    min-height: 260px;\n    max-width: 960px;\n"])));
var BaseQuestionLayout = function BaseQuestionLayout(_ref) {
  var title = _ref.title,
    description = _ref.description,
    children = _ref.children,
    finePrint = _ref.finePrint;
  return /*#__PURE__*/React.createElement(Layout$1, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: {
      default: 'h4',
      md: 'h3'
    },
    as: "h1",
    marginBottom: "md"
  }, title), description && (typeof description === 'string' ? /*#__PURE__*/React.createElement(Paragraph, {
    marginBottom: "sm"
  }, description) : description), children, finePrint && /*#__PURE__*/React.createElement(Paragraph, null, finePrint));
};
BaseQuestionLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  title: propTypes.node.isRequired,
  description: propTypes.node,
  finePrint: propTypes.string,
  children: propTypes.node
} : {};

var FORM_ACTION_BUTTON_ID = 'mortgage-questionnaire-actionButton';
var QuestionForm = function QuestionForm(_ref) {
  var hasFormActions = _ref.hasFormActions,
    defaultValues = _ref.defaultValues,
    valuesToPersist = _ref.valuesToPersist,
    formatters = _ref.formatters,
    validationSchema = _ref.validationSchema,
    onChange = _ref.onChange,
    onSubmit = _ref.onSubmit,
    formActionLabel = _ref.formActionLabel,
    children = _ref.children;
  var _useState = useState(defaultValues),
    _useState2 = _slicedToArray(_useState, 2),
    castedValues = _useState2[0],
    setCastedValues = _useState2[1];
  var formHookResult = useForm({
    reValidateMode: 'onBlur',
    validationSchema: validationSchema,
    defaultValues: defaultValues
  }, {
    generateFormattersFromSchema: true,
    formatters: formatters,
    setCastedValues: setCastedValues,
    valuesToPersist: valuesToPersist
  });
  var questionnaireSubmitHandler = useCallback(function (formData) {
    return onChange(formData).then(function () {
      return onSubmit(formData);
    });
  }, [onChange, onSubmit]);
  var handleSubmit = formHookResult.handleSubmit;
  return /*#__PURE__*/React.createElement(StyledForm, {
    onSubmit: handleSubmit(questionnaireSubmitHandler)
  }, children(Object.assign({}, formHookResult, {
    castedValues: castedValues
  })), hasFormActions && /*#__PURE__*/React.createElement(FormActions, null, /*#__PURE__*/React.createElement(StyledButton, {
    id: FORM_ACTION_BUTTON_ID,
    buttonType: "primary",
    type: "submit"
  }, formActionLabel)));
};
QuestionForm.propTypes = process.env.NODE_ENV !== "production" ? {
  hasFormActions: propTypes.bool,
  formActionLabel: propTypes.string,
  defaultValues: propTypes.object,
  valuesToPersist: propTypes.arrayOf(propTypes.string),
  formatters: propTypes.object,
  validationSchema: propTypes.instanceOf(zgmYup.mixed).isRequired,
  onChange: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
  children: propTypes.func.isRequired
} : {};
QuestionForm.defaultProps = {
  defaultValues: {},
  valuesToPersist: [],
  formatters: {},
  formActionLabel: 'Next'
};

var tooltipContent = {
  downPayment: {
    body: 'A down payment is the amount of money you spend upfront to purchase a home. It is usually combined with a mortgage to fulfill the total purchase price of a home.',
    trigger: 'down payment'
  },
  additionalCash: {
    body: "Cash-out refinancing allows homeowners to turn some of the equity they've built up in their home into cash.",
    trigger: 'additional cash'
  },
  selfEmployed: {
    body: 'Loans for self-employed borrowers typically require more documentation for items like your income and assets.',
    trigger: 'self-employed'
  },
  bankruptcy: {
    body: 'Bankruptcy is the legal process in which a person declares their inability to pay off their debts. Bankruptcy does not mean you cannot get a loan, but the terms of your loan may not be as favorable.',
    trigger: 'bankruptcy'
  },
  foreclosure: {
    body: 'A foreclosure is the legal process by which a bank or lender sells or repossesses a mortgaged property because the borrower could not pay the loan. A foreclosure does not mean you cannot get a loan, but the terms of your loan may not be as favorable.',
    trigger: 'foreclosure'
  },
  shortSale: {
    body: 'A short sale is a sale of real estate in which the proceeds from selling the property will fall short of the balance of debts. Having a short sale does not mean you cannot get a loan, but the terms of your loan may not be as favorable.',
    trigger: 'short sale'
  },
  realEstateProfessional: {
    body: '"Real estate professionals" includes the real estate agents and brokers, and other professionals, you interact with through Zillow. Zillow Premier Agent is an advertising program that helps connect customers to local real estate professionals. Zillow Premier Agent partners are paid advertisers are and are not affiliated with Zillow, Inc. brokerage or any of its affiliates. Zillow does not endorse any real estate professional, and we may share information about your recent and future site activity with your agent to help them understand what you’re looking for in a home.',
    trigger: 'real estate professionals'
  }
};
var TooltipWithTrigger = function TooltipWithTrigger(_ref) {
  var body = _ref.body,
    trigger = _ref.trigger;
  return /*#__PURE__*/React.createElement(TooltipPopper, {
    triggered: /*#__PURE__*/React.createElement(Tooltip, {
      body: /*#__PURE__*/React.createElement(Paragraph, null, body)
    })
  }, /*#__PURE__*/React.createElement(TriggerText, null, trigger));
};
TooltipWithTrigger.propTypes = process.env.NODE_ENV !== "production" ? {
  body: propTypes.string.isRequired,
  trigger: propTypes.string.isRequired
} : {};

var additionalCash = tooltipContent.additionalCash;
var validationSchema = zgmYup.object({
  cashOut: zgmYup.string().enumeration(NO_YES_OPTIONS)
});
var CashOut = function CashOut(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Do you want to borrow ", /*#__PURE__*/React.createElement(TooltipWithTrigger, additionalCash), " when you refinance?")
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value === null || value === void 0 ? void 0 : value.toString(), _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      vertical: false,
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value === 'true', _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
CashOut.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.bool,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var bankruptcy = tooltipContent.bankruptcy,
  foreclosure = tooltipContent.foreclosure,
  shortSale = tooltipContent.shortSale;
var validationSchema$1 = zgmYup.object({
  creditHistory: zgmYup.string().enumeration(NO_YES_OPTIONS)
});
var CreditHistory = function CreditHistory(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext,
    answers = _ref.answers;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Have you had a ", /*#__PURE__*/React.createElement(TooltipWithTrigger, bankruptcy), ", ", /*#__PURE__*/React.createElement(TooltipWithTrigger, foreclosure), ", or", ' ', /*#__PURE__*/React.createElement(TooltipWithTrigger, shortSale), " in the past ", answers.vaEligible ? 2 : 7, " years?")
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value === null || value === void 0 ? void 0 : value.toString(), _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$1
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      vertical: false,
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value === 'true', _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
CreditHistory.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.bool,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired,
  answers: propTypes.shape({
    vaEligible: propTypes.bool
  }).isRequired
} : {};

var getValidationSchema = function getValidationSchema(entry) {
  return zgmYup.object({
    creditScore: zgmYup.string().enumeration(entry === 'connect' ? CREDIT_SCORE_CONNECT_OPTIONS : CREDIT_SCORE_CQ_OPTIONS, entry !== 'connect' // includeEmptyOption
    ).required()
  });
};
var getDescriptionCopy = function getDescriptionCopy(loanType, context) {
  return "Your credit score " + (context.entry === 'connect' ? 'affects the loan programs and' : 'helps determine the') + " interest rates you may qualify for" + (loanType === 'purchase' ? ", as well as the amount you'll need to put down" : '') + ".";
};

// TODO: ZGMIAIR-1080, ZGMIAIR-970: standardize input value during Purchase Rate routing
var CreditScore = function CreditScore(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    answers = _ref.answers,
    context = _ref.context,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "What's your credit score? It's ok to estimate.",
    description: getDescriptionCopy(answers.loanType, context)
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = context.entry === 'connect' ? value ? "R_" + value.creditScoreLow + "_" + value.creditScoreHigh : 'R_660_719' : value !== null && value !== void 0 ? value : defaultValue, _ref2),
    hasFormActions: context.entry !== 'connect',
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: getValidationSchema(context.entry)
  }, function (_ref3) {
    var fields = _ref3.fields;
    return context.entry === 'connect' ? /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = CREDIT_SCORE_CONNECT_OPTIONS_VALUES[event.target.value], _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    }) : /*#__PURE__*/React.createElement(StyledField, {
      field: fields[name]
    });
  }));
};
CreditScore.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.any,
  defaultValue: propTypes.any,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired,
  context: propTypes.shape({
    entry: propTypes.string
  }),
  answers: propTypes.shape({
    loanType: propTypes.string
  })
} : {};

// Prefer global cache, fall back to bundle-scoped cache
var cachedPromises;
if (global.window) {
  if (!window.mortgageCachedPromises) {
    window.mortgageCachedPromises = {};
  }
  cachedPromises = window.mortgageCachedPromises;
} else {
  cachedPromises = {};
}

/**
 * Example
 * cachedPromise('propertyTaxRate', JSON.stringify(apiInput), () => API.MAX.GET({
 *     action: 'getAnnualPropertyTaxRate',
 *     input: apiInput
 * }))
 *
 *
 * @param name - unique name for this type of promise
 * @param key - unique key to identify input
 * @param createPromise - callback to that returns promise
 * @param cache - optional object specifying where to store cached promises
 * @returns {*}
 */

// Works best with zmm-api promises
function cachedPromise(name, key, createPromise, cache) {
  if (cache === void 0) {
    cache = cachedPromises;
  }
  cache[name] = cache[name] || {};
  cache[name][key] = cache[name][key] || createPromise();
  if (cache[name][key].catch) {
    return cache[name][key].catch(function (e) {
      // Don't cache failed connection or unexpected errors, these may change with repeated requests
      if (!e || e.error === 'UnexpectedError' || e.error === 'ConnectionFailure') {
        delete cache[name][key];
      }
      throw e;
    });
  }
  return cache[name][key];
}

var _zgmYup$object, _formatters;
var downPaymentTooltipContent = tooltipContent.downPayment;
var _properties$errors = {
    properties: {
      AMOUNT: 'downPayment',
      PERCENT: 'downPaymentPercent',
      PROPERTY_VALUE: 'propertyValue'
    },
    errors: {
      AMOUNT: {
        MIN: 'Please enter a number between $0-$100,000,000',
        MAX: 'Please enter a number between $0-$100,000,000',
        GREATER_THAN_VALUE: 'The down payment amount must be less than the loan amount'
      },
      PERCENT: {
        PERCENT: 'Please enter a number between 0%-100%',
        GREATER_THAN_VALUE: 'The down payment amount must be less than the loan amount'
      }
    }
  },
  properties = _properties$errors.properties,
  errors = _properties$errors.errors;
var validationSchema$2 = zgmYup.object((_zgmYup$object = {}, _zgmYup$object[properties.AMOUNT] = zgmYup.float().min(0, errors.AMOUNT.MIN).max(DOLLARS_MAX / 2, errors.AMOUNT.MAX).when(properties.PROPERTY_VALUE, function (propertyValue, amount) {
  return amount.lessThan(propertyValue, errors.AMOUNT.GREATER_THAN_VALUE);
}).required(), _zgmYup$object[properties.PERCENT] = zgmYup.float().min(0, errors.PERCENT.PERCENT).lessThan(100, errors.PERCENT.GREATER_THAN_VALUE).required(), _zgmYup$object));
var formatters = (_formatters = {}, _formatters[properties.PERCENT] = function (number) {
  return Math.round(number * 10) / 10;
}, _formatters);
var DEFAULT_DOWN_PAYMENT_PERCENT = 0.2;

/**
 * 20% for non-VA.
 * $0 for VA, except when loan amount is higher than county loan limit, in which case it is
 * 25% of the difference between the county loan limit and the loan amount being asked for by the borrower.
 */
var calculateDefaultPercentDown = function calculateDefaultPercentDown(propertyValue, militaryHistory, conformingLoanLimit) {
  if (conformingLoanLimit === void 0) {
    conformingLoanLimit = 453100;
  }
  if (!militaryHistory) {
    return Math.round(DEFAULT_DOWN_PAYMENT_PERCENT * propertyValue);
  } else {
    var diff = propertyValue - conformingLoanLimit;
    if (diff <= 0) {
      return 0;
    } else {
      return Math.round(0.25 * diff);
    }
  }
};
var getDownPaymentDefaultValues = function getDownPaymentDefaultValues(downPayment, propertyValue, vaEligible, conformingLoanLimit) {
  if (conformingLoanLimit === void 0) {
    conformingLoanLimit = undefined;
  }
  if (downPayment >= 0 && propertyValue > 0 && downPayment < propertyValue) {
    return {
      downPayment: downPayment,
      // NOTE: downPaymentPercent doesn't get rounded after user change
      downPaymentPercent: Math.round(downPayment / propertyValue * 1000) / 10
    };
  }
  var calculatedDownpayment = calculateDefaultPercentDown(propertyValue, vaEligible, conformingLoanLimit);
  return {
    downPayment: calculatedDownpayment,
    downPaymentPercent: calculatedDownpayment / propertyValue * 100
  };
};
var needsConformingLoanLimit = function needsConformingLoanLimit(answers) {
  var _answers$location;
  return answers.vaEligible && ((_answers$location = answers.location) === null || _answers$location === void 0 ? void 0 : _answers$location.regionId);
};

// Force downpayment dollar or percent value to recalculate based on user input before progressing to next page
var handleEnterKeyDown = function handleEnterKeyDown(event) {
  if (event.key === 'Enter') {
    var _document$getElementB;
    event.preventDefault();
    event.stopPropagation();
    (_document$getElementB = document.getElementById(FORM_ACTION_BUTTON_ID)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus();
  }
};
var DownPayment = function DownPayment(_ref) {
  var value = _ref.value,
    answers = _ref.answers,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  var _useState = useState(function () {
      return !needsConformingLoanLimit(answers) && getDownPaymentDefaultValues(value, answers.propertyValue, answers.vaEligible);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    defaultValues = _useState2[0],
    setDefaultValues = _useState2[1];
  if (!defaultValues) {
    cachedPromise('conformingLoanLimit', answers.location.regionId, function () {
      return API.MAX.GET({
        action: 'getCountyConformingLoanLimit',
        input: {
          partnerId: API.partnerId,
          regionId: answers.location.regionId
        }
      }).then(function (_ref2) {
        var conformingLoanLimit = _ref2.conformingLoanLimit;
        return conformingLoanLimit;
      }).catch(function (error) {
        var _global$DD_RUM, _global$DD_RUM$addErr;
        (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addErr = _global$DD_RUM.addError) === null || _global$DD_RUM$addErr === void 0 ? void 0 : _global$DD_RUM$addErr.call(_global$DD_RUM, new Error('Could not get conforming loan limit'), {
          error: error,
          level: 'warn'
        });
      });
    }).then(function (conformingLoanLimit) {
      return setDefaultValues(getDownPaymentDefaultValues(value, answers.propertyValue, answers.vaEligible, conformingLoanLimit));
    });
  }
  return defaultValues && /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "How much do you have for a ", /*#__PURE__*/React.createElement(TooltipWithTrigger, downPaymentTooltipContent), "?"),
    description: answers.vaEligible ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, {
      marginBottom: "sm"
    }, "Because of your military service, you may be eligible for a $0 down payment VA loan."), /*#__PURE__*/React.createElement(Paragraph, {
      marginBottom: "sm"
    }, "You can make a down payment to lower your monthly mortgage payments, but for most VA loans it is not required.")) : 'Tip: most loans require at least 3% down.'
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: Object.assign({}, defaultValues, {
      propertyValue: answers.propertyValue
    }),
    valuesToPersist: [properties.PROPERTY_VALUE],
    hasFormActions: true,
    onChange: onChange,
    onSubmit: onNext,
    formatters: formatters,
    validationSchema: validationSchema$2
  }, function (_ref3) {
    var _getInputProps = _ref3.getInputProps,
      setValue = _ref3.setValue,
      fieldErrors = _ref3.errors,
      _ref3$castedValues = _ref3.castedValues,
      downPayment = _ref3$castedValues.downPayment,
      downPaymentPercent = _ref3$castedValues.downPaymentPercent,
      propertyValue = _ref3$castedValues.propertyValue;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RHFDownPayment.Labeled, {
      getInputProps: function getInputProps(e) {
        return Object.assign({}, _getInputProps(e), {
          onKeyDown: handleEnterKeyDown
        });
      },
      homePrice: propertyValue,
      downPayment: downPayment,
      downPaymentPercent: downPaymentPercent,
      setValue: setValue,
      errors: fieldErrors,
      size: "lg",
      downPaymentPercentLabel: "Down payment percent"
    }));
  }));
};
DownPayment.propTypes = process.env.NODE_ENV !== "production" ? {
  value: propTypes.any,
  defaultValue: propTypes.any,
  error: propTypes.bool,
  answers: propTypes.shape({
    location: propTypes.shape({
      regionId: propTypes.number
    }),
    propertyValue: propTypes.number,
    vaEligible: propTypes.bool
  }),
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var SCHEMA_SUB_TYPES = types.SCHEMA_SUB_TYPES;
var getValidationSchema$1 = function getValidationSchema() {
  return zgmYup.object({
    email: zgmYup.string().max(255).email().meta({
      subType: SCHEMA_SUB_TYPES.STRING.EMAIL
    }).test('isValid', 'Invalid Email Address', function (email, _ref) {
      return new Promise(function ($return, $error) {
        var createError = _ref.createError;
        // undefined at first rendering
        if (email === undefined) {
          return $return(true);
        }
        return $return(cachedPromise('email', email, function () {
          return API.MAX.POST({
            action: 'parseEmailAddress',
            input: {
              partnerId: API.partnerId,
              emailAddress: email
            }
          });
        }).then(function () {
          return true;
        }, function (response) {
          if (response && response.error === 'InvalidEmailAddress') {
            trackEvent({
              category: 'Mortgages',
              action: "input validation fail: email",
              label: getTrackingLabel()
            });
            return createError({
              message: 'Please enter a valid email.'
            });
          } else {
            return createError({
              message: 'Connection lost, please try again later.'
            });
          }
        }));
      });
    }).required()
  });
};
var Email = function Email(_ref2) {
  var _ref3;
  var name = _ref2.name,
    value = _ref2.value,
    context = _ref2.context,
    onChange = _ref2.onChange,
    onNext = _ref2.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Nice to meet you. What's your email address?",
    description: "Your information is protected by TLS encryption."
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref3 = {}, _ref3[name] = value, _ref3),
    hasFormActions: true,
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: getValidationSchema$1()
  }, function (_ref4) {
    var fields = _ref4.fields;
    return /*#__PURE__*/React.createElement(StyledField, {
      placeholder: "example@email.com",
      field: fields[name],
      autoComplete: "off",
      "data-dd-privacy": "mask-user-input"
    });
  }));
};
Email.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.any,
  context: propTypes.object.isRequired,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var onSubmit = function onSubmit(answers, context) {
  var _global$DD_RUM, _global$DD_RUM$addAct;
  (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addAct = _global$DD_RUM.addAction) === null || _global$DD_RUM$addAct === void 0 ? void 0 : _global$DD_RUM$addAct.call(_global$DD_RUM, 'mortgage-questionnaire:submitted', {
    entry: 'Connect',
    originalEntry: context.originalEntry,
    loanType: answers.loanType
  });
  sendTrackEventOnSubmitLongForm();
};

// Connect final page
var FinalPage = function FinalPage(_ref) {
  var name = _ref.name,
    answers = _ref.answers,
    context = _ref.context,
    onNext = _ref.onNext,
    onSuccess = _ref.onSuccess,
    ConnectSuccess = _ref.components.ConnectSuccess;
  var _useState = useState(function () {
      var response = global.window.history.state;
      if (response !== null && response !== void 0 && response.contactId && response !== null && response !== void 0 && response.primaryLender) {
        return response;
      }
      return {};
    }),
    _useState2 = _slicedToArray(_useState, 2),
    contactLenderResponse = _useState2[0],
    setContactLenderResponse = _useState2[1];
  if (contactLenderResponse !== null && contactLenderResponse !== void 0 && contactLenderResponse.contactId && contactLenderResponse !== null && contactLenderResponse !== void 0 && contactLenderResponse.primaryLender) {
    return /*#__PURE__*/React.createElement(ConnectSuccess, {
      contactLenderResponse: contactLenderResponse,
      answers: answers,
      context: context
    });
  }
  return /*#__PURE__*/React.createElement(Searching, {
    name: name,
    answers: answers,
    context: context,
    onNext: onNext,
    onSuccess: onSuccess,
    components: {
      ConnectSuccess: ConnectSuccess
    },
    contactLenderResponse: contactLenderResponse,
    setContactLenderResponse: setContactLenderResponse
  });
};
FinalPage.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string,
  answers: propTypes.object,
  context: propTypes.object,
  onNext: propTypes.func.isRequired,
  onSuccess: propTypes.func,
  components: propTypes.shape({
    ConnectSuccess: propTypes.elementType
  })
} : {};
function Searching(_ref2) {
  var name = _ref2.name,
    answers = _ref2.answers,
    context = _ref2.context,
    onNext = _ref2.onNext,
    onSuccess = _ref2.onSuccess,
    ConnectSuccess = _ref2.components.ConnectSuccess,
    contactLenderResponse = _ref2.contactLenderResponse,
    setContactLenderResponse = _ref2.setContactLenderResponse;
  // avoid loading state, where affiliateSearch is already known in most cases
  var longFormContactPossibleResponseOrPromise = getLongFormContactPossible(answers, context);
  useEffect(function () {
    var getLenders = function getLenders() {
      return new Promise(function ($return, $error) {
        var _await$longFormContac, longFormContactPossible, affiliateDibs, response;
        return Promise.resolve(longFormContactPossibleResponseOrPromise.catch(function (error) {
          var _global$DD_RUM2, _global$DD_RUM2$addEr;
          (_global$DD_RUM2 = global.DD_RUM) === null || _global$DD_RUM2 === void 0 ? void 0 : (_global$DD_RUM2$addEr = _global$DD_RUM2.addError) === null || _global$DD_RUM2$addEr === void 0 ? void 0 : _global$DD_RUM2$addEr.call(_global$DD_RUM2, error, {
            action: 'verify contact possible in final page',
            answers: _omit(answers, PII_QUESTIONS_ROUTES),
            context: context
          });
          return {};
        })).then(function ($await_1) {
          try {
            _await$longFormContac = $await_1, longFormContactPossible = _await$longFormContac.longFormContactPossible, affiliateDibs = _await$longFormContac.affiliateDibs;
            if (!longFormContactPossible) {
              track({
                category: 'Mortgages',
                action: "page view: Final:failure",
                label: getTrackingLabel()
              });
              track({
                category: 'Mortgages',
                action: 'failure reason: No lenders found',
                label: getTrackingLabel()
              });
              return $return(onNext({
                notFound: 'No lenders found'
              }));
            }
            onSubmit(answers, context);
            return Promise.resolve(contactLongFormLender(answers, context, affiliateDibs).catch(function (error) {
              return setContactLenderResponse(function () {
                var _error$cause;
                if (INVALID_CONTACT_ERRORS.includes(error === null || error === void 0 ? void 0 : (_error$cause = error.cause) === null || _error$cause === void 0 ? void 0 : _error$cause.error)) {
                  return;
                } else {
                  // handled in Error boundary
                  throw error;
                }
              });
            })).then(function ($await_2) {
              try {
                response = $await_2;
                if (!response) {
                  return $return(onNext({
                    notFound: INVALID_DATA
                  }));
                }
                track({
                  category: 'Mortgages',
                  action: 'page view: Final:success',
                  label: getTrackingLabel()
                }, {
                  newLaneEvent: generateConnectLeadSubmitEvent(context.landingPage)
                });

                // legacy event signal to link backend data from tracking
                track({
                  category: 'Mortgages',
                  action: 'longform:completed',
                  label: JSON.stringify({
                    contactType: answers.loanType,
                    landingPage: window.location.pathname,
                    page: 'searching',
                    failed: false,
                    contactId: response.contactId,
                    gaClientId: response.gaClientId
                  })
                });
                track({
                  category: 'Mortgages',
                  action: "success: connected to a lender from " + context.originalEntry.toUpperCase(),
                  label: JSON.stringify(Object.assign({}, getTrackingLabel(true), {
                    contactType: answers.loanType,
                    page: 'searching',
                    failed: false,
                    contactId: response.contactId,
                    gaClientId: response.gaClientId
                  }))
                });
                setItem$1(FINAL_PAGE_RESPONSE, Object.assign({}, response, {
                  answers: answers
                }));
                setContactLenderResponse(response);
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                window.history.replaceState(Object.assign({}, window.history.state, response), name, "#" + name);
                notifyNativeAppFormComplete();
                return $return();
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }, $error);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    };
    getLenders();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return contactLenderResponse !== null && contactLenderResponse !== void 0 && contactLenderResponse.contactId ? /*#__PURE__*/React.createElement(ConnectSuccess, {
    contactLenderResponse: contactLenderResponse,
    answers: answers,
    context: context
  }) : /*#__PURE__*/React.createElement(React.Fragment, null);
}
Searching.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string,
  answers: propTypes.object.isRequired,
  context: propTypes.object.isRequired,
  onNext: propTypes.func.isRequired,
  onSuccess: propTypes.func,
  components: propTypes.shape({
    ConnectSuccess: propTypes.elementType
  }),
  contactLenderResponse: propTypes.object,
  setContactLenderResponse: propTypes.func
} : {};

var getValidationSchema$2 = function getValidationSchema(name) {
  var _zgmYup$object;
  return zgmYup.object((_zgmYup$object = {}, _zgmYup$object[name] = zgmYup.string().enumeration(NO_YES_OPTIONS), _zgmYup$object));
};
var FirstTime = function FirstTime(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Let's get started. Are you a first time home buyer?"
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value === null || value === void 0 ? void 0 : value.toString(), _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: getValidationSchema$2(name)
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      vertical: false,
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value === 'true', _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
FirstTime.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.bool,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var validationSchema$3 = zgmYup.object({
  hasAgent: zgmYup.string().enumeration(NO_YES_OPTIONS)
});
var HasAgent = function HasAgent(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Do you have a real estate agent?"
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value === null || value === void 0 ? void 0 : value.toString(), _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$3
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      vertical: false,
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value === 'true', _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
HasAgent.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.bool,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var validationSchema$4 = function validationSchema(propertyValue) {
  return zgmYup.object({
    helocAmount: zgmYup.float().positive().dollar().min(25000).max(propertyValue, 'Amount must be less than property value').round().convertEmptyToNull().nullable().required()
  });
};
var HelocAmount = function HelocAmount(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    onNext = _ref.onNext,
    answers = _ref.answers;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "How much would you like to borrow?",
    description: "$25,000 minimum"
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value !== null && value !== void 0 ? value : defaultValue, _ref2),
    hasFormActions: true,
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$4(answers.propertyValue)
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledField, {
      field: fields[name],
      focus: true
    });
  }));
};
HelocAmount.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.any,
  defaultValue: propTypes.any,
  answers: propTypes.shape({
    propertyValue: propTypes.number
  }),
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var validationSchema$5 = zgmYup.object({
  homeOwner: zgmYup.string().enumeration(NO_YES_OPTIONS)
});
var HomeOwner = function HomeOwner(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Do you currently own a home?"
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value === null || value === void 0 ? void 0 : value.toString(), _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$5
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      "aria-label": "Home owner",
      field: fields[name],
      vertical: false,
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value === 'true', _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
HomeOwner.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.bool,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var validationSchema$6 = zgmYup.object({
  income: zgmYup.float().positive().max(INCOME_MAX).dollar().convertEmptyToNull().nullable().required()
});
var Income = function Income(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Great. What's your annual income before taxes?",
    description: "This helps determine the amount you qualify for."
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value !== null && value !== void 0 ? value : defaultValue, _ref2),
    hasFormActions: true,
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$6
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledField, {
      field: fields[name],
      focus: true
    });
  }));
};
Income.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.any,
  defaultValue: propTypes.any,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var _JOURNEY_STAGE_OPTION;
var JOURNEY_STAGE = {
  LOOKING: 'LookingAtListings',
  TOURING: 'TouringHomes',
  MAKING_OFFER: 'MakingOffer',
  UNDER_CONTRACT: 'UnderContract',
  // new values under AB testing, they should map to existing values in API requests
  ESTIMATED_AFFORDABILITY: 'EstimatedAffordability',
  PREAPPROVED_OR_PREQUALIFIED: 'PreapprovedOrPrequalified',
  MAKING_OFFER_OR_UNDER_CONTRACT: 'MakingOfferOrUnderContract',
  LOOKING_OR_TOURING: 'LookingAtListingsOrTouringHomes',
  WORKING_WITH_AGENT: 'WorkingWithAgent'
};
var JOURNEY_STAGE_OPTIONS = (_JOURNEY_STAGE_OPTION = {}, _JOURNEY_STAGE_OPTION[JOURNEY_STAGE.ESTIMATED_AFFORDABILITY] = 'Figuring out what I can afford', _JOURNEY_STAGE_OPTION[JOURNEY_STAGE.LOOKING] = 'Just looking at listings', _JOURNEY_STAGE_OPTION[JOURNEY_STAGE.TOURING] = 'Touring homes', _JOURNEY_STAGE_OPTION[JOURNEY_STAGE.PREAPPROVED_OR_PREQUALIFIED] = 'Pre-approved or pre-qualified', _JOURNEY_STAGE_OPTION[JOURNEY_STAGE.MAKING_OFFER_OR_UNDER_CONTRACT] = 'Making offers or under contract', _JOURNEY_STAGE_OPTION);

var validationSchema$7 = zgmYup.object({
  journeyStage: zgmYup.string().enumeration(JOURNEY_STAGE_OPTIONS)
});
var JourneyStage = function JourneyStage(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "How far along are you in the process?"
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value, _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$7
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value, _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
JourneyStage.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.string,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var LANGUAGE_OPTIONS = {
  English: 'English',
  Spanish: 'Spanish',
  French: 'French',
  Mandarin: 'Mandarin',
  Cantonese: 'Cantonese',
  Other: 'Other'
};
var validationSchema$8 = zgmYup.object({
  language: zgmYup.string().enumeration(LANGUAGE_OPTIONS)
});
var Language = function Language(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Which language do you prefer?"
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value, _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$8
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value, _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
Language.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.string,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var now$1 = function now() {
  return new Date().toISOString();
};
var generateAbadModalCloseEvent = function generateAbadModalCloseEvent(abadContent, abadVersion, isPAABADModal) {
  var newLaneEvent = {
    envelope: {
      event_template_id: '131',
      event_template_version_id: '1',
      event_type_id: '2178',
      event_type_version_id: '1',
      event_client_start_dtm: now$1()
    },
    clickstream_trigger: {
      trigger_location_nm: 'zgmi_connect_funnel',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'abad',
      trigger_source_nm: 'abad_close_button',
      input_selector_nm: 'mouse'
    },
    semantic: {
      semantic_event_nm: 'abad_close',
      topic_tag_txt: ['zgmi', 'zhl']
    },
    abad_info: {
      abad_context_txt: abadContent,
      abad_version_txt: abadVersion,
      abad_close_button_txt: isPAABADModal ? 'Close' : 'See your results'
    }
  };
  return newLaneEvent;
};
var generateConnectResultsView = function generateConnectResultsView(answers, landingPage, lenderContactId, lenderId, isMatchedLender, numLenderMatches) {
  var newLaneEvent = {
    envelope: {
      event_template_id: '157',
      event_template_version_id: '1',
      event_type_id: '2182',
      event_type_version_id: '1',
      event_client_start_dtm: now$1()
    },
    clickstream_trigger: {
      trigger_location_nm: 'zgmi_connect_funnel',
      trigger_type_nm: 'impression',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: isMatchedLender ? 'zgmi_connect_lendermatch' : 'zgmi_connect_nolenderfound'
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zgmi_connect', 'zhl', 'zgmi']
    },
    zgmi_lender_info: {
      lender: isMatchedLender ? lenderId : 'zgmi_no_lender_found'
    },
    zgmi_connect_funnel: getConnectFunnelBlock(answers, landingPage, lenderContactId, numLenderMatches)
  };
  return newLaneEvent;
};

var RegionFailure = function RegionFailure(_ref) {
  var state = _ref.state,
    directoryURL = _ref.directoryURL;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, null, "Sorry, we can't offer lenders in ", state, " at this time. But you can search for a local lender using our", ' ', /*#__PURE__*/React.createElement(Anchor, {
    href: directoryURL
  }, "lender directory"), "."), /*#__PURE__*/React.createElement(Paragraph, {
    marginTop: "xs"
  }, "Please note: this was not an application for credit and you may still qualify for a loan."));
};
RegionFailure.propTypes = process.env.NODE_ENV !== "production" ? {
  state: propTypes.string,
  directoryURL: propTypes.string
} : {};
var HelocFailure = function HelocFailure(_ref2) {
  var ratesURL = _ref2.ratesURL,
    directoryURL = _ref2.directoryURL;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, null, "Sorry. We weren\u2019t able to find any lenders in your area to assist you, but your options are:"), /*#__PURE__*/React.createElement(List, {
    marginTop: "xs",
    marginLeft: "sm",
    appearance: "number"
  }, /*#__PURE__*/React.createElement(List.Item, null, /*#__PURE__*/React.createElement(Anchor, {
    href: zillowURL('mortgages/refinance/', true)
  }, "See if you qualify for a cash-out refinance")), /*#__PURE__*/React.createElement(List.Item, null, "Find a lender by checking ", /*#__PURE__*/React.createElement(Anchor, {
    href: ratesURL
  }, "mortgage rates")), /*#__PURE__*/React.createElement(List.Item, null, "Find a lender in our ", /*#__PURE__*/React.createElement(Anchor, {
    href: directoryURL
  }, "lender directory"))));
};
HelocFailure.propTypes = process.env.NODE_ENV !== "production" ? {
  ratesURL: propTypes.string,
  directoryURL: propTypes.string
} : {};
var GenericFailurePage = function GenericFailurePage(_ref3) {
  var ratesURL = _ref3.ratesURL,
    directoryURL = _ref3.directoryURL;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, null, "Sorry, no participating lenders are available at this time."), /*#__PURE__*/React.createElement(Paragraph, {
    marginTop: "sm"
  }, "Please note: this was not an application for credit and you may still qualify for a loan."), /*#__PURE__*/React.createElement(Spacer, {
    marginTop: "sm"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "6"
  }, "Here are some options to explore:"), /*#__PURE__*/React.createElement(List, {
    marginTop: "xs",
    marginLeft: "sm",
    appearance: "number"
  }, /*#__PURE__*/React.createElement(List.Item, null, "Find a lender in our ", /*#__PURE__*/React.createElement(Anchor, {
    href: directoryURL
  }, "lender directory")), /*#__PURE__*/React.createElement(List.Item, null, "Find a lender by checking ", /*#__PURE__*/React.createElement(Anchor, {
    href: ratesURL
  }, "mortgage rates")))));
};
GenericFailurePage.propTypes = process.env.NODE_ENV !== "production" ? {
  ratesURL: propTypes.string,
  directoryURL: propTypes.string
} : {};
var directoryURL = zillowURL('/lender-directory/');
var ratesURL = zillowURL('/mortgage-rates/');
var LenderNotFound = function LenderNotFound(_ref4) {
  var answers = _ref4.answers,
    context = _ref4.context;
  useEffect(function () {
    var _history$state$reason, _history$state;
    track({
      category: 'Mortgages',
      action: "failure reason: " + ((_history$state$reason = (_history$state = history.state) === null || _history$state === void 0 ? void 0 : _history$state.reason) !== null && _history$state$reason !== void 0 ? _history$state$reason : 'Unknown reason'),
      label: getTrackingLabel()
    }, {
      newLaneEvent: generateConnectNoLenderEvent()
    });
    event(generateConnectResultsView(answers, context.landingPage, 'zgmi_connect_nolenderfound', false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    as: "h1",
    marginBottom: "sm"
  }, "No Lenders Found"), answers.loanType === 'heloc' ? /*#__PURE__*/React.createElement(HelocFailure, {
    ratesURL: ratesURL,
    directoryURL: directoryURL
  }) : /*#__PURE__*/React.createElement(GenericFailurePage, {
    ratesURL: ratesURL,
    directoryURL: directoryURL
  }), /*#__PURE__*/React.createElement(TextButton, {
    marginTop: "sm",
    onClick: function onClick(e) {
      var _history$state2;
      e.preventDefault();
      // ZGMIAIR-4696 stop-gap solution. must go 2 back to phone page otherwise
      //   user is caught in redirect loop on searching page
      if (((_history$state2 = history.state) === null || _history$state2 === void 0 ? void 0 : _history$state2.reason) === INVALID_DATA) {
        window.history.go(-2);
      } else {
        window.history.back();
      }
    }
  }, "Go back"));
};
LenderNotFound.propTypes = process.env.NODE_ENV !== "production" ? {
  answers: propTypes.shape({
    loanType: propTypes.string,
    location: propTypes.shape({
      state: propTypes.string
    })
  }),
  context: propTypes.shape({
    landingPage: propTypes.string,
    entry: propTypes.string
  })
} : {};
LenderNotFound.defaultProps = {
  answers: {}
};

// TODO: unify default value of 200000 vs 300000 in CQ vs Connect, or make it a formula
var LoanBalance = function LoanBalance(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    answers = _ref.answers,
    defaultValue = _ref.defaultValue,
    context = _ref.context,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  var maxLoanBalance = 2 * answers.propertyValue;
  var validationSchema = zgmYup.object({
    loanBalance: zgmYup.float().moreThan(0).min(LOAN_BALANCE_MIN, "Please enter an amount greater than " + dollar(LOAN_BALANCE_MIN)).max(maxLoanBalance, "Please enter an amount less than " + dollar(maxLoanBalance)).dollar().convertEmptyToNull().nullable().required()
  });
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: context.entry === 'connect' ? "What's your balance of your current loan?" : "What's your current loan balance?",
    description: "It's ok to estimate."
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value !== null && value !== void 0 ? value : context.entry === 'connect' ? 300000 : defaultValue, _ref2),
    hasFormActions: true,
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledField, {
      field: fields[name],
      focus: true
    });
  }));
};
LoanBalance.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.any,
  answers: propTypes.shape({
    propertyValue: propTypes.number
  }),
  defaultValue: propTypes.any,
  error: propTypes.bool,
  context: propTypes.shape({
    entry: propTypes.string.isRequired
  }),
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var _templateObject$4;
var StyledPageContent = styled(PageContent)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    background-color: ", ";\n    border: 1px solid ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    text-align: left;\n"])), token('colors.backgroundWhite'), token('colors.borderLight'), spaceMixin('sm'), spaceMixin('sm'));
var ZHLHeroDisclaimer = function ZHLHeroDisclaimer(_ref) {
  var brand = _ref.brand;
  var isTrulia = brand.toLowerCase() === 'trulia';
  return /*#__PURE__*/React.createElement(StyledPageContent, null, isTrulia ? /*#__PURE__*/React.createElement(Text, {
    fontType: "finePrint"
  }, "Zillow Home Loans, LLC (ZHL) is a participating lender, an affiliate of Zillow Group Marketplace, Inc. (sometimes doing business as Trulia Mortgages or Trulia), and may be selected first based on data supplied by users. Non-selection does not constitute credit denial. Users are always invited to apply to ZHL. You are not required to use ZHL and are encouraged to shop around and compare loan terms of other lenders. Other lenders are selected based on their location, customer reviews, and other data supplied by users.") : /*#__PURE__*/React.createElement(Text, {
    fontType: "finePrint"
  }, "Zillow Home Loans, LLC (ZHL) is a participating lender, an affiliate of ZGMI, and may be selected first based on data supplied by users. Non-selection does not constitute credit denial. Users are always invited to apply to ZHL. You are not required to use ZHL and are encouraged to shop around and compare loan terms of other lenders. Other lenders are selected based on their location, customer reviews, and other data supplied by users."));
};
ZHLHeroDisclaimer.propTypes = process.env.NODE_ENV !== "production" ? {
  brand: propTypes.string
} : {};
ZHLHeroDisclaimer.defaultProps = {
  brand: 'zillow'
};

var _templateObject$5, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$1;
var MINIMUM_INPUT_LENGTH = 3;
var autocompletePath = process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development' ? TEST_URL_AUTOCOMPLETE : PROD_URL_AUTOCOMPLETE;
var whereAmI;
var getWhereAmI = function getWhereAmI() {
  return API.MAX.GET({
    action: 'whereAmI',
    input: {
      partnerId: API.partnerId
    }
  }).then(function (response) {
    whereAmI = response && {
      name: response.name,
      regionId: response.regionId,
      zipCode: response.zipCode,
      city: response.cityName,
      county: response.countyName,
      state: response.stateAbbreviation,
      latitude: response.latitude,
      longitude: response.longitude
    };
    return whereAmI;
  });
};

// duplicated functionality from: src/common/js/fetchAutoCompleteLocations.js
var fetchAutoCompleteLocations = function fetchAutoCompleteLocations(input) {
  var latLongQuery = whereAmI ? "&userLon=" + whereAmI.longitude + "&userLat=" + whereAmI.latitude : '';
  return fetch(autocompletePath + "?q=" + input + latLongQuery + "&resultTypes=city,zipCode,county", {
    headers: {
      'Content-Type': 'text/plain'
    },
    timeout: 500
  }).then(function (res) {
    return res.json();
  }).then(function (_ref) {
    var results = _ref.results;
    return results;
  }).catch(function () {
    return [];
  });
};
var fetchLocations = _debounce(function (input, setLocations, setError) {
  fetchAutoCompleteLocations(input).then(function (locations) {
    var formattedLocations = locations === null || locations === void 0 ? void 0 : locations.map(function (result) {
      var _result$metaData, _result$metaData2, _result$metaData3, _result$metaData4, _result$metaData5;
      return {
        name: result.display,
        regionId: (_result$metaData = result.metaData) === null || _result$metaData === void 0 ? void 0 : _result$metaData.regionId,
        zipCode: (_result$metaData2 = result.metaData) === null || _result$metaData2 === void 0 ? void 0 : _result$metaData2.zipCode,
        // optional
        city: (_result$metaData3 = result.metaData) === null || _result$metaData3 === void 0 ? void 0 : _result$metaData3.city,
        county: (_result$metaData4 = result.metaData) === null || _result$metaData4 === void 0 ? void 0 : _result$metaData4.county,
        state: (_result$metaData5 = result.metaData) === null || _result$metaData5 === void 0 ? void 0 : _result$metaData5.state
      };
    });
    setLocations(formattedLocations);
    setError(!locations.length);
  });
}, 500);
var QuestionForm$1 = styled(StyledForm)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: ", ";\n"])), spaceMixin('md'));
var StyledCombobox = styled(Combobox)(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    min-height: 64px;\n"])));
var LandingInput = styled(Input)(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n    ", "\n"])), mediaMixin('md', 'padding-right: 8em;'));
var LandingButton = styled(Button)(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    ", "\n"])), mediaMixin('md', css(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n            width: auto;\n            position: absolute;\n            margin-right: 0;\n            top: 4px;\n            right: 0;\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n        "])))));
var AbsolutePositionedFormHelp = styled(FormHelp)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n"])));
var QUESTION_TEXT = 'Where are you buying/refinancing?';
var CTA_GET_STARTED_TEXT = 'Get started';
var CTA_NEXT_TEXT = 'Next';

/**
 * Mortgage location input, take any location input but only saves zip code
 */
var LocationQuestion = function LocationQuestion(_ref2) {
  var _inputObject$name, _inputObject$name2;
  var name = _ref2.name,
    value = _ref2.value,
    onChange = _ref2.onChange,
    onNext = _ref2.onNext,
    showLanding = _ref2.showLanding,
    context = _ref2.context,
    isLanding = _ref2.isLanding;
  // NOTE: inputObject has name, regionId, zipCode, but only zipCode is saved externally
  var _useState = useState({
      name: value === null || value === void 0 ? void 0 : value.name,
      regionId: undefined,
      zipCode: undefined,
      city: undefined,
      county: undefined,
      state: undefined,
      supportsMortgage: undefined
    }),
    _useState2 = _slicedToArray(_useState, 2),
    inputObject = _useState2[0],
    setInputObject = _useState2[1];
  var _useState3 = useState(!inputObject.name),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1]; // because setting value doesn't re-render ComboBox
  var ctaButtonText = showLanding && isLanding ? CTA_GET_STARTED_TEXT : CTA_NEXT_TEXT;
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    locations = _useState6[0],
    setLocations = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  useEffect(function () {
    event(generateMortgageFunnelCTAViewEvent(window.location.pathname, CTA_GET_STARTED_TEXT));
    //place mortgage landing page view here if you only want it on the location question
    if (!inputObject.name) {
      Promise.resolve(whereAmI || getWhereAmI()).then(function (output) {
        !inputObject.name && setInputObject(output);
        setLoading(false);
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleOnChange = useCallback(function (locationName) {
    var _locationName$trim;
    setError(false);
    setInputObject(locations.find(function (location) {
      return location.name === locationName;
    }) || {
      name: locationName
    });
    if ((locationName === null || locationName === void 0 ? void 0 : (_locationName$trim = locationName.trim()) === null || _locationName$trim === void 0 ? void 0 : _locationName$trim.length) >= MINIMUM_INPUT_LENGTH) {
      fetchLocations(locationName, setLocations, setError);
    } else {
      setLocations([]);
    }
  }, [locations]);
  var validateAndNext = function validateAndNext(e) {
    return new Promise(function ($return, $error) {
      var _locationInfo$locatio, _onNext, locationInfo, zipCode, newLaneEvent, newLocation;
      e.preventDefault();
      if (!inputObject || !(inputObject.regionId || inputObject.zipCode || inputObject.name)) {
        setError(true);
        return $return();
      }
      return Promise.resolve(API.MAX.GET({
        action: 'getZIPCodeLocation',
        input: {
          partnerId: API.partnerId,
          locationRef: inputObject.regionId ? {
            regionId: inputObject.regionId
          } : inputObject.zipCode ? {
            zipCode: inputObject.zipCode
          } : {
            location: inputObject.name
          }
        }
      }).catch(function () {})).then(function ($await_1) {
        try {
          locationInfo = $await_1;
          zipCode = locationInfo === null || locationInfo === void 0 ? void 0 : (_locationInfo$locatio = locationInfo.location) === null || _locationInfo$locatio === void 0 ? void 0 : _locationInfo$locatio.zipCode;
          if (!zipCode) {
            setError(true);
            return $return();
          }
          if (!locationInfo.supportsMortgage) {
            setError('Sorry, participating lenders only operate in the 50 U.S. states and the District of Columbia.');
            return $return();
          }
          event(generateMortgageFunnelCTAClickEvent(window.location.pathname, CTA_GET_STARTED_TEXT));
          if (context.entry === 'connect') {
            newLaneEvent = generateConnectLeadStartEvent(context.landingPage, QUESTION_TEXT, [ctaButtonText]);
          } else if (context.entry === 'cq') {
            newLaneEvent = generateCQLeadStartEvent(context.landingPage, QUESTION_TEXT, [ctaButtonText]);
          }
          if (newLaneEvent) {
            event(newLaneEvent);
          }
          newLocation = {
            name: locationInfo.location.zipCode,
            // to convert prepopulation value to zipCode
            regionId: locationInfo.location.regionId,
            zipCode: locationInfo.location.zipCode,
            city: locationInfo.location.cityName,
            county: locationInfo.location.countyName,
            state: locationInfo.location.stateAbbreviation,
            supportsMortgage: locationInfo.supportsMortgage
          };
          return Promise.resolve(onChange(newLocation)).then(function ($await_2) {
            try {
              onNext((_onNext = {}, _onNext[name] = newLocation, _onNext));
              return $return();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var InputComponent = showLanding ? LandingInput : Input;
  var renderInput = useCallback(function (_ref3) {
    var onClear = _ref3.onClear,
      onTagClose = _ref3.onTagClose,
      rest = _objectWithoutProperties(_ref3, ["onClear", "onTagClose"]);
    return /*#__PURE__*/React.createElement(FormField, {
      marginBottom: "sm",
      controlId: "location-input",
      label: /*#__PURE__*/React.createElement(Label, {
        required: false,
        size: "lg",
        fontColor: context.themeDark ? 'textWhite' : 'textDark'
      }, QUESTION_TEXT),
      control: /*#__PURE__*/React.createElement(InputComponent, _extends({}, rest, {
        placeholder: "City, ZIP code, or county",
        autoComplete: "off",
        error: error
      })),
      description: error && /*#__PURE__*/React.createElement(AbsolutePositionedFormHelp, {
        error: true,
        role: "alert"
      }, error === true ? "Sorry, we couldn't find that location" : error),
      required: true
    });
  }, [error, context.themeDark]);
  var ButtonComponent = showLanding ? LandingButton : Button;
  var submitButtonRef = React.useRef(null);
  var handleOptionSelect = function handleOptionSelect(eventValue, action) {
    return (action === null || action === void 0 ? void 0 : action.reason) === 'click' && Promise.resolve().then(function () {
      var _submitButtonRef$curr, _submitButtonRef$curr2;
      return (_submitButtonRef$curr = submitButtonRef.current) === null || _submitButtonRef$curr === void 0 ? void 0 : (_submitButtonRef$curr2 = _submitButtonRef$curr.click) === null || _submitButtonRef$curr2 === void 0 ? void 0 : _submitButtonRef$curr2.call(_submitButtonRef$curr);
    });
  };
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: /*#__PURE__*/React.createElement(Text, {
      fontType: {
        default: 'h4',
        md: 'h3'
      },
      fontColor: context.themeDark ? 'textWhite' : 'textDark'
    }, isLanding ? context.title : context.entry === 'connect' ? 'Where are you looking to buy or refinance?' : "Compare Today's Mortgage Rates"),
    description: /*#__PURE__*/React.createElement(Paragraph, {
      fontColor: context.themeDark ? 'textWhite' : 'textDark',
      fontType: context.themeDark ? 'h6' : 'body',
      marginBottom: "sm"
    }, isLanding && context.description ? context.description : context.entry === 'connect' ? '' : 'Answer a few questions about your loan preferences to compare mortgage rates from multiple lenders.'),
    finePrint: context.entry === 'connect' ? undefined : 'Rates can vary by location.'
  }, context.landingPage !== 'heloc' && /*#__PURE__*/React.createElement(QuestionForm$1, {
    onSubmit: validateAndNext
  }, loading ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      minHeight: '64px'
    }
  }, renderInput({})) : /*#__PURE__*/React.createElement(StyledCombobox, {
    freeForm: true,
    allowSubmitWhileOpen: true,
    autoCompleteBehavior: "none",
    value: (_inputObject$name = inputObject === null || inputObject === void 0 ? void 0 : inputObject.name) !== null && _inputObject$name !== void 0 ? _inputObject$name : '',
    renderInput: renderInput,
    options: (inputObject === null || inputObject === void 0 ? void 0 : (_inputObject$name2 = inputObject.name) === null || _inputObject$name2 === void 0 ? void 0 : _inputObject$name2.length) >= MINIMUM_INPUT_LENGTH && locations ? locations.map(function (location) {
      return location.name;
    }) : [],
    onChange: handleOnChange,
    onOptionSelect: handleOptionSelect,
    renderEmptyState: null
  }), /*#__PURE__*/React.createElement(ButtonComponent, {
    ref: submitButtonRef,
    type: "submit",
    marginY: "md",
    buttonType: "primary"
  }, ctaButtonText), context.entry === 'connect' && /*#__PURE__*/React.createElement(ZHLHeroDisclaimer, {
    brand: context.brand
  })));
};
LocationQuestion.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string,
  value: propTypes.shape({
    name: propTypes.string,
    regionId: propTypes.number,
    zipCode: propTypes.string
  }),
  onChange: propTypes.func,
  onNext: propTypes.func,
  showLanding: propTypes.bool,
  context: propTypes.shape({
    brand: propTypes.string,
    title: propTypes.string,
    description: propTypes.string,
    entry: propTypes.string,
    landingPage: propTypes.string,
    themeDark: propTypes.bool
  }),
  isLanding: propTypes.bool
} : {};

var LOAN_TYPE_OPTIONS = {
  purchase: 'Purchase',
  refinance: 'Refinance'
};
var CONNECT_LOAN_TYPE_OPTIONS = {
  purchase: 'Purchase a home',
  refinance: 'Refinance my home',
  heloc: 'Get a Home Equity Line of Credit (HELOC)'
};
var CONNECT_VA_LOAN_TYPE_OPTIONS = {
  purchase: 'VA purchase loan',
  refinance: 'VA IRRRL refinance loan'
};
var getValidationSchema$3 = function getValidationSchema(name, entry, vaEligible) {
  var _zgmYup$object;
  return zgmYup.object((_zgmYup$object = {}, _zgmYup$object[name] = zgmYup.string().enumeration(entry === 'connect' ? vaEligible ? CONNECT_VA_LOAN_TYPE_OPTIONS : CONNECT_LOAN_TYPE_OPTIONS : LOAN_TYPE_OPTIONS), _zgmYup$object));
};
var getTitle = function getTitle(currentEntry, vaEligible, isVariant) {
  if (currentEntry === 'connect') {
    if (vaEligible) {
      return 'Which loan type are you interested in?';
    }
    return isVariant ? 'What would you like help with?' : 'What are you trying to do?';
  }
  return isVariant ? 'What type of loan are you looking for?' : 'What type of rates are you looking for?';
};
var LoanType = function LoanType(_ref) {
  var _context$originalEntr, _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext,
    answers = _ref.answers,
    context = _ref.context,
    config = _ref.config;
  var currentEntry = (_context$originalEntr = context.originalEntry) !== null && _context$originalEntr !== void 0 ? _context$originalEntr : context.entry;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: getTitle(currentEntry, answers.vaEligible, config.isVariant)
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value, _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: getValidationSchema$3(name, currentEntry, answers.vaEligible)
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      "aria-label": "Loan type",
      field: fields[name],
      vertical: currentEntry === 'connect',
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value, _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
LoanType.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.string,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired,
  answers: propTypes.shape({
    vaEligible: propTypes.bool
  }),
  context: propTypes.shape({
    entry: propTypes.string,
    originalEntry: propTypes.string
  }).isRequired,
  config: propTypes.shape({
    isVariant: propTypes.bool
  })
} : {};

/**
 * Duplicated from zmmFormExtras, which is used for original long-form validation & parsing
 * Splits a string input (by spaces) into an array of strings. Removes all white space.
 * @param input {string|Array}
 * @returns {Array}
 */
var splitString = function splitString(input) {
  var value = [];
  if (input && typeof input === 'string') {
    value = input.trim().split(/[ ]+/);
  } else if (Array.isArray(input)) {
    return input;
  }
  return value;
};
var singleLineValidationSchema = zgmYup.object({
  name: zgmYup.string().max(100).matches(/\S+\s\S+/, {
    message: 'Please enter a valid first and last name.',
    excludeEmptyString: true
  }).required()
});
var SingleLineName = function SingleLineName(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    _onChange2 = _ref.onChange,
    onNext = _ref.onNext,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: title,
    description: "Your information is protected by TLS encryption."
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value && value.first + " " + value.last, _ref2),
    hasFormActions: true,
    onChange: function onChange(formData) {
      var _onChange;
      var _splitString = splitString(formData.name),
        _splitString2 = _toArray(_splitString),
        first = _splitString2[0],
        rest = _splitString2.slice(1);
      return _onChange2((_onChange = {}, _onChange[name] = {
        first: first,
        last: rest.join(' ')
      }, _onChange));
    },
    onSubmit: onNext,
    validationSchema: singleLineValidationSchema
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledFormFlex, null, /*#__PURE__*/React.createElement(StyledField, {
      field: fields[name],
      placeholder: "Enter first and last name",
      desktopColumnWidth: widths.full,
      "data-dd-privacy": "mask-user-input"
    }));
  }));
};
SingleLineName.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  title: propTypes.string.isRequired,
  value: propTypes.shape({
    first: propTypes.string.isRequired,
    last: propTypes.string.isRequired
  }),
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var SCHEMA_SUB_TYPES$1 = types.SCHEMA_SUB_TYPES;
var namePattern = /^[A-Za-zÀ-öù-žḀ-ỿ-'"\u2026 ]*$/;
//Backend logic for accepting first and last names are: letters/accented letters, space, -, smart quotes, ellipsis character(...)
var validationSchema$9 = zgmYup.object({
  name: zgmYup.object({
    first: zgmYup.string().max(40).label('First name').meta({
      subType: SCHEMA_SUB_TYPES$1.STRING.NAME_FIRST
    }).trim().matches(namePattern, {
      message: 'Must be a valid first name',
      excludeEmptyString: true
    }).required(),
    last: zgmYup.string().max(80).label('Last name').meta({
      subType: SCHEMA_SUB_TYPES$1.STRING.NAME_LAST
    }).trim().matches(namePattern, {
      message: 'Must be a valid last name',
      excludeEmptyString: true
    }).required()
  })
});
var SplitLinesName = function SplitLinesName(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    _onChange2 = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Almost there! What's your name?",
    description: "Your information is protected by TLS encryption."
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value, _ref2),
    hasFormActions: true,
    onChange: function onChange(formData) {
      var _onChange;
      return _onChange2((_onChange = {}, _onChange[name] = formData.name, _onChange));
    },
    onSubmit: onNext,
    validationSchema: validationSchema$9
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledFormFlex, null, /*#__PURE__*/React.createElement(StyledField, {
      field: fields[name].first,
      placeholder: "First name",
      desktopColumnWidth: widths.medium,
      autoComplete: "off",
      "data-dd-privacy": "mask-user-input"
    }), /*#__PURE__*/React.createElement(StyledField, {
      field: fields[name].last,
      placeholder: "Last name",
      desktopColumnWidth: widths.medium,
      autoComplete: "off",
      "data-dd-privacy": "mask-user-input"
    }));
  }));
};
SplitLinesName.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.any,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};
var Name = function Name(_ref4) {
  var answers = _ref4.answers,
    context = _ref4.context,
    componentProps = _objectWithoutProperties(_ref4, ["answers", "context"]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isZhl = _useState2[0],
    setIsZhl = _useState2[1];
  useEffect(function () {
    getLongFormContactPossible(answers, context).catch(function () {}).then(function (response) {
      if (response !== null && response !== void 0 && response.affiliateDibs) {
        setIsZhl(true);
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return isZhl ? /*#__PURE__*/React.createElement(SplitLinesName, componentProps) : /*#__PURE__*/React.createElement(SingleLineName, _extends({}, componentProps, {
    title: "Almost there! What's your name?"
  }));
};
Name.propTypes = process.env.NODE_ENV !== "production" ? {
  answers: propTypes.object,
  context: propTypes.object
} : {};

var validationSchema$a = zgmYup.object({
  needAgent: zgmYup.string().enumeration(NO_YES_OPTIONS)
});
var NeedAgent = function NeedAgent(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Would you like to be connected with a local real estate agent for help finding and touring homes?"
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value === null || value === void 0 ? void 0 : value.toString(), _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$a
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      vertical: false,
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value === 'true', _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
NeedAgent.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.bool,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var getPhoneNumberSchema = function getPhoneNumberSchema() {
  return zgmYup.object({
    phoneNumber: zgmYup.string().phone().test('isValid', 'Invalid Phone Number', function (phone, _ref) {
      return new Promise(function ($return, $error) {
        var _ref$allowExtension = _ref.allowExtension,
          allowExtension = _ref$allowExtension === void 0 ? false : _ref$allowExtension,
          createError = _ref.createError;
        // undefined at first rendering
        if (phone === undefined) {
          return $return(true);
        }
        return $return(cachedPromise('phone', phone, function () {
          return API.MAX.POST({
            action: 'parsePhoneNumber',
            input: {
              partnerId: API.partnerId,
              phoneNumber: phone
            }
          });
        }).then(function (response) {
          if (!allowExtension && response.phoneNumber.extension) {
            return createError({
              message: 'Please do not include extensions.'
            });
          }
          return true;
        }, function (response) {
          if (response && response.error === 'InvalidPhoneNumber') {
            trackEvent({
              category: 'Mortgages',
              action: 'input validation fail: phoneNumber',
              label: getTrackingLabel()
            });
            return createError({
              message: 'Please enter a valid phone number.'
            });
          } else {
            return createError({
              message: 'Connection lost, please try again later.'
            });
          }
        }));
      });
    }).required()
  });
};

var CTA_LABEL = 'Next';
var PAContact = function PAContact(_ref) {
  var name = _ref.name,
    value = _ref.value,
    answers = _ref.answers,
    context = _ref.context,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasError = _useState2[0],
    setHasError = _useState2[1];
  var defaultValues = useMemo(function () {
    var _ref2;
    return _ref2 = {}, _ref2[name] = value, _ref2;
  }, [name, value]);
  var _useForm = useForm({
      reValidateMode: 'onBlur',
      validationSchema: getPhoneNumberSchema(),
      defaultValues: defaultValues
    }, {
      generateFormattersFromSchema: true
    }),
    fields = _useForm.fields,
    handleSubmit = _useForm.handleSubmit;
  var onSubmit = useCallback(function (formData) {
    return new Promise(function ($return, $error) {
      var newAnswers, response, _global$DD_RUM, _global$DD_RUM$addErr;
      setHasError(false);
      newAnswers = Object.assign({}, answers, formData);
      trackPAContactClick({
        answers: newAnswers,
        context: context
      });
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      var $Try_1_Catch = function (error) {
        try {
          (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addErr = _global$DD_RUM.addError) === null || _global$DD_RUM$addErr === void 0 ? void 0 : _global$DD_RUM$addErr.call(_global$DD_RUM, error, {
            action: 'submitExternalContactLead'
          });
          setHasError(true);
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(onChange(formData)).then(function ($await_2) {
          try {
            return Promise.resolve(submitPAContact({
              answers: newAnswers
            })).then(function ($await_3) {
              try {
                response = $await_3;
                setContext({
                  isZGMIPaLead: true
                }); // use by contactLongFormLender at then end of the flow
                trackPAContactSuccess({
                  answers: newAnswers,
                  context: context,
                  optionals: response
                });
                onNext(formData);
                return $Try_1_Post();
              } catch ($boundEx) {
                return $Try_1_Catch($boundEx);
              }
            }, $Try_1_Catch);
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error);
      }
    });
  }, [onChange, onNext, answers, context]);
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "What\u2019s the best number for Zillow to reach you at? Zillow will help you get connected with a local real estate agent and lender."
  }, /*#__PURE__*/React.createElement(StyledForm, {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement(StyledField, {
    field: fields[name],
    placeholder: "(XXX) XXX-XXXX",
    autoComplete: "off",
    "data-dd-privacy": "mask-user-input"
  }), hasError && /*#__PURE__*/React.createElement(Spacer, {
    marginY: "sm"
  }, /*#__PURE__*/React.createElement(Alert, {
    appearance: "error",
    body: "We're sorry, something went wrong when submitting your request. Please come back later and try again."
  })), /*#__PURE__*/React.createElement(FormActions, null, /*#__PURE__*/React.createElement(StyledButton, {
    id: FORM_ACTION_BUTTON_ID,
    buttonType: "primary",
    type: "submit"
  }, CTA_LABEL))), /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "finePrint",
    marginTop: "sm"
  }, "By selecting \"", CTA_LABEL, "\", I provide consent and agree to the Use of Electronic Signatures and Records. Your information is protected by TLS encryption. By selecting \"", CTA_LABEL, "\" (1) I authorize Zillow Group Marketplace, Inc. (\"ZGMI\") to send the information I provided to participating lenders, and to Zillow, Inc., so that Zillow, Inc. may share that information with other partners or real estate professionals, and (2) I authorize ZGMI, participating lenders, Zillow, Inc., and other partners and real estate professionals, to deliver or cause to be delivered to me at the phone number I provided, telemarketing calls which may use an automatic telephone dialing system, an artificial or prerecorded voice or text message via telephone, mobile device (including SMS and MMS - charges may apply) and/or email, even if my telephone number is registered with any state, federal, national, or provide Do Not Call (DNC) list. I understand that I am not required to provide this consent and authorization and it is not a condition to qualify for a loan or receive any good or service."));
};
PAContact.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.any,
  answers: propTypes.shape({
    hasAgent: propTypes.bool,
    loanType: propTypes.string,
    location: propTypes.shape({
      state: propTypes.string
    }),
    needs: propTypes.string
  }),
  context: propTypes.shape({
    landingPage: propTypes.string
  }).isRequired,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var showdown = createCommonjsModule(function (module) {
(function(){
/**
 * Created by Tivie on 13-07-2015.
 */

function getDefaultOpts (simple) {

  var defaultOptions = {
    omitExtraWLInCodeBlocks: {
      defaultValue: false,
      describe: 'Omit the default extra whiteline added to code blocks',
      type: 'boolean'
    },
    noHeaderId: {
      defaultValue: false,
      describe: 'Turn on/off generated header id',
      type: 'boolean'
    },
    prefixHeaderId: {
      defaultValue: false,
      describe: 'Add a prefix to the generated header ids. Passing a string will prefix that string to the header id. Setting to true will add a generic \'section-\' prefix',
      type: 'string'
    },
    rawPrefixHeaderId: {
      defaultValue: false,
      describe: 'Setting this option to true will prevent showdown from modifying the prefix. This might result in malformed IDs (if, for instance, the " char is used in the prefix)',
      type: 'boolean'
    },
    ghCompatibleHeaderId: {
      defaultValue: false,
      describe: 'Generate header ids compatible with github style (spaces are replaced with dashes, a bunch of non alphanumeric chars are removed)',
      type: 'boolean'
    },
    rawHeaderId: {
      defaultValue: false,
      describe: 'Remove only spaces, \' and " from generated header ids (including prefixes), replacing them with dashes (-). WARNING: This might result in malformed ids',
      type: 'boolean'
    },
    headerLevelStart: {
      defaultValue: false,
      describe: 'The header blocks level start',
      type: 'integer'
    },
    parseImgDimensions: {
      defaultValue: false,
      describe: 'Turn on/off image dimension parsing',
      type: 'boolean'
    },
    simplifiedAutoLink: {
      defaultValue: false,
      describe: 'Turn on/off GFM autolink style',
      type: 'boolean'
    },
    excludeTrailingPunctuationFromURLs: {
      defaultValue: false,
      describe: 'Excludes trailing punctuation from links generated with autoLinking',
      type: 'boolean'
    },
    literalMidWordUnderscores: {
      defaultValue: false,
      describe: 'Parse midword underscores as literal underscores',
      type: 'boolean'
    },
    literalMidWordAsterisks: {
      defaultValue: false,
      describe: 'Parse midword asterisks as literal asterisks',
      type: 'boolean'
    },
    strikethrough: {
      defaultValue: false,
      describe: 'Turn on/off strikethrough support',
      type: 'boolean'
    },
    tables: {
      defaultValue: false,
      describe: 'Turn on/off tables support',
      type: 'boolean'
    },
    tablesHeaderId: {
      defaultValue: false,
      describe: 'Add an id to table headers',
      type: 'boolean'
    },
    ghCodeBlocks: {
      defaultValue: true,
      describe: 'Turn on/off GFM fenced code blocks support',
      type: 'boolean'
    },
    tasklists: {
      defaultValue: false,
      describe: 'Turn on/off GFM tasklist support',
      type: 'boolean'
    },
    smoothLivePreview: {
      defaultValue: false,
      describe: 'Prevents weird effects in live previews due to incomplete input',
      type: 'boolean'
    },
    smartIndentationFix: {
      defaultValue: false,
      description: 'Tries to smartly fix indentation in es6 strings',
      type: 'boolean'
    },
    disableForced4SpacesIndentedSublists: {
      defaultValue: false,
      description: 'Disables the requirement of indenting nested sublists by 4 spaces',
      type: 'boolean'
    },
    simpleLineBreaks: {
      defaultValue: false,
      description: 'Parses simple line breaks as <br> (GFM Style)',
      type: 'boolean'
    },
    requireSpaceBeforeHeadingText: {
      defaultValue: false,
      description: 'Makes adding a space between `#` and the header text mandatory (GFM Style)',
      type: 'boolean'
    },
    ghMentions: {
      defaultValue: false,
      description: 'Enables github @mentions',
      type: 'boolean'
    },
    ghMentionsLink: {
      defaultValue: 'https://github.com/{u}',
      description: 'Changes the link generated by @mentions. Only applies if ghMentions option is enabled.',
      type: 'string'
    },
    encodeEmails: {
      defaultValue: true,
      description: 'Encode e-mail addresses through the use of Character Entities, transforming ASCII e-mail addresses into its equivalent decimal entities',
      type: 'boolean'
    },
    openLinksInNewWindow: {
      defaultValue: false,
      description: 'Open all links in new windows',
      type: 'boolean'
    },
    backslashEscapesHTMLTags: {
      defaultValue: false,
      description: 'Support for HTML Tag escaping. ex: \<div>foo\</div>',
      type: 'boolean'
    },
    emoji: {
      defaultValue: false,
      description: 'Enable emoji support. Ex: `this is a :smile: emoji`',
      type: 'boolean'
    },
    underline: {
      defaultValue: false,
      description: 'Enable support for underline. Syntax is double or triple underscores: `__underline word__`. With this option enabled, underscores no longer parses into `<em>` and `<strong>`',
      type: 'boolean'
    },
    completeHTMLDocument: {
      defaultValue: false,
      description: 'Outputs a complete html document, including `<html>`, `<head>` and `<body>` tags',
      type: 'boolean'
    },
    metadata: {
      defaultValue: false,
      description: 'Enable support for document metadata (defined at the top of the document between `«««` and `»»»` or between `---` and `---`).',
      type: 'boolean'
    },
    splitAdjacentBlockquotes: {
      defaultValue: false,
      description: 'Split adjacent blockquote blocks',
      type: 'boolean'
    }
  };
  if (simple === false) {
    return JSON.parse(JSON.stringify(defaultOptions));
  }
  var ret = {};
  for (var opt in defaultOptions) {
    if (defaultOptions.hasOwnProperty(opt)) {
      ret[opt] = defaultOptions[opt].defaultValue;
    }
  }
  return ret;
}

function allOptionsOn () {
  var options = getDefaultOpts(true),
      ret = {};
  for (var opt in options) {
    if (options.hasOwnProperty(opt)) {
      ret[opt] = true;
    }
  }
  return ret;
}

/**
 * Created by Tivie on 06-01-2015.
 */

// Private properties
var showdown = {},
    parsers = {},
    extensions = {},
    globalOptions = getDefaultOpts(true),
    setFlavor = 'vanilla',
    flavor = {
      github: {
        omitExtraWLInCodeBlocks:              true,
        simplifiedAutoLink:                   true,
        excludeTrailingPunctuationFromURLs:   true,
        literalMidWordUnderscores:            true,
        strikethrough:                        true,
        tables:                               true,
        tablesHeaderId:                       true,
        ghCodeBlocks:                         true,
        tasklists:                            true,
        disableForced4SpacesIndentedSublists: true,
        simpleLineBreaks:                     true,
        requireSpaceBeforeHeadingText:        true,
        ghCompatibleHeaderId:                 true,
        ghMentions:                           true,
        backslashEscapesHTMLTags:             true,
        emoji:                                true,
        splitAdjacentBlockquotes:             true
      },
      original: {
        noHeaderId:                           true,
        ghCodeBlocks:                         false
      },
      ghost: {
        omitExtraWLInCodeBlocks:              true,
        parseImgDimensions:                   true,
        simplifiedAutoLink:                   true,
        excludeTrailingPunctuationFromURLs:   true,
        literalMidWordUnderscores:            true,
        strikethrough:                        true,
        tables:                               true,
        tablesHeaderId:                       true,
        ghCodeBlocks:                         true,
        tasklists:                            true,
        smoothLivePreview:                    true,
        simpleLineBreaks:                     true,
        requireSpaceBeforeHeadingText:        true,
        ghMentions:                           false,
        encodeEmails:                         true
      },
      vanilla: getDefaultOpts(true),
      allOn: allOptionsOn()
    };

/**
 * helper namespace
 * @type {{}}
 */
showdown.helper = {};

/**
 * TODO LEGACY SUPPORT CODE
 * @type {{}}
 */
showdown.extensions = {};

/**
 * Set a global option
 * @static
 * @param {string} key
 * @param {*} value
 * @returns {showdown}
 */
showdown.setOption = function (key, value) {
  globalOptions[key] = value;
  return this;
};

/**
 * Get a global option
 * @static
 * @param {string} key
 * @returns {*}
 */
showdown.getOption = function (key) {
  return globalOptions[key];
};

/**
 * Get the global options
 * @static
 * @returns {{}}
 */
showdown.getOptions = function () {
  return globalOptions;
};

/**
 * Reset global options to the default values
 * @static
 */
showdown.resetOptions = function () {
  globalOptions = getDefaultOpts(true);
};

/**
 * Set the flavor showdown should use as default
 * @param {string} name
 */
showdown.setFlavor = function (name) {
  if (!flavor.hasOwnProperty(name)) {
    throw Error(name + ' flavor was not found');
  }
  showdown.resetOptions();
  var preset = flavor[name];
  setFlavor = name;
  for (var option in preset) {
    if (preset.hasOwnProperty(option)) {
      globalOptions[option] = preset[option];
    }
  }
};

/**
 * Get the currently set flavor
 * @returns {string}
 */
showdown.getFlavor = function () {
  return setFlavor;
};

/**
 * Get the options of a specified flavor. Returns undefined if the flavor was not found
 * @param {string} name Name of the flavor
 * @returns {{}|undefined}
 */
showdown.getFlavorOptions = function (name) {
  if (flavor.hasOwnProperty(name)) {
    return flavor[name];
  }
};

/**
 * Get the default options
 * @static
 * @param {boolean} [simple=true]
 * @returns {{}}
 */
showdown.getDefaultOptions = function (simple) {
  return getDefaultOpts(simple);
};

/**
 * Get or set a subParser
 *
 * subParser(name)       - Get a registered subParser
 * subParser(name, func) - Register a subParser
 * @static
 * @param {string} name
 * @param {function} [func]
 * @returns {*}
 */
showdown.subParser = function (name, func) {
  if (showdown.helper.isString(name)) {
    if (typeof func !== 'undefined') {
      parsers[name] = func;
    } else {
      if (parsers.hasOwnProperty(name)) {
        return parsers[name];
      } else {
        throw Error('SubParser named ' + name + ' not registered!');
      }
    }
  }
};

/**
 * Gets or registers an extension
 * @static
 * @param {string} name
 * @param {object|function=} ext
 * @returns {*}
 */
showdown.extension = function (name, ext) {

  if (!showdown.helper.isString(name)) {
    throw Error('Extension \'name\' must be a string');
  }

  name = showdown.helper.stdExtName(name);

  // Getter
  if (showdown.helper.isUndefined(ext)) {
    if (!extensions.hasOwnProperty(name)) {
      throw Error('Extension named ' + name + ' is not registered!');
    }
    return extensions[name];

    // Setter
  } else {
    // Expand extension if it's wrapped in a function
    if (typeof ext === 'function') {
      ext = ext();
    }

    // Ensure extension is an array
    if (!showdown.helper.isArray(ext)) {
      ext = [ext];
    }

    var validExtension = validate(ext, name);

    if (validExtension.valid) {
      extensions[name] = ext;
    } else {
      throw Error(validExtension.error);
    }
  }
};

/**
 * Gets all extensions registered
 * @returns {{}}
 */
showdown.getAllExtensions = function () {
  return extensions;
};

/**
 * Remove an extension
 * @param {string} name
 */
showdown.removeExtension = function (name) {
  delete extensions[name];
};

/**
 * Removes all extensions
 */
showdown.resetExtensions = function () {
  extensions = {};
};

/**
 * Validate extension
 * @param {array} extension
 * @param {string} name
 * @returns {{valid: boolean, error: string}}
 */
function validate (extension, name) {

  var errMsg = (name) ? 'Error in ' + name + ' extension->' : 'Error in unnamed extension',
      ret = {
        valid: true,
        error: ''
      };

  if (!showdown.helper.isArray(extension)) {
    extension = [extension];
  }

  for (var i = 0; i < extension.length; ++i) {
    var baseMsg = errMsg + ' sub-extension ' + i + ': ',
        ext = extension[i];
    if (typeof ext !== 'object') {
      ret.valid = false;
      ret.error = baseMsg + 'must be an object, but ' + typeof ext + ' given';
      return ret;
    }

    if (!showdown.helper.isString(ext.type)) {
      ret.valid = false;
      ret.error = baseMsg + 'property "type" must be a string, but ' + typeof ext.type + ' given';
      return ret;
    }

    var type = ext.type = ext.type.toLowerCase();

    // normalize extension type
    if (type === 'language') {
      type = ext.type = 'lang';
    }

    if (type === 'html') {
      type = ext.type = 'output';
    }

    if (type !== 'lang' && type !== 'output' && type !== 'listener') {
      ret.valid = false;
      ret.error = baseMsg + 'type ' + type + ' is not recognized. Valid values: "lang/language", "output/html" or "listener"';
      return ret;
    }

    if (type === 'listener') {
      if (showdown.helper.isUndefined(ext.listeners)) {
        ret.valid = false;
        ret.error = baseMsg + '. Extensions of type "listener" must have a property called "listeners"';
        return ret;
      }
    } else {
      if (showdown.helper.isUndefined(ext.filter) && showdown.helper.isUndefined(ext.regex)) {
        ret.valid = false;
        ret.error = baseMsg + type + ' extensions must define either a "regex" property or a "filter" method';
        return ret;
      }
    }

    if (ext.listeners) {
      if (typeof ext.listeners !== 'object') {
        ret.valid = false;
        ret.error = baseMsg + '"listeners" property must be an object but ' + typeof ext.listeners + ' given';
        return ret;
      }
      for (var ln in ext.listeners) {
        if (ext.listeners.hasOwnProperty(ln)) {
          if (typeof ext.listeners[ln] !== 'function') {
            ret.valid = false;
            ret.error = baseMsg + '"listeners" property must be an hash of [event name]: [callback]. listeners.' + ln +
              ' must be a function but ' + typeof ext.listeners[ln] + ' given';
            return ret;
          }
        }
      }
    }

    if (ext.filter) {
      if (typeof ext.filter !== 'function') {
        ret.valid = false;
        ret.error = baseMsg + '"filter" must be a function, but ' + typeof ext.filter + ' given';
        return ret;
      }
    } else if (ext.regex) {
      if (showdown.helper.isString(ext.regex)) {
        ext.regex = new RegExp(ext.regex, 'g');
      }
      if (!(ext.regex instanceof RegExp)) {
        ret.valid = false;
        ret.error = baseMsg + '"regex" property must either be a string or a RegExp object, but ' + typeof ext.regex + ' given';
        return ret;
      }
      if (showdown.helper.isUndefined(ext.replace)) {
        ret.valid = false;
        ret.error = baseMsg + '"regex" extensions must implement a replace string or function';
        return ret;
      }
    }
  }
  return ret;
}

/**
 * Validate extension
 * @param {object} ext
 * @returns {boolean}
 */
showdown.validateExtension = function (ext) {

  var validateExtension = validate(ext, null);
  if (!validateExtension.valid) {
    console.warn(validateExtension.error);
    return false;
  }
  return true;
};

/**
 * showdownjs helper functions
 */

if (!showdown.hasOwnProperty('helper')) {
  showdown.helper = {};
}

/**
 * Check if var is string
 * @static
 * @param {string} a
 * @returns {boolean}
 */
showdown.helper.isString = function (a) {
  return (typeof a === 'string' || a instanceof String);
};

/**
 * Check if var is a function
 * @static
 * @param {*} a
 * @returns {boolean}
 */
showdown.helper.isFunction = function (a) {
  var getType = {};
  return a && getType.toString.call(a) === '[object Function]';
};

/**
 * isArray helper function
 * @static
 * @param {*} a
 * @returns {boolean}
 */
showdown.helper.isArray = function (a) {
  return Array.isArray(a);
};

/**
 * Check if value is undefined
 * @static
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 */
showdown.helper.isUndefined = function (value) {
  return typeof value === 'undefined';
};

/**
 * ForEach helper function
 * Iterates over Arrays and Objects (own properties only)
 * @static
 * @param {*} obj
 * @param {function} callback Accepts 3 params: 1. value, 2. key, 3. the original array/object
 */
showdown.helper.forEach = function (obj, callback) {
  // check if obj is defined
  if (showdown.helper.isUndefined(obj)) {
    throw new Error('obj param is required');
  }

  if (showdown.helper.isUndefined(callback)) {
    throw new Error('callback param is required');
  }

  if (!showdown.helper.isFunction(callback)) {
    throw new Error('callback param must be a function/closure');
  }

  if (typeof obj.forEach === 'function') {
    obj.forEach(callback);
  } else if (showdown.helper.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      callback(obj[i], i, obj);
    }
  } else if (typeof (obj) === 'object') {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        callback(obj[prop], prop, obj);
      }
    }
  } else {
    throw new Error('obj does not seem to be an array or an iterable object');
  }
};

/**
 * Standardidize extension name
 * @static
 * @param {string} s extension name
 * @returns {string}
 */
showdown.helper.stdExtName = function (s) {
  return s.replace(/[_?*+\/\\.^-]/g, '').replace(/\s/g, '').toLowerCase();
};

function escapeCharactersCallback (wholeMatch, m1) {
  var charCodeToEscape = m1.charCodeAt(0);
  return '¨E' + charCodeToEscape + 'E';
}

/**
 * Callback used to escape characters when passing through String.replace
 * @static
 * @param {string} wholeMatch
 * @param {string} m1
 * @returns {string}
 */
showdown.helper.escapeCharactersCallback = escapeCharactersCallback;

/**
 * Escape characters in a string
 * @static
 * @param {string} text
 * @param {string} charsToEscape
 * @param {boolean} afterBackslash
 * @returns {XML|string|void|*}
 */
showdown.helper.escapeCharacters = function (text, charsToEscape, afterBackslash) {
  // First we have to escape the escape characters so that
  // we can build a character class out of them
  var regexString = '([' + charsToEscape.replace(/([\[\]\\])/g, '\\$1') + '])';

  if (afterBackslash) {
    regexString = '\\\\' + regexString;
  }

  var regex = new RegExp(regexString, 'g');
  text = text.replace(regex, escapeCharactersCallback);

  return text;
};

/**
 * Unescape HTML entities
 * @param txt
 * @returns {string}
 */
showdown.helper.unescapeHTMLEntities = function (txt) {

  return txt
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&');
};

var rgxFindMatchPos = function (str, left, right, flags) {
  var f = flags || '',
      g = f.indexOf('g') > -1,
      x = new RegExp(left + '|' + right, 'g' + f.replace(/g/g, '')),
      l = new RegExp(left, f.replace(/g/g, '')),
      pos = [],
      t, s, m, start, end;

  do {
    t = 0;
    while ((m = x.exec(str))) {
      if (l.test(m[0])) {
        if (!(t++)) {
          s = x.lastIndex;
          start = s - m[0].length;
        }
      } else if (t) {
        if (!--t) {
          end = m.index + m[0].length;
          var obj = {
            left: {start: start, end: s},
            match: {start: s, end: m.index},
            right: {start: m.index, end: end},
            wholeMatch: {start: start, end: end}
          };
          pos.push(obj);
          if (!g) {
            return pos;
          }
        }
      }
    }
  } while (t && (x.lastIndex = s));

  return pos;
};

/**
 * matchRecursiveRegExp
 *
 * (c) 2007 Steven Levithan <stevenlevithan.com>
 * MIT License
 *
 * Accepts a string to search, a left and right format delimiter
 * as regex patterns, and optional regex flags. Returns an array
 * of matches, allowing nested instances of left/right delimiters.
 * Use the "g" flag to return all matches, otherwise only the
 * first is returned. Be careful to ensure that the left and
 * right format delimiters produce mutually exclusive matches.
 * Backreferences are not supported within the right delimiter
 * due to how it is internally combined with the left delimiter.
 * When matching strings whose format delimiters are unbalanced
 * to the left or right, the output is intentionally as a
 * conventional regex library with recursion support would
 * produce, e.g. "<<x>" and "<x>>" both produce ["x"] when using
 * "<" and ">" as the delimiters (both strings contain a single,
 * balanced instance of "<x>").
 *
 * examples:
 * matchRecursiveRegExp("test", "\\(", "\\)")
 * returns: []
 * matchRecursiveRegExp("<t<<e>><s>>t<>", "<", ">", "g")
 * returns: ["t<<e>><s>", ""]
 * matchRecursiveRegExp("<div id=\"x\">test</div>", "<div\\b[^>]*>", "</div>", "gi")
 * returns: ["test"]
 */
showdown.helper.matchRecursiveRegExp = function (str, left, right, flags) {

  var matchPos = rgxFindMatchPos (str, left, right, flags),
      results = [];

  for (var i = 0; i < matchPos.length; ++i) {
    results.push([
      str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end),
      str.slice(matchPos[i].match.start, matchPos[i].match.end),
      str.slice(matchPos[i].left.start, matchPos[i].left.end),
      str.slice(matchPos[i].right.start, matchPos[i].right.end)
    ]);
  }
  return results;
};

/**
 *
 * @param {string} str
 * @param {string|function} replacement
 * @param {string} left
 * @param {string} right
 * @param {string} flags
 * @returns {string}
 */
showdown.helper.replaceRecursiveRegExp = function (str, replacement, left, right, flags) {

  if (!showdown.helper.isFunction(replacement)) {
    var repStr = replacement;
    replacement = function () {
      return repStr;
    };
  }

  var matchPos = rgxFindMatchPos(str, left, right, flags),
      finalStr = str,
      lng = matchPos.length;

  if (lng > 0) {
    var bits = [];
    if (matchPos[0].wholeMatch.start !== 0) {
      bits.push(str.slice(0, matchPos[0].wholeMatch.start));
    }
    for (var i = 0; i < lng; ++i) {
      bits.push(
        replacement(
          str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end),
          str.slice(matchPos[i].match.start, matchPos[i].match.end),
          str.slice(matchPos[i].left.start, matchPos[i].left.end),
          str.slice(matchPos[i].right.start, matchPos[i].right.end)
        )
      );
      if (i < lng - 1) {
        bits.push(str.slice(matchPos[i].wholeMatch.end, matchPos[i + 1].wholeMatch.start));
      }
    }
    if (matchPos[lng - 1].wholeMatch.end < str.length) {
      bits.push(str.slice(matchPos[lng - 1].wholeMatch.end));
    }
    finalStr = bits.join('');
  }
  return finalStr;
};

/**
 * Returns the index within the passed String object of the first occurrence of the specified regex,
 * starting the search at fromIndex. Returns -1 if the value is not found.
 *
 * @param {string} str string to search
 * @param {RegExp} regex Regular expression to search
 * @param {int} [fromIndex = 0] Index to start the search
 * @returns {Number}
 * @throws InvalidArgumentError
 */
showdown.helper.regexIndexOf = function (str, regex, fromIndex) {
  if (!showdown.helper.isString(str)) {
    throw 'InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string';
  }
  if (regex instanceof RegExp === false) {
    throw 'InvalidArgumentError: second parameter of showdown.helper.regexIndexOf function must be an instance of RegExp';
  }
  var indexOf = str.substring(fromIndex || 0).search(regex);
  return (indexOf >= 0) ? (indexOf + (fromIndex || 0)) : indexOf;
};

/**
 * Splits the passed string object at the defined index, and returns an array composed of the two substrings
 * @param {string} str string to split
 * @param {int} index index to split string at
 * @returns {[string,string]}
 * @throws InvalidArgumentError
 */
showdown.helper.splitAtIndex = function (str, index) {
  if (!showdown.helper.isString(str)) {
    throw 'InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string';
  }
  return [str.substring(0, index), str.substring(index)];
};

/**
 * Obfuscate an e-mail address through the use of Character Entities,
 * transforming ASCII characters into their equivalent decimal or hex entities.
 *
 * Since it has a random component, subsequent calls to this function produce different results
 *
 * @param {string} mail
 * @returns {string}
 */
showdown.helper.encodeEmailAddress = function (mail) {
  var encode = [
    function (ch) {
      return '&#' + ch.charCodeAt(0) + ';';
    },
    function (ch) {
      return '&#x' + ch.charCodeAt(0).toString(16) + ';';
    },
    function (ch) {
      return ch;
    }
  ];

  mail = mail.replace(/./g, function (ch) {
    if (ch === '@') {
      // this *must* be encoded. I insist.
      ch = encode[Math.floor(Math.random() * 2)](ch);
    } else {
      var r = Math.random();
      // roughly 10% raw, 45% hex, 45% dec
      ch = (
        r > 0.9 ? encode[2](ch) : r > 0.45 ? encode[1](ch) : encode[0](ch)
      );
    }
    return ch;
  });

  return mail;
};

/**
 *
 * @param str
 * @param targetLength
 * @param padString
 * @returns {string}
 */
showdown.helper.padEnd = function padEnd (str, targetLength, padString) {
  /*jshint bitwise: false*/
  // eslint-disable-next-line space-infix-ops
  targetLength = targetLength>>0; //floor if number or convert non-number to 0;
  /*jshint bitwise: true*/
  padString = String(padString || ' ');
  if (str.length > targetLength) {
    return String(str);
  } else {
    targetLength = targetLength - str.length;
    if (targetLength > padString.length) {
      padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
    }
    return String(str) + padString.slice(0,targetLength);
  }
};

/**
 * POLYFILLS
 */
// use this instead of builtin is undefined for IE8 compatibility
if (typeof console === 'undefined') {
  console = {
    warn: function (msg) {
      alert(msg);
    },
    log: function (msg) {
      alert(msg);
    },
    error: function (msg) {
      throw msg;
    }
  };
}

/**
 * Common regexes.
 * We declare some common regexes to improve performance
 */
showdown.helper.regexes = {
  asteriskDashAndColon: /([*_:~])/g
};

/**
 * EMOJIS LIST
 */
showdown.helper.emojis = {
  '+1':'\ud83d\udc4d',
  '-1':'\ud83d\udc4e',
  '100':'\ud83d\udcaf',
  '1234':'\ud83d\udd22',
  '1st_place_medal':'\ud83e\udd47',
  '2nd_place_medal':'\ud83e\udd48',
  '3rd_place_medal':'\ud83e\udd49',
  '8ball':'\ud83c\udfb1',
  'a':'\ud83c\udd70\ufe0f',
  'ab':'\ud83c\udd8e',
  'abc':'\ud83d\udd24',
  'abcd':'\ud83d\udd21',
  'accept':'\ud83c\ude51',
  'aerial_tramway':'\ud83d\udea1',
  'airplane':'\u2708\ufe0f',
  'alarm_clock':'\u23f0',
  'alembic':'\u2697\ufe0f',
  'alien':'\ud83d\udc7d',
  'ambulance':'\ud83d\ude91',
  'amphora':'\ud83c\udffa',
  'anchor':'\u2693\ufe0f',
  'angel':'\ud83d\udc7c',
  'anger':'\ud83d\udca2',
  'angry':'\ud83d\ude20',
  'anguished':'\ud83d\ude27',
  'ant':'\ud83d\udc1c',
  'apple':'\ud83c\udf4e',
  'aquarius':'\u2652\ufe0f',
  'aries':'\u2648\ufe0f',
  'arrow_backward':'\u25c0\ufe0f',
  'arrow_double_down':'\u23ec',
  'arrow_double_up':'\u23eb',
  'arrow_down':'\u2b07\ufe0f',
  'arrow_down_small':'\ud83d\udd3d',
  'arrow_forward':'\u25b6\ufe0f',
  'arrow_heading_down':'\u2935\ufe0f',
  'arrow_heading_up':'\u2934\ufe0f',
  'arrow_left':'\u2b05\ufe0f',
  'arrow_lower_left':'\u2199\ufe0f',
  'arrow_lower_right':'\u2198\ufe0f',
  'arrow_right':'\u27a1\ufe0f',
  'arrow_right_hook':'\u21aa\ufe0f',
  'arrow_up':'\u2b06\ufe0f',
  'arrow_up_down':'\u2195\ufe0f',
  'arrow_up_small':'\ud83d\udd3c',
  'arrow_upper_left':'\u2196\ufe0f',
  'arrow_upper_right':'\u2197\ufe0f',
  'arrows_clockwise':'\ud83d\udd03',
  'arrows_counterclockwise':'\ud83d\udd04',
  'art':'\ud83c\udfa8',
  'articulated_lorry':'\ud83d\ude9b',
  'artificial_satellite':'\ud83d\udef0',
  'astonished':'\ud83d\ude32',
  'athletic_shoe':'\ud83d\udc5f',
  'atm':'\ud83c\udfe7',
  'atom_symbol':'\u269b\ufe0f',
  'avocado':'\ud83e\udd51',
  'b':'\ud83c\udd71\ufe0f',
  'baby':'\ud83d\udc76',
  'baby_bottle':'\ud83c\udf7c',
  'baby_chick':'\ud83d\udc24',
  'baby_symbol':'\ud83d\udebc',
  'back':'\ud83d\udd19',
  'bacon':'\ud83e\udd53',
  'badminton':'\ud83c\udff8',
  'baggage_claim':'\ud83d\udec4',
  'baguette_bread':'\ud83e\udd56',
  'balance_scale':'\u2696\ufe0f',
  'balloon':'\ud83c\udf88',
  'ballot_box':'\ud83d\uddf3',
  'ballot_box_with_check':'\u2611\ufe0f',
  'bamboo':'\ud83c\udf8d',
  'banana':'\ud83c\udf4c',
  'bangbang':'\u203c\ufe0f',
  'bank':'\ud83c\udfe6',
  'bar_chart':'\ud83d\udcca',
  'barber':'\ud83d\udc88',
  'baseball':'\u26be\ufe0f',
  'basketball':'\ud83c\udfc0',
  'basketball_man':'\u26f9\ufe0f',
  'basketball_woman':'\u26f9\ufe0f&zwj;\u2640\ufe0f',
  'bat':'\ud83e\udd87',
  'bath':'\ud83d\udec0',
  'bathtub':'\ud83d\udec1',
  'battery':'\ud83d\udd0b',
  'beach_umbrella':'\ud83c\udfd6',
  'bear':'\ud83d\udc3b',
  'bed':'\ud83d\udecf',
  'bee':'\ud83d\udc1d',
  'beer':'\ud83c\udf7a',
  'beers':'\ud83c\udf7b',
  'beetle':'\ud83d\udc1e',
  'beginner':'\ud83d\udd30',
  'bell':'\ud83d\udd14',
  'bellhop_bell':'\ud83d\udece',
  'bento':'\ud83c\udf71',
  'biking_man':'\ud83d\udeb4',
  'bike':'\ud83d\udeb2',
  'biking_woman':'\ud83d\udeb4&zwj;\u2640\ufe0f',
  'bikini':'\ud83d\udc59',
  'biohazard':'\u2623\ufe0f',
  'bird':'\ud83d\udc26',
  'birthday':'\ud83c\udf82',
  'black_circle':'\u26ab\ufe0f',
  'black_flag':'\ud83c\udff4',
  'black_heart':'\ud83d\udda4',
  'black_joker':'\ud83c\udccf',
  'black_large_square':'\u2b1b\ufe0f',
  'black_medium_small_square':'\u25fe\ufe0f',
  'black_medium_square':'\u25fc\ufe0f',
  'black_nib':'\u2712\ufe0f',
  'black_small_square':'\u25aa\ufe0f',
  'black_square_button':'\ud83d\udd32',
  'blonde_man':'\ud83d\udc71',
  'blonde_woman':'\ud83d\udc71&zwj;\u2640\ufe0f',
  'blossom':'\ud83c\udf3c',
  'blowfish':'\ud83d\udc21',
  'blue_book':'\ud83d\udcd8',
  'blue_car':'\ud83d\ude99',
  'blue_heart':'\ud83d\udc99',
  'blush':'\ud83d\ude0a',
  'boar':'\ud83d\udc17',
  'boat':'\u26f5\ufe0f',
  'bomb':'\ud83d\udca3',
  'book':'\ud83d\udcd6',
  'bookmark':'\ud83d\udd16',
  'bookmark_tabs':'\ud83d\udcd1',
  'books':'\ud83d\udcda',
  'boom':'\ud83d\udca5',
  'boot':'\ud83d\udc62',
  'bouquet':'\ud83d\udc90',
  'bowing_man':'\ud83d\ude47',
  'bow_and_arrow':'\ud83c\udff9',
  'bowing_woman':'\ud83d\ude47&zwj;\u2640\ufe0f',
  'bowling':'\ud83c\udfb3',
  'boxing_glove':'\ud83e\udd4a',
  'boy':'\ud83d\udc66',
  'bread':'\ud83c\udf5e',
  'bride_with_veil':'\ud83d\udc70',
  'bridge_at_night':'\ud83c\udf09',
  'briefcase':'\ud83d\udcbc',
  'broken_heart':'\ud83d\udc94',
  'bug':'\ud83d\udc1b',
  'building_construction':'\ud83c\udfd7',
  'bulb':'\ud83d\udca1',
  'bullettrain_front':'\ud83d\ude85',
  'bullettrain_side':'\ud83d\ude84',
  'burrito':'\ud83c\udf2f',
  'bus':'\ud83d\ude8c',
  'business_suit_levitating':'\ud83d\udd74',
  'busstop':'\ud83d\ude8f',
  'bust_in_silhouette':'\ud83d\udc64',
  'busts_in_silhouette':'\ud83d\udc65',
  'butterfly':'\ud83e\udd8b',
  'cactus':'\ud83c\udf35',
  'cake':'\ud83c\udf70',
  'calendar':'\ud83d\udcc6',
  'call_me_hand':'\ud83e\udd19',
  'calling':'\ud83d\udcf2',
  'camel':'\ud83d\udc2b',
  'camera':'\ud83d\udcf7',
  'camera_flash':'\ud83d\udcf8',
  'camping':'\ud83c\udfd5',
  'cancer':'\u264b\ufe0f',
  'candle':'\ud83d\udd6f',
  'candy':'\ud83c\udf6c',
  'canoe':'\ud83d\udef6',
  'capital_abcd':'\ud83d\udd20',
  'capricorn':'\u2651\ufe0f',
  'car':'\ud83d\ude97',
  'card_file_box':'\ud83d\uddc3',
  'card_index':'\ud83d\udcc7',
  'card_index_dividers':'\ud83d\uddc2',
  'carousel_horse':'\ud83c\udfa0',
  'carrot':'\ud83e\udd55',
  'cat':'\ud83d\udc31',
  'cat2':'\ud83d\udc08',
  'cd':'\ud83d\udcbf',
  'chains':'\u26d3',
  'champagne':'\ud83c\udf7e',
  'chart':'\ud83d\udcb9',
  'chart_with_downwards_trend':'\ud83d\udcc9',
  'chart_with_upwards_trend':'\ud83d\udcc8',
  'checkered_flag':'\ud83c\udfc1',
  'cheese':'\ud83e\uddc0',
  'cherries':'\ud83c\udf52',
  'cherry_blossom':'\ud83c\udf38',
  'chestnut':'\ud83c\udf30',
  'chicken':'\ud83d\udc14',
  'children_crossing':'\ud83d\udeb8',
  'chipmunk':'\ud83d\udc3f',
  'chocolate_bar':'\ud83c\udf6b',
  'christmas_tree':'\ud83c\udf84',
  'church':'\u26ea\ufe0f',
  'cinema':'\ud83c\udfa6',
  'circus_tent':'\ud83c\udfaa',
  'city_sunrise':'\ud83c\udf07',
  'city_sunset':'\ud83c\udf06',
  'cityscape':'\ud83c\udfd9',
  'cl':'\ud83c\udd91',
  'clamp':'\ud83d\udddc',
  'clap':'\ud83d\udc4f',
  'clapper':'\ud83c\udfac',
  'classical_building':'\ud83c\udfdb',
  'clinking_glasses':'\ud83e\udd42',
  'clipboard':'\ud83d\udccb',
  'clock1':'\ud83d\udd50',
  'clock10':'\ud83d\udd59',
  'clock1030':'\ud83d\udd65',
  'clock11':'\ud83d\udd5a',
  'clock1130':'\ud83d\udd66',
  'clock12':'\ud83d\udd5b',
  'clock1230':'\ud83d\udd67',
  'clock130':'\ud83d\udd5c',
  'clock2':'\ud83d\udd51',
  'clock230':'\ud83d\udd5d',
  'clock3':'\ud83d\udd52',
  'clock330':'\ud83d\udd5e',
  'clock4':'\ud83d\udd53',
  'clock430':'\ud83d\udd5f',
  'clock5':'\ud83d\udd54',
  'clock530':'\ud83d\udd60',
  'clock6':'\ud83d\udd55',
  'clock630':'\ud83d\udd61',
  'clock7':'\ud83d\udd56',
  'clock730':'\ud83d\udd62',
  'clock8':'\ud83d\udd57',
  'clock830':'\ud83d\udd63',
  'clock9':'\ud83d\udd58',
  'clock930':'\ud83d\udd64',
  'closed_book':'\ud83d\udcd5',
  'closed_lock_with_key':'\ud83d\udd10',
  'closed_umbrella':'\ud83c\udf02',
  'cloud':'\u2601\ufe0f',
  'cloud_with_lightning':'\ud83c\udf29',
  'cloud_with_lightning_and_rain':'\u26c8',
  'cloud_with_rain':'\ud83c\udf27',
  'cloud_with_snow':'\ud83c\udf28',
  'clown_face':'\ud83e\udd21',
  'clubs':'\u2663\ufe0f',
  'cocktail':'\ud83c\udf78',
  'coffee':'\u2615\ufe0f',
  'coffin':'\u26b0\ufe0f',
  'cold_sweat':'\ud83d\ude30',
  'comet':'\u2604\ufe0f',
  'computer':'\ud83d\udcbb',
  'computer_mouse':'\ud83d\uddb1',
  'confetti_ball':'\ud83c\udf8a',
  'confounded':'\ud83d\ude16',
  'confused':'\ud83d\ude15',
  'congratulations':'\u3297\ufe0f',
  'construction':'\ud83d\udea7',
  'construction_worker_man':'\ud83d\udc77',
  'construction_worker_woman':'\ud83d\udc77&zwj;\u2640\ufe0f',
  'control_knobs':'\ud83c\udf9b',
  'convenience_store':'\ud83c\udfea',
  'cookie':'\ud83c\udf6a',
  'cool':'\ud83c\udd92',
  'policeman':'\ud83d\udc6e',
  'copyright':'\u00a9\ufe0f',
  'corn':'\ud83c\udf3d',
  'couch_and_lamp':'\ud83d\udecb',
  'couple':'\ud83d\udc6b',
  'couple_with_heart_woman_man':'\ud83d\udc91',
  'couple_with_heart_man_man':'\ud83d\udc68&zwj;\u2764\ufe0f&zwj;\ud83d\udc68',
  'couple_with_heart_woman_woman':'\ud83d\udc69&zwj;\u2764\ufe0f&zwj;\ud83d\udc69',
  'couplekiss_man_man':'\ud83d\udc68&zwj;\u2764\ufe0f&zwj;\ud83d\udc8b&zwj;\ud83d\udc68',
  'couplekiss_man_woman':'\ud83d\udc8f',
  'couplekiss_woman_woman':'\ud83d\udc69&zwj;\u2764\ufe0f&zwj;\ud83d\udc8b&zwj;\ud83d\udc69',
  'cow':'\ud83d\udc2e',
  'cow2':'\ud83d\udc04',
  'cowboy_hat_face':'\ud83e\udd20',
  'crab':'\ud83e\udd80',
  'crayon':'\ud83d\udd8d',
  'credit_card':'\ud83d\udcb3',
  'crescent_moon':'\ud83c\udf19',
  'cricket':'\ud83c\udfcf',
  'crocodile':'\ud83d\udc0a',
  'croissant':'\ud83e\udd50',
  'crossed_fingers':'\ud83e\udd1e',
  'crossed_flags':'\ud83c\udf8c',
  'crossed_swords':'\u2694\ufe0f',
  'crown':'\ud83d\udc51',
  'cry':'\ud83d\ude22',
  'crying_cat_face':'\ud83d\ude3f',
  'crystal_ball':'\ud83d\udd2e',
  'cucumber':'\ud83e\udd52',
  'cupid':'\ud83d\udc98',
  'curly_loop':'\u27b0',
  'currency_exchange':'\ud83d\udcb1',
  'curry':'\ud83c\udf5b',
  'custard':'\ud83c\udf6e',
  'customs':'\ud83d\udec3',
  'cyclone':'\ud83c\udf00',
  'dagger':'\ud83d\udde1',
  'dancer':'\ud83d\udc83',
  'dancing_women':'\ud83d\udc6f',
  'dancing_men':'\ud83d\udc6f&zwj;\u2642\ufe0f',
  'dango':'\ud83c\udf61',
  'dark_sunglasses':'\ud83d\udd76',
  'dart':'\ud83c\udfaf',
  'dash':'\ud83d\udca8',
  'date':'\ud83d\udcc5',
  'deciduous_tree':'\ud83c\udf33',
  'deer':'\ud83e\udd8c',
  'department_store':'\ud83c\udfec',
  'derelict_house':'\ud83c\udfda',
  'desert':'\ud83c\udfdc',
  'desert_island':'\ud83c\udfdd',
  'desktop_computer':'\ud83d\udda5',
  'male_detective':'\ud83d\udd75\ufe0f',
  'diamond_shape_with_a_dot_inside':'\ud83d\udca0',
  'diamonds':'\u2666\ufe0f',
  'disappointed':'\ud83d\ude1e',
  'disappointed_relieved':'\ud83d\ude25',
  'dizzy':'\ud83d\udcab',
  'dizzy_face':'\ud83d\ude35',
  'do_not_litter':'\ud83d\udeaf',
  'dog':'\ud83d\udc36',
  'dog2':'\ud83d\udc15',
  'dollar':'\ud83d\udcb5',
  'dolls':'\ud83c\udf8e',
  'dolphin':'\ud83d\udc2c',
  'door':'\ud83d\udeaa',
  'doughnut':'\ud83c\udf69',
  'dove':'\ud83d\udd4a',
  'dragon':'\ud83d\udc09',
  'dragon_face':'\ud83d\udc32',
  'dress':'\ud83d\udc57',
  'dromedary_camel':'\ud83d\udc2a',
  'drooling_face':'\ud83e\udd24',
  'droplet':'\ud83d\udca7',
  'drum':'\ud83e\udd41',
  'duck':'\ud83e\udd86',
  'dvd':'\ud83d\udcc0',
  'e-mail':'\ud83d\udce7',
  'eagle':'\ud83e\udd85',
  'ear':'\ud83d\udc42',
  'ear_of_rice':'\ud83c\udf3e',
  'earth_africa':'\ud83c\udf0d',
  'earth_americas':'\ud83c\udf0e',
  'earth_asia':'\ud83c\udf0f',
  'egg':'\ud83e\udd5a',
  'eggplant':'\ud83c\udf46',
  'eight_pointed_black_star':'\u2734\ufe0f',
  'eight_spoked_asterisk':'\u2733\ufe0f',
  'electric_plug':'\ud83d\udd0c',
  'elephant':'\ud83d\udc18',
  'email':'\u2709\ufe0f',
  'end':'\ud83d\udd1a',
  'envelope_with_arrow':'\ud83d\udce9',
  'euro':'\ud83d\udcb6',
  'european_castle':'\ud83c\udff0',
  'european_post_office':'\ud83c\udfe4',
  'evergreen_tree':'\ud83c\udf32',
  'exclamation':'\u2757\ufe0f',
  'expressionless':'\ud83d\ude11',
  'eye':'\ud83d\udc41',
  'eye_speech_bubble':'\ud83d\udc41&zwj;\ud83d\udde8',
  'eyeglasses':'\ud83d\udc53',
  'eyes':'\ud83d\udc40',
  'face_with_head_bandage':'\ud83e\udd15',
  'face_with_thermometer':'\ud83e\udd12',
  'fist_oncoming':'\ud83d\udc4a',
  'factory':'\ud83c\udfed',
  'fallen_leaf':'\ud83c\udf42',
  'family_man_woman_boy':'\ud83d\udc6a',
  'family_man_boy':'\ud83d\udc68&zwj;\ud83d\udc66',
  'family_man_boy_boy':'\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
  'family_man_girl':'\ud83d\udc68&zwj;\ud83d\udc67',
  'family_man_girl_boy':'\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
  'family_man_girl_girl':'\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
  'family_man_man_boy':'\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66',
  'family_man_man_boy_boy':'\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
  'family_man_man_girl':'\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67',
  'family_man_man_girl_boy':'\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
  'family_man_man_girl_girl':'\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
  'family_man_woman_boy_boy':'\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
  'family_man_woman_girl':'\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67',
  'family_man_woman_girl_boy':'\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
  'family_man_woman_girl_girl':'\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
  'family_woman_boy':'\ud83d\udc69&zwj;\ud83d\udc66',
  'family_woman_boy_boy':'\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
  'family_woman_girl':'\ud83d\udc69&zwj;\ud83d\udc67',
  'family_woman_girl_boy':'\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
  'family_woman_girl_girl':'\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
  'family_woman_woman_boy':'\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66',
  'family_woman_woman_boy_boy':'\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
  'family_woman_woman_girl':'\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67',
  'family_woman_woman_girl_boy':'\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
  'family_woman_woman_girl_girl':'\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
  'fast_forward':'\u23e9',
  'fax':'\ud83d\udce0',
  'fearful':'\ud83d\ude28',
  'feet':'\ud83d\udc3e',
  'female_detective':'\ud83d\udd75\ufe0f&zwj;\u2640\ufe0f',
  'ferris_wheel':'\ud83c\udfa1',
  'ferry':'\u26f4',
  'field_hockey':'\ud83c\udfd1',
  'file_cabinet':'\ud83d\uddc4',
  'file_folder':'\ud83d\udcc1',
  'film_projector':'\ud83d\udcfd',
  'film_strip':'\ud83c\udf9e',
  'fire':'\ud83d\udd25',
  'fire_engine':'\ud83d\ude92',
  'fireworks':'\ud83c\udf86',
  'first_quarter_moon':'\ud83c\udf13',
  'first_quarter_moon_with_face':'\ud83c\udf1b',
  'fish':'\ud83d\udc1f',
  'fish_cake':'\ud83c\udf65',
  'fishing_pole_and_fish':'\ud83c\udfa3',
  'fist_raised':'\u270a',
  'fist_left':'\ud83e\udd1b',
  'fist_right':'\ud83e\udd1c',
  'flags':'\ud83c\udf8f',
  'flashlight':'\ud83d\udd26',
  'fleur_de_lis':'\u269c\ufe0f',
  'flight_arrival':'\ud83d\udeec',
  'flight_departure':'\ud83d\udeeb',
  'floppy_disk':'\ud83d\udcbe',
  'flower_playing_cards':'\ud83c\udfb4',
  'flushed':'\ud83d\ude33',
  'fog':'\ud83c\udf2b',
  'foggy':'\ud83c\udf01',
  'football':'\ud83c\udfc8',
  'footprints':'\ud83d\udc63',
  'fork_and_knife':'\ud83c\udf74',
  'fountain':'\u26f2\ufe0f',
  'fountain_pen':'\ud83d\udd8b',
  'four_leaf_clover':'\ud83c\udf40',
  'fox_face':'\ud83e\udd8a',
  'framed_picture':'\ud83d\uddbc',
  'free':'\ud83c\udd93',
  'fried_egg':'\ud83c\udf73',
  'fried_shrimp':'\ud83c\udf64',
  'fries':'\ud83c\udf5f',
  'frog':'\ud83d\udc38',
  'frowning':'\ud83d\ude26',
  'frowning_face':'\u2639\ufe0f',
  'frowning_man':'\ud83d\ude4d&zwj;\u2642\ufe0f',
  'frowning_woman':'\ud83d\ude4d',
  'middle_finger':'\ud83d\udd95',
  'fuelpump':'\u26fd\ufe0f',
  'full_moon':'\ud83c\udf15',
  'full_moon_with_face':'\ud83c\udf1d',
  'funeral_urn':'\u26b1\ufe0f',
  'game_die':'\ud83c\udfb2',
  'gear':'\u2699\ufe0f',
  'gem':'\ud83d\udc8e',
  'gemini':'\u264a\ufe0f',
  'ghost':'\ud83d\udc7b',
  'gift':'\ud83c\udf81',
  'gift_heart':'\ud83d\udc9d',
  'girl':'\ud83d\udc67',
  'globe_with_meridians':'\ud83c\udf10',
  'goal_net':'\ud83e\udd45',
  'goat':'\ud83d\udc10',
  'golf':'\u26f3\ufe0f',
  'golfing_man':'\ud83c\udfcc\ufe0f',
  'golfing_woman':'\ud83c\udfcc\ufe0f&zwj;\u2640\ufe0f',
  'gorilla':'\ud83e\udd8d',
  'grapes':'\ud83c\udf47',
  'green_apple':'\ud83c\udf4f',
  'green_book':'\ud83d\udcd7',
  'green_heart':'\ud83d\udc9a',
  'green_salad':'\ud83e\udd57',
  'grey_exclamation':'\u2755',
  'grey_question':'\u2754',
  'grimacing':'\ud83d\ude2c',
  'grin':'\ud83d\ude01',
  'grinning':'\ud83d\ude00',
  'guardsman':'\ud83d\udc82',
  'guardswoman':'\ud83d\udc82&zwj;\u2640\ufe0f',
  'guitar':'\ud83c\udfb8',
  'gun':'\ud83d\udd2b',
  'haircut_woman':'\ud83d\udc87',
  'haircut_man':'\ud83d\udc87&zwj;\u2642\ufe0f',
  'hamburger':'\ud83c\udf54',
  'hammer':'\ud83d\udd28',
  'hammer_and_pick':'\u2692',
  'hammer_and_wrench':'\ud83d\udee0',
  'hamster':'\ud83d\udc39',
  'hand':'\u270b',
  'handbag':'\ud83d\udc5c',
  'handshake':'\ud83e\udd1d',
  'hankey':'\ud83d\udca9',
  'hatched_chick':'\ud83d\udc25',
  'hatching_chick':'\ud83d\udc23',
  'headphones':'\ud83c\udfa7',
  'hear_no_evil':'\ud83d\ude49',
  'heart':'\u2764\ufe0f',
  'heart_decoration':'\ud83d\udc9f',
  'heart_eyes':'\ud83d\ude0d',
  'heart_eyes_cat':'\ud83d\ude3b',
  'heartbeat':'\ud83d\udc93',
  'heartpulse':'\ud83d\udc97',
  'hearts':'\u2665\ufe0f',
  'heavy_check_mark':'\u2714\ufe0f',
  'heavy_division_sign':'\u2797',
  'heavy_dollar_sign':'\ud83d\udcb2',
  'heavy_heart_exclamation':'\u2763\ufe0f',
  'heavy_minus_sign':'\u2796',
  'heavy_multiplication_x':'\u2716\ufe0f',
  'heavy_plus_sign':'\u2795',
  'helicopter':'\ud83d\ude81',
  'herb':'\ud83c\udf3f',
  'hibiscus':'\ud83c\udf3a',
  'high_brightness':'\ud83d\udd06',
  'high_heel':'\ud83d\udc60',
  'hocho':'\ud83d\udd2a',
  'hole':'\ud83d\udd73',
  'honey_pot':'\ud83c\udf6f',
  'horse':'\ud83d\udc34',
  'horse_racing':'\ud83c\udfc7',
  'hospital':'\ud83c\udfe5',
  'hot_pepper':'\ud83c\udf36',
  'hotdog':'\ud83c\udf2d',
  'hotel':'\ud83c\udfe8',
  'hotsprings':'\u2668\ufe0f',
  'hourglass':'\u231b\ufe0f',
  'hourglass_flowing_sand':'\u23f3',
  'house':'\ud83c\udfe0',
  'house_with_garden':'\ud83c\udfe1',
  'houses':'\ud83c\udfd8',
  'hugs':'\ud83e\udd17',
  'hushed':'\ud83d\ude2f',
  'ice_cream':'\ud83c\udf68',
  'ice_hockey':'\ud83c\udfd2',
  'ice_skate':'\u26f8',
  'icecream':'\ud83c\udf66',
  'id':'\ud83c\udd94',
  'ideograph_advantage':'\ud83c\ude50',
  'imp':'\ud83d\udc7f',
  'inbox_tray':'\ud83d\udce5',
  'incoming_envelope':'\ud83d\udce8',
  'tipping_hand_woman':'\ud83d\udc81',
  'information_source':'\u2139\ufe0f',
  'innocent':'\ud83d\ude07',
  'interrobang':'\u2049\ufe0f',
  'iphone':'\ud83d\udcf1',
  'izakaya_lantern':'\ud83c\udfee',
  'jack_o_lantern':'\ud83c\udf83',
  'japan':'\ud83d\uddfe',
  'japanese_castle':'\ud83c\udfef',
  'japanese_goblin':'\ud83d\udc7a',
  'japanese_ogre':'\ud83d\udc79',
  'jeans':'\ud83d\udc56',
  'joy':'\ud83d\ude02',
  'joy_cat':'\ud83d\ude39',
  'joystick':'\ud83d\udd79',
  'kaaba':'\ud83d\udd4b',
  'key':'\ud83d\udd11',
  'keyboard':'\u2328\ufe0f',
  'keycap_ten':'\ud83d\udd1f',
  'kick_scooter':'\ud83d\udef4',
  'kimono':'\ud83d\udc58',
  'kiss':'\ud83d\udc8b',
  'kissing':'\ud83d\ude17',
  'kissing_cat':'\ud83d\ude3d',
  'kissing_closed_eyes':'\ud83d\ude1a',
  'kissing_heart':'\ud83d\ude18',
  'kissing_smiling_eyes':'\ud83d\ude19',
  'kiwi_fruit':'\ud83e\udd5d',
  'koala':'\ud83d\udc28',
  'koko':'\ud83c\ude01',
  'label':'\ud83c\udff7',
  'large_blue_circle':'\ud83d\udd35',
  'large_blue_diamond':'\ud83d\udd37',
  'large_orange_diamond':'\ud83d\udd36',
  'last_quarter_moon':'\ud83c\udf17',
  'last_quarter_moon_with_face':'\ud83c\udf1c',
  'latin_cross':'\u271d\ufe0f',
  'laughing':'\ud83d\ude06',
  'leaves':'\ud83c\udf43',
  'ledger':'\ud83d\udcd2',
  'left_luggage':'\ud83d\udec5',
  'left_right_arrow':'\u2194\ufe0f',
  'leftwards_arrow_with_hook':'\u21a9\ufe0f',
  'lemon':'\ud83c\udf4b',
  'leo':'\u264c\ufe0f',
  'leopard':'\ud83d\udc06',
  'level_slider':'\ud83c\udf9a',
  'libra':'\u264e\ufe0f',
  'light_rail':'\ud83d\ude88',
  'link':'\ud83d\udd17',
  'lion':'\ud83e\udd81',
  'lips':'\ud83d\udc44',
  'lipstick':'\ud83d\udc84',
  'lizard':'\ud83e\udd8e',
  'lock':'\ud83d\udd12',
  'lock_with_ink_pen':'\ud83d\udd0f',
  'lollipop':'\ud83c\udf6d',
  'loop':'\u27bf',
  'loud_sound':'\ud83d\udd0a',
  'loudspeaker':'\ud83d\udce2',
  'love_hotel':'\ud83c\udfe9',
  'love_letter':'\ud83d\udc8c',
  'low_brightness':'\ud83d\udd05',
  'lying_face':'\ud83e\udd25',
  'm':'\u24c2\ufe0f',
  'mag':'\ud83d\udd0d',
  'mag_right':'\ud83d\udd0e',
  'mahjong':'\ud83c\udc04\ufe0f',
  'mailbox':'\ud83d\udceb',
  'mailbox_closed':'\ud83d\udcea',
  'mailbox_with_mail':'\ud83d\udcec',
  'mailbox_with_no_mail':'\ud83d\udced',
  'man':'\ud83d\udc68',
  'man_artist':'\ud83d\udc68&zwj;\ud83c\udfa8',
  'man_astronaut':'\ud83d\udc68&zwj;\ud83d\ude80',
  'man_cartwheeling':'\ud83e\udd38&zwj;\u2642\ufe0f',
  'man_cook':'\ud83d\udc68&zwj;\ud83c\udf73',
  'man_dancing':'\ud83d\udd7a',
  'man_facepalming':'\ud83e\udd26&zwj;\u2642\ufe0f',
  'man_factory_worker':'\ud83d\udc68&zwj;\ud83c\udfed',
  'man_farmer':'\ud83d\udc68&zwj;\ud83c\udf3e',
  'man_firefighter':'\ud83d\udc68&zwj;\ud83d\ude92',
  'man_health_worker':'\ud83d\udc68&zwj;\u2695\ufe0f',
  'man_in_tuxedo':'\ud83e\udd35',
  'man_judge':'\ud83d\udc68&zwj;\u2696\ufe0f',
  'man_juggling':'\ud83e\udd39&zwj;\u2642\ufe0f',
  'man_mechanic':'\ud83d\udc68&zwj;\ud83d\udd27',
  'man_office_worker':'\ud83d\udc68&zwj;\ud83d\udcbc',
  'man_pilot':'\ud83d\udc68&zwj;\u2708\ufe0f',
  'man_playing_handball':'\ud83e\udd3e&zwj;\u2642\ufe0f',
  'man_playing_water_polo':'\ud83e\udd3d&zwj;\u2642\ufe0f',
  'man_scientist':'\ud83d\udc68&zwj;\ud83d\udd2c',
  'man_shrugging':'\ud83e\udd37&zwj;\u2642\ufe0f',
  'man_singer':'\ud83d\udc68&zwj;\ud83c\udfa4',
  'man_student':'\ud83d\udc68&zwj;\ud83c\udf93',
  'man_teacher':'\ud83d\udc68&zwj;\ud83c\udfeb',
  'man_technologist':'\ud83d\udc68&zwj;\ud83d\udcbb',
  'man_with_gua_pi_mao':'\ud83d\udc72',
  'man_with_turban':'\ud83d\udc73',
  'tangerine':'\ud83c\udf4a',
  'mans_shoe':'\ud83d\udc5e',
  'mantelpiece_clock':'\ud83d\udd70',
  'maple_leaf':'\ud83c\udf41',
  'martial_arts_uniform':'\ud83e\udd4b',
  'mask':'\ud83d\ude37',
  'massage_woman':'\ud83d\udc86',
  'massage_man':'\ud83d\udc86&zwj;\u2642\ufe0f',
  'meat_on_bone':'\ud83c\udf56',
  'medal_military':'\ud83c\udf96',
  'medal_sports':'\ud83c\udfc5',
  'mega':'\ud83d\udce3',
  'melon':'\ud83c\udf48',
  'memo':'\ud83d\udcdd',
  'men_wrestling':'\ud83e\udd3c&zwj;\u2642\ufe0f',
  'menorah':'\ud83d\udd4e',
  'mens':'\ud83d\udeb9',
  'metal':'\ud83e\udd18',
  'metro':'\ud83d\ude87',
  'microphone':'\ud83c\udfa4',
  'microscope':'\ud83d\udd2c',
  'milk_glass':'\ud83e\udd5b',
  'milky_way':'\ud83c\udf0c',
  'minibus':'\ud83d\ude90',
  'minidisc':'\ud83d\udcbd',
  'mobile_phone_off':'\ud83d\udcf4',
  'money_mouth_face':'\ud83e\udd11',
  'money_with_wings':'\ud83d\udcb8',
  'moneybag':'\ud83d\udcb0',
  'monkey':'\ud83d\udc12',
  'monkey_face':'\ud83d\udc35',
  'monorail':'\ud83d\ude9d',
  'moon':'\ud83c\udf14',
  'mortar_board':'\ud83c\udf93',
  'mosque':'\ud83d\udd4c',
  'motor_boat':'\ud83d\udee5',
  'motor_scooter':'\ud83d\udef5',
  'motorcycle':'\ud83c\udfcd',
  'motorway':'\ud83d\udee3',
  'mount_fuji':'\ud83d\uddfb',
  'mountain':'\u26f0',
  'mountain_biking_man':'\ud83d\udeb5',
  'mountain_biking_woman':'\ud83d\udeb5&zwj;\u2640\ufe0f',
  'mountain_cableway':'\ud83d\udea0',
  'mountain_railway':'\ud83d\ude9e',
  'mountain_snow':'\ud83c\udfd4',
  'mouse':'\ud83d\udc2d',
  'mouse2':'\ud83d\udc01',
  'movie_camera':'\ud83c\udfa5',
  'moyai':'\ud83d\uddff',
  'mrs_claus':'\ud83e\udd36',
  'muscle':'\ud83d\udcaa',
  'mushroom':'\ud83c\udf44',
  'musical_keyboard':'\ud83c\udfb9',
  'musical_note':'\ud83c\udfb5',
  'musical_score':'\ud83c\udfbc',
  'mute':'\ud83d\udd07',
  'nail_care':'\ud83d\udc85',
  'name_badge':'\ud83d\udcdb',
  'national_park':'\ud83c\udfde',
  'nauseated_face':'\ud83e\udd22',
  'necktie':'\ud83d\udc54',
  'negative_squared_cross_mark':'\u274e',
  'nerd_face':'\ud83e\udd13',
  'neutral_face':'\ud83d\ude10',
  'new':'\ud83c\udd95',
  'new_moon':'\ud83c\udf11',
  'new_moon_with_face':'\ud83c\udf1a',
  'newspaper':'\ud83d\udcf0',
  'newspaper_roll':'\ud83d\uddde',
  'next_track_button':'\u23ed',
  'ng':'\ud83c\udd96',
  'no_good_man':'\ud83d\ude45&zwj;\u2642\ufe0f',
  'no_good_woman':'\ud83d\ude45',
  'night_with_stars':'\ud83c\udf03',
  'no_bell':'\ud83d\udd15',
  'no_bicycles':'\ud83d\udeb3',
  'no_entry':'\u26d4\ufe0f',
  'no_entry_sign':'\ud83d\udeab',
  'no_mobile_phones':'\ud83d\udcf5',
  'no_mouth':'\ud83d\ude36',
  'no_pedestrians':'\ud83d\udeb7',
  'no_smoking':'\ud83d\udead',
  'non-potable_water':'\ud83d\udeb1',
  'nose':'\ud83d\udc43',
  'notebook':'\ud83d\udcd3',
  'notebook_with_decorative_cover':'\ud83d\udcd4',
  'notes':'\ud83c\udfb6',
  'nut_and_bolt':'\ud83d\udd29',
  'o':'\u2b55\ufe0f',
  'o2':'\ud83c\udd7e\ufe0f',
  'ocean':'\ud83c\udf0a',
  'octopus':'\ud83d\udc19',
  'oden':'\ud83c\udf62',
  'office':'\ud83c\udfe2',
  'oil_drum':'\ud83d\udee2',
  'ok':'\ud83c\udd97',
  'ok_hand':'\ud83d\udc4c',
  'ok_man':'\ud83d\ude46&zwj;\u2642\ufe0f',
  'ok_woman':'\ud83d\ude46',
  'old_key':'\ud83d\udddd',
  'older_man':'\ud83d\udc74',
  'older_woman':'\ud83d\udc75',
  'om':'\ud83d\udd49',
  'on':'\ud83d\udd1b',
  'oncoming_automobile':'\ud83d\ude98',
  'oncoming_bus':'\ud83d\ude8d',
  'oncoming_police_car':'\ud83d\ude94',
  'oncoming_taxi':'\ud83d\ude96',
  'open_file_folder':'\ud83d\udcc2',
  'open_hands':'\ud83d\udc50',
  'open_mouth':'\ud83d\ude2e',
  'open_umbrella':'\u2602\ufe0f',
  'ophiuchus':'\u26ce',
  'orange_book':'\ud83d\udcd9',
  'orthodox_cross':'\u2626\ufe0f',
  'outbox_tray':'\ud83d\udce4',
  'owl':'\ud83e\udd89',
  'ox':'\ud83d\udc02',
  'package':'\ud83d\udce6',
  'page_facing_up':'\ud83d\udcc4',
  'page_with_curl':'\ud83d\udcc3',
  'pager':'\ud83d\udcdf',
  'paintbrush':'\ud83d\udd8c',
  'palm_tree':'\ud83c\udf34',
  'pancakes':'\ud83e\udd5e',
  'panda_face':'\ud83d\udc3c',
  'paperclip':'\ud83d\udcce',
  'paperclips':'\ud83d\udd87',
  'parasol_on_ground':'\u26f1',
  'parking':'\ud83c\udd7f\ufe0f',
  'part_alternation_mark':'\u303d\ufe0f',
  'partly_sunny':'\u26c5\ufe0f',
  'passenger_ship':'\ud83d\udef3',
  'passport_control':'\ud83d\udec2',
  'pause_button':'\u23f8',
  'peace_symbol':'\u262e\ufe0f',
  'peach':'\ud83c\udf51',
  'peanuts':'\ud83e\udd5c',
  'pear':'\ud83c\udf50',
  'pen':'\ud83d\udd8a',
  'pencil2':'\u270f\ufe0f',
  'penguin':'\ud83d\udc27',
  'pensive':'\ud83d\ude14',
  'performing_arts':'\ud83c\udfad',
  'persevere':'\ud83d\ude23',
  'person_fencing':'\ud83e\udd3a',
  'pouting_woman':'\ud83d\ude4e',
  'phone':'\u260e\ufe0f',
  'pick':'\u26cf',
  'pig':'\ud83d\udc37',
  'pig2':'\ud83d\udc16',
  'pig_nose':'\ud83d\udc3d',
  'pill':'\ud83d\udc8a',
  'pineapple':'\ud83c\udf4d',
  'ping_pong':'\ud83c\udfd3',
  'pisces':'\u2653\ufe0f',
  'pizza':'\ud83c\udf55',
  'place_of_worship':'\ud83d\uded0',
  'plate_with_cutlery':'\ud83c\udf7d',
  'play_or_pause_button':'\u23ef',
  'point_down':'\ud83d\udc47',
  'point_left':'\ud83d\udc48',
  'point_right':'\ud83d\udc49',
  'point_up':'\u261d\ufe0f',
  'point_up_2':'\ud83d\udc46',
  'police_car':'\ud83d\ude93',
  'policewoman':'\ud83d\udc6e&zwj;\u2640\ufe0f',
  'poodle':'\ud83d\udc29',
  'popcorn':'\ud83c\udf7f',
  'post_office':'\ud83c\udfe3',
  'postal_horn':'\ud83d\udcef',
  'postbox':'\ud83d\udcee',
  'potable_water':'\ud83d\udeb0',
  'potato':'\ud83e\udd54',
  'pouch':'\ud83d\udc5d',
  'poultry_leg':'\ud83c\udf57',
  'pound':'\ud83d\udcb7',
  'rage':'\ud83d\ude21',
  'pouting_cat':'\ud83d\ude3e',
  'pouting_man':'\ud83d\ude4e&zwj;\u2642\ufe0f',
  'pray':'\ud83d\ude4f',
  'prayer_beads':'\ud83d\udcff',
  'pregnant_woman':'\ud83e\udd30',
  'previous_track_button':'\u23ee',
  'prince':'\ud83e\udd34',
  'princess':'\ud83d\udc78',
  'printer':'\ud83d\udda8',
  'purple_heart':'\ud83d\udc9c',
  'purse':'\ud83d\udc5b',
  'pushpin':'\ud83d\udccc',
  'put_litter_in_its_place':'\ud83d\udeae',
  'question':'\u2753',
  'rabbit':'\ud83d\udc30',
  'rabbit2':'\ud83d\udc07',
  'racehorse':'\ud83d\udc0e',
  'racing_car':'\ud83c\udfce',
  'radio':'\ud83d\udcfb',
  'radio_button':'\ud83d\udd18',
  'radioactive':'\u2622\ufe0f',
  'railway_car':'\ud83d\ude83',
  'railway_track':'\ud83d\udee4',
  'rainbow':'\ud83c\udf08',
  'rainbow_flag':'\ud83c\udff3\ufe0f&zwj;\ud83c\udf08',
  'raised_back_of_hand':'\ud83e\udd1a',
  'raised_hand_with_fingers_splayed':'\ud83d\udd90',
  'raised_hands':'\ud83d\ude4c',
  'raising_hand_woman':'\ud83d\ude4b',
  'raising_hand_man':'\ud83d\ude4b&zwj;\u2642\ufe0f',
  'ram':'\ud83d\udc0f',
  'ramen':'\ud83c\udf5c',
  'rat':'\ud83d\udc00',
  'record_button':'\u23fa',
  'recycle':'\u267b\ufe0f',
  'red_circle':'\ud83d\udd34',
  'registered':'\u00ae\ufe0f',
  'relaxed':'\u263a\ufe0f',
  'relieved':'\ud83d\ude0c',
  'reminder_ribbon':'\ud83c\udf97',
  'repeat':'\ud83d\udd01',
  'repeat_one':'\ud83d\udd02',
  'rescue_worker_helmet':'\u26d1',
  'restroom':'\ud83d\udebb',
  'revolving_hearts':'\ud83d\udc9e',
  'rewind':'\u23ea',
  'rhinoceros':'\ud83e\udd8f',
  'ribbon':'\ud83c\udf80',
  'rice':'\ud83c\udf5a',
  'rice_ball':'\ud83c\udf59',
  'rice_cracker':'\ud83c\udf58',
  'rice_scene':'\ud83c\udf91',
  'right_anger_bubble':'\ud83d\uddef',
  'ring':'\ud83d\udc8d',
  'robot':'\ud83e\udd16',
  'rocket':'\ud83d\ude80',
  'rofl':'\ud83e\udd23',
  'roll_eyes':'\ud83d\ude44',
  'roller_coaster':'\ud83c\udfa2',
  'rooster':'\ud83d\udc13',
  'rose':'\ud83c\udf39',
  'rosette':'\ud83c\udff5',
  'rotating_light':'\ud83d\udea8',
  'round_pushpin':'\ud83d\udccd',
  'rowing_man':'\ud83d\udea3',
  'rowing_woman':'\ud83d\udea3&zwj;\u2640\ufe0f',
  'rugby_football':'\ud83c\udfc9',
  'running_man':'\ud83c\udfc3',
  'running_shirt_with_sash':'\ud83c\udfbd',
  'running_woman':'\ud83c\udfc3&zwj;\u2640\ufe0f',
  'sa':'\ud83c\ude02\ufe0f',
  'sagittarius':'\u2650\ufe0f',
  'sake':'\ud83c\udf76',
  'sandal':'\ud83d\udc61',
  'santa':'\ud83c\udf85',
  'satellite':'\ud83d\udce1',
  'saxophone':'\ud83c\udfb7',
  'school':'\ud83c\udfeb',
  'school_satchel':'\ud83c\udf92',
  'scissors':'\u2702\ufe0f',
  'scorpion':'\ud83e\udd82',
  'scorpius':'\u264f\ufe0f',
  'scream':'\ud83d\ude31',
  'scream_cat':'\ud83d\ude40',
  'scroll':'\ud83d\udcdc',
  'seat':'\ud83d\udcba',
  'secret':'\u3299\ufe0f',
  'see_no_evil':'\ud83d\ude48',
  'seedling':'\ud83c\udf31',
  'selfie':'\ud83e\udd33',
  'shallow_pan_of_food':'\ud83e\udd58',
  'shamrock':'\u2618\ufe0f',
  'shark':'\ud83e\udd88',
  'shaved_ice':'\ud83c\udf67',
  'sheep':'\ud83d\udc11',
  'shell':'\ud83d\udc1a',
  'shield':'\ud83d\udee1',
  'shinto_shrine':'\u26e9',
  'ship':'\ud83d\udea2',
  'shirt':'\ud83d\udc55',
  'shopping':'\ud83d\udecd',
  'shopping_cart':'\ud83d\uded2',
  'shower':'\ud83d\udebf',
  'shrimp':'\ud83e\udd90',
  'signal_strength':'\ud83d\udcf6',
  'six_pointed_star':'\ud83d\udd2f',
  'ski':'\ud83c\udfbf',
  'skier':'\u26f7',
  'skull':'\ud83d\udc80',
  'skull_and_crossbones':'\u2620\ufe0f',
  'sleeping':'\ud83d\ude34',
  'sleeping_bed':'\ud83d\udecc',
  'sleepy':'\ud83d\ude2a',
  'slightly_frowning_face':'\ud83d\ude41',
  'slightly_smiling_face':'\ud83d\ude42',
  'slot_machine':'\ud83c\udfb0',
  'small_airplane':'\ud83d\udee9',
  'small_blue_diamond':'\ud83d\udd39',
  'small_orange_diamond':'\ud83d\udd38',
  'small_red_triangle':'\ud83d\udd3a',
  'small_red_triangle_down':'\ud83d\udd3b',
  'smile':'\ud83d\ude04',
  'smile_cat':'\ud83d\ude38',
  'smiley':'\ud83d\ude03',
  'smiley_cat':'\ud83d\ude3a',
  'smiling_imp':'\ud83d\ude08',
  'smirk':'\ud83d\ude0f',
  'smirk_cat':'\ud83d\ude3c',
  'smoking':'\ud83d\udeac',
  'snail':'\ud83d\udc0c',
  'snake':'\ud83d\udc0d',
  'sneezing_face':'\ud83e\udd27',
  'snowboarder':'\ud83c\udfc2',
  'snowflake':'\u2744\ufe0f',
  'snowman':'\u26c4\ufe0f',
  'snowman_with_snow':'\u2603\ufe0f',
  'sob':'\ud83d\ude2d',
  'soccer':'\u26bd\ufe0f',
  'soon':'\ud83d\udd1c',
  'sos':'\ud83c\udd98',
  'sound':'\ud83d\udd09',
  'space_invader':'\ud83d\udc7e',
  'spades':'\u2660\ufe0f',
  'spaghetti':'\ud83c\udf5d',
  'sparkle':'\u2747\ufe0f',
  'sparkler':'\ud83c\udf87',
  'sparkles':'\u2728',
  'sparkling_heart':'\ud83d\udc96',
  'speak_no_evil':'\ud83d\ude4a',
  'speaker':'\ud83d\udd08',
  'speaking_head':'\ud83d\udde3',
  'speech_balloon':'\ud83d\udcac',
  'speedboat':'\ud83d\udea4',
  'spider':'\ud83d\udd77',
  'spider_web':'\ud83d\udd78',
  'spiral_calendar':'\ud83d\uddd3',
  'spiral_notepad':'\ud83d\uddd2',
  'spoon':'\ud83e\udd44',
  'squid':'\ud83e\udd91',
  'stadium':'\ud83c\udfdf',
  'star':'\u2b50\ufe0f',
  'star2':'\ud83c\udf1f',
  'star_and_crescent':'\u262a\ufe0f',
  'star_of_david':'\u2721\ufe0f',
  'stars':'\ud83c\udf20',
  'station':'\ud83d\ude89',
  'statue_of_liberty':'\ud83d\uddfd',
  'steam_locomotive':'\ud83d\ude82',
  'stew':'\ud83c\udf72',
  'stop_button':'\u23f9',
  'stop_sign':'\ud83d\uded1',
  'stopwatch':'\u23f1',
  'straight_ruler':'\ud83d\udccf',
  'strawberry':'\ud83c\udf53',
  'stuck_out_tongue':'\ud83d\ude1b',
  'stuck_out_tongue_closed_eyes':'\ud83d\ude1d',
  'stuck_out_tongue_winking_eye':'\ud83d\ude1c',
  'studio_microphone':'\ud83c\udf99',
  'stuffed_flatbread':'\ud83e\udd59',
  'sun_behind_large_cloud':'\ud83c\udf25',
  'sun_behind_rain_cloud':'\ud83c\udf26',
  'sun_behind_small_cloud':'\ud83c\udf24',
  'sun_with_face':'\ud83c\udf1e',
  'sunflower':'\ud83c\udf3b',
  'sunglasses':'\ud83d\ude0e',
  'sunny':'\u2600\ufe0f',
  'sunrise':'\ud83c\udf05',
  'sunrise_over_mountains':'\ud83c\udf04',
  'surfing_man':'\ud83c\udfc4',
  'surfing_woman':'\ud83c\udfc4&zwj;\u2640\ufe0f',
  'sushi':'\ud83c\udf63',
  'suspension_railway':'\ud83d\ude9f',
  'sweat':'\ud83d\ude13',
  'sweat_drops':'\ud83d\udca6',
  'sweat_smile':'\ud83d\ude05',
  'sweet_potato':'\ud83c\udf60',
  'swimming_man':'\ud83c\udfca',
  'swimming_woman':'\ud83c\udfca&zwj;\u2640\ufe0f',
  'symbols':'\ud83d\udd23',
  'synagogue':'\ud83d\udd4d',
  'syringe':'\ud83d\udc89',
  'taco':'\ud83c\udf2e',
  'tada':'\ud83c\udf89',
  'tanabata_tree':'\ud83c\udf8b',
  'taurus':'\u2649\ufe0f',
  'taxi':'\ud83d\ude95',
  'tea':'\ud83c\udf75',
  'telephone_receiver':'\ud83d\udcde',
  'telescope':'\ud83d\udd2d',
  'tennis':'\ud83c\udfbe',
  'tent':'\u26fa\ufe0f',
  'thermometer':'\ud83c\udf21',
  'thinking':'\ud83e\udd14',
  'thought_balloon':'\ud83d\udcad',
  'ticket':'\ud83c\udfab',
  'tickets':'\ud83c\udf9f',
  'tiger':'\ud83d\udc2f',
  'tiger2':'\ud83d\udc05',
  'timer_clock':'\u23f2',
  'tipping_hand_man':'\ud83d\udc81&zwj;\u2642\ufe0f',
  'tired_face':'\ud83d\ude2b',
  'tm':'\u2122\ufe0f',
  'toilet':'\ud83d\udebd',
  'tokyo_tower':'\ud83d\uddfc',
  'tomato':'\ud83c\udf45',
  'tongue':'\ud83d\udc45',
  'top':'\ud83d\udd1d',
  'tophat':'\ud83c\udfa9',
  'tornado':'\ud83c\udf2a',
  'trackball':'\ud83d\uddb2',
  'tractor':'\ud83d\ude9c',
  'traffic_light':'\ud83d\udea5',
  'train':'\ud83d\ude8b',
  'train2':'\ud83d\ude86',
  'tram':'\ud83d\ude8a',
  'triangular_flag_on_post':'\ud83d\udea9',
  'triangular_ruler':'\ud83d\udcd0',
  'trident':'\ud83d\udd31',
  'triumph':'\ud83d\ude24',
  'trolleybus':'\ud83d\ude8e',
  'trophy':'\ud83c\udfc6',
  'tropical_drink':'\ud83c\udf79',
  'tropical_fish':'\ud83d\udc20',
  'truck':'\ud83d\ude9a',
  'trumpet':'\ud83c\udfba',
  'tulip':'\ud83c\udf37',
  'tumbler_glass':'\ud83e\udd43',
  'turkey':'\ud83e\udd83',
  'turtle':'\ud83d\udc22',
  'tv':'\ud83d\udcfa',
  'twisted_rightwards_arrows':'\ud83d\udd00',
  'two_hearts':'\ud83d\udc95',
  'two_men_holding_hands':'\ud83d\udc6c',
  'two_women_holding_hands':'\ud83d\udc6d',
  'u5272':'\ud83c\ude39',
  'u5408':'\ud83c\ude34',
  'u55b6':'\ud83c\ude3a',
  'u6307':'\ud83c\ude2f\ufe0f',
  'u6708':'\ud83c\ude37\ufe0f',
  'u6709':'\ud83c\ude36',
  'u6e80':'\ud83c\ude35',
  'u7121':'\ud83c\ude1a\ufe0f',
  'u7533':'\ud83c\ude38',
  'u7981':'\ud83c\ude32',
  'u7a7a':'\ud83c\ude33',
  'umbrella':'\u2614\ufe0f',
  'unamused':'\ud83d\ude12',
  'underage':'\ud83d\udd1e',
  'unicorn':'\ud83e\udd84',
  'unlock':'\ud83d\udd13',
  'up':'\ud83c\udd99',
  'upside_down_face':'\ud83d\ude43',
  'v':'\u270c\ufe0f',
  'vertical_traffic_light':'\ud83d\udea6',
  'vhs':'\ud83d\udcfc',
  'vibration_mode':'\ud83d\udcf3',
  'video_camera':'\ud83d\udcf9',
  'video_game':'\ud83c\udfae',
  'violin':'\ud83c\udfbb',
  'virgo':'\u264d\ufe0f',
  'volcano':'\ud83c\udf0b',
  'volleyball':'\ud83c\udfd0',
  'vs':'\ud83c\udd9a',
  'vulcan_salute':'\ud83d\udd96',
  'walking_man':'\ud83d\udeb6',
  'walking_woman':'\ud83d\udeb6&zwj;\u2640\ufe0f',
  'waning_crescent_moon':'\ud83c\udf18',
  'waning_gibbous_moon':'\ud83c\udf16',
  'warning':'\u26a0\ufe0f',
  'wastebasket':'\ud83d\uddd1',
  'watch':'\u231a\ufe0f',
  'water_buffalo':'\ud83d\udc03',
  'watermelon':'\ud83c\udf49',
  'wave':'\ud83d\udc4b',
  'wavy_dash':'\u3030\ufe0f',
  'waxing_crescent_moon':'\ud83c\udf12',
  'wc':'\ud83d\udebe',
  'weary':'\ud83d\ude29',
  'wedding':'\ud83d\udc92',
  'weight_lifting_man':'\ud83c\udfcb\ufe0f',
  'weight_lifting_woman':'\ud83c\udfcb\ufe0f&zwj;\u2640\ufe0f',
  'whale':'\ud83d\udc33',
  'whale2':'\ud83d\udc0b',
  'wheel_of_dharma':'\u2638\ufe0f',
  'wheelchair':'\u267f\ufe0f',
  'white_check_mark':'\u2705',
  'white_circle':'\u26aa\ufe0f',
  'white_flag':'\ud83c\udff3\ufe0f',
  'white_flower':'\ud83d\udcae',
  'white_large_square':'\u2b1c\ufe0f',
  'white_medium_small_square':'\u25fd\ufe0f',
  'white_medium_square':'\u25fb\ufe0f',
  'white_small_square':'\u25ab\ufe0f',
  'white_square_button':'\ud83d\udd33',
  'wilted_flower':'\ud83e\udd40',
  'wind_chime':'\ud83c\udf90',
  'wind_face':'\ud83c\udf2c',
  'wine_glass':'\ud83c\udf77',
  'wink':'\ud83d\ude09',
  'wolf':'\ud83d\udc3a',
  'woman':'\ud83d\udc69',
  'woman_artist':'\ud83d\udc69&zwj;\ud83c\udfa8',
  'woman_astronaut':'\ud83d\udc69&zwj;\ud83d\ude80',
  'woman_cartwheeling':'\ud83e\udd38&zwj;\u2640\ufe0f',
  'woman_cook':'\ud83d\udc69&zwj;\ud83c\udf73',
  'woman_facepalming':'\ud83e\udd26&zwj;\u2640\ufe0f',
  'woman_factory_worker':'\ud83d\udc69&zwj;\ud83c\udfed',
  'woman_farmer':'\ud83d\udc69&zwj;\ud83c\udf3e',
  'woman_firefighter':'\ud83d\udc69&zwj;\ud83d\ude92',
  'woman_health_worker':'\ud83d\udc69&zwj;\u2695\ufe0f',
  'woman_judge':'\ud83d\udc69&zwj;\u2696\ufe0f',
  'woman_juggling':'\ud83e\udd39&zwj;\u2640\ufe0f',
  'woman_mechanic':'\ud83d\udc69&zwj;\ud83d\udd27',
  'woman_office_worker':'\ud83d\udc69&zwj;\ud83d\udcbc',
  'woman_pilot':'\ud83d\udc69&zwj;\u2708\ufe0f',
  'woman_playing_handball':'\ud83e\udd3e&zwj;\u2640\ufe0f',
  'woman_playing_water_polo':'\ud83e\udd3d&zwj;\u2640\ufe0f',
  'woman_scientist':'\ud83d\udc69&zwj;\ud83d\udd2c',
  'woman_shrugging':'\ud83e\udd37&zwj;\u2640\ufe0f',
  'woman_singer':'\ud83d\udc69&zwj;\ud83c\udfa4',
  'woman_student':'\ud83d\udc69&zwj;\ud83c\udf93',
  'woman_teacher':'\ud83d\udc69&zwj;\ud83c\udfeb',
  'woman_technologist':'\ud83d\udc69&zwj;\ud83d\udcbb',
  'woman_with_turban':'\ud83d\udc73&zwj;\u2640\ufe0f',
  'womans_clothes':'\ud83d\udc5a',
  'womans_hat':'\ud83d\udc52',
  'women_wrestling':'\ud83e\udd3c&zwj;\u2640\ufe0f',
  'womens':'\ud83d\udeba',
  'world_map':'\ud83d\uddfa',
  'worried':'\ud83d\ude1f',
  'wrench':'\ud83d\udd27',
  'writing_hand':'\u270d\ufe0f',
  'x':'\u274c',
  'yellow_heart':'\ud83d\udc9b',
  'yen':'\ud83d\udcb4',
  'yin_yang':'\u262f\ufe0f',
  'yum':'\ud83d\ude0b',
  'zap':'\u26a1\ufe0f',
  'zipper_mouth_face':'\ud83e\udd10',
  'zzz':'\ud83d\udca4',

  /* special emojis :P */
  'octocat':  '<img alt=":octocat:" height="20" width="20" align="absmiddle" src="https://assets-cdn.github.com/images/icons/emoji/octocat.png">',
  'showdown': '<span style="font-family: \'Anonymous Pro\', monospace; text-decoration: underline; text-decoration-style: dashed; text-decoration-color: #3e8b8a;text-underline-position: under;">S</span>'
};

/**
 * Created by Estevao on 31-05-2015.
 */

/**
 * Showdown Converter class
 * @class
 * @param {object} [converterOptions]
 * @returns {Converter}
 */
showdown.Converter = function (converterOptions) {

  var
      /**
       * Options used by this converter
       * @private
       * @type {{}}
       */
      options = {},

      /**
       * Language extensions used by this converter
       * @private
       * @type {Array}
       */
      langExtensions = [],

      /**
       * Output modifiers extensions used by this converter
       * @private
       * @type {Array}
       */
      outputModifiers = [],

      /**
       * Event listeners
       * @private
       * @type {{}}
       */
      listeners = {},

      /**
       * The flavor set in this converter
       */
      setConvFlavor = setFlavor,

      /**
       * Metadata of the document
       * @type {{parsed: {}, raw: string, format: string}}
       */
      metadata = {
        parsed: {},
        raw: '',
        format: ''
      };

  _constructor();

  /**
   * Converter constructor
   * @private
   */
  function _constructor () {
    converterOptions = converterOptions || {};

    for (var gOpt in globalOptions) {
      if (globalOptions.hasOwnProperty(gOpt)) {
        options[gOpt] = globalOptions[gOpt];
      }
    }

    // Merge options
    if (typeof converterOptions === 'object') {
      for (var opt in converterOptions) {
        if (converterOptions.hasOwnProperty(opt)) {
          options[opt] = converterOptions[opt];
        }
      }
    } else {
      throw Error('Converter expects the passed parameter to be an object, but ' + typeof converterOptions +
      ' was passed instead.');
    }

    if (options.extensions) {
      showdown.helper.forEach(options.extensions, _parseExtension);
    }
  }

  /**
   * Parse extension
   * @param {*} ext
   * @param {string} [name='']
   * @private
   */
  function _parseExtension (ext, name) {

    name = name || null;
    // If it's a string, the extension was previously loaded
    if (showdown.helper.isString(ext)) {
      ext = showdown.helper.stdExtName(ext);
      name = ext;

      // LEGACY_SUPPORT CODE
      if (showdown.extensions[ext]) {
        console.warn('DEPRECATION WARNING: ' + ext + ' is an old extension that uses a deprecated loading method.' +
          'Please inform the developer that the extension should be updated!');
        legacyExtensionLoading(showdown.extensions[ext], ext);
        return;
        // END LEGACY SUPPORT CODE

      } else if (!showdown.helper.isUndefined(extensions[ext])) {
        ext = extensions[ext];

      } else {
        throw Error('Extension "' + ext + '" could not be loaded. It was either not found or is not a valid extension.');
      }
    }

    if (typeof ext === 'function') {
      ext = ext();
    }

    if (!showdown.helper.isArray(ext)) {
      ext = [ext];
    }

    var validExt = validate(ext, name);
    if (!validExt.valid) {
      throw Error(validExt.error);
    }

    for (var i = 0; i < ext.length; ++i) {
      switch (ext[i].type) {

        case 'lang':
          langExtensions.push(ext[i]);
          break;

        case 'output':
          outputModifiers.push(ext[i]);
          break;
      }
      if (ext[i].hasOwnProperty('listeners')) {
        for (var ln in ext[i].listeners) {
          if (ext[i].listeners.hasOwnProperty(ln)) {
            listen(ln, ext[i].listeners[ln]);
          }
        }
      }
    }

  }

  /**
   * LEGACY_SUPPORT
   * @param {*} ext
   * @param {string} name
   */
  function legacyExtensionLoading (ext, name) {
    if (typeof ext === 'function') {
      ext = ext(new showdown.Converter());
    }
    if (!showdown.helper.isArray(ext)) {
      ext = [ext];
    }
    var valid = validate(ext, name);

    if (!valid.valid) {
      throw Error(valid.error);
    }

    for (var i = 0; i < ext.length; ++i) {
      switch (ext[i].type) {
        case 'lang':
          langExtensions.push(ext[i]);
          break;
        case 'output':
          outputModifiers.push(ext[i]);
          break;
        default:// should never reach here
          throw Error('Extension loader error: Type unrecognized!!!');
      }
    }
  }

  /**
   * Listen to an event
   * @param {string} name
   * @param {function} callback
   */
  function listen (name, callback) {
    if (!showdown.helper.isString(name)) {
      throw Error('Invalid argument in converter.listen() method: name must be a string, but ' + typeof name + ' given');
    }

    if (typeof callback !== 'function') {
      throw Error('Invalid argument in converter.listen() method: callback must be a function, but ' + typeof callback + ' given');
    }

    if (!listeners.hasOwnProperty(name)) {
      listeners[name] = [];
    }
    listeners[name].push(callback);
  }

  function rTrimInputText (text) {
    var rsp = text.match(/^\s*/)[0].length,
        rgx = new RegExp('^\\s{0,' + rsp + '}', 'gm');
    return text.replace(rgx, '');
  }

  /**
   * Dispatch an event
   * @private
   * @param {string} evtName Event name
   * @param {string} text Text
   * @param {{}} options Converter Options
   * @param {{}} globals
   * @returns {string}
   */
  this._dispatch = function dispatch (evtName, text, options, globals) {
    if (listeners.hasOwnProperty(evtName)) {
      for (var ei = 0; ei < listeners[evtName].length; ++ei) {
        var nText = listeners[evtName][ei](evtName, text, this, options, globals);
        if (nText && typeof nText !== 'undefined') {
          text = nText;
        }
      }
    }
    return text;
  };

  /**
   * Listen to an event
   * @param {string} name
   * @param {function} callback
   * @returns {showdown.Converter}
   */
  this.listen = function (name, callback) {
    listen(name, callback);
    return this;
  };

  /**
   * Converts a markdown string into HTML
   * @param {string} text
   * @returns {*}
   */
  this.makeHtml = function (text) {
    //check if text is not falsy
    if (!text) {
      return text;
    }

    var globals = {
      gHtmlBlocks:     [],
      gHtmlMdBlocks:   [],
      gHtmlSpans:      [],
      gUrls:           {},
      gTitles:         {},
      gDimensions:     {},
      gListLevel:      0,
      hashLinkCounts:  {},
      langExtensions:  langExtensions,
      outputModifiers: outputModifiers,
      converter:       this,
      ghCodeBlocks:    [],
      metadata: {
        parsed: {},
        raw: '',
        format: ''
      }
    };

    // This lets us use ¨ trema as an escape char to avoid md5 hashes
    // The choice of character is arbitrary; anything that isn't
    // magic in Markdown will work.
    text = text.replace(/¨/g, '¨T');

    // Replace $ with ¨D
    // RegExp interprets $ as a special character
    // when it's in a replacement string
    text = text.replace(/\$/g, '¨D');

    // Standardize line endings
    text = text.replace(/\r\n/g, '\n'); // DOS to Unix
    text = text.replace(/\r/g, '\n'); // Mac to Unix

    // Stardardize line spaces
    text = text.replace(/\u00A0/g, '&nbsp;');

    if (options.smartIndentationFix) {
      text = rTrimInputText(text);
    }

    // Make sure text begins and ends with a couple of newlines:
    text = '\n\n' + text + '\n\n';

    // detab
    text = showdown.subParser('detab')(text, options, globals);

    /**
     * Strip any lines consisting only of spaces and tabs.
     * This makes subsequent regexs easier to write, because we can
     * match consecutive blank lines with /\n+/ instead of something
     * contorted like /[ \t]*\n+/
     */
    text = text.replace(/^[ \t]+$/mg, '');

    //run languageExtensions
    showdown.helper.forEach(langExtensions, function (ext) {
      text = showdown.subParser('runExtension')(ext, text, options, globals);
    });

    // run the sub parsers
    text = showdown.subParser('metadata')(text, options, globals);
    text = showdown.subParser('hashPreCodeTags')(text, options, globals);
    text = showdown.subParser('githubCodeBlocks')(text, options, globals);
    text = showdown.subParser('hashHTMLBlocks')(text, options, globals);
    text = showdown.subParser('hashCodeTags')(text, options, globals);
    text = showdown.subParser('stripLinkDefinitions')(text, options, globals);
    text = showdown.subParser('blockGamut')(text, options, globals);
    text = showdown.subParser('unhashHTMLSpans')(text, options, globals);
    text = showdown.subParser('unescapeSpecialChars')(text, options, globals);

    // attacklab: Restore dollar signs
    text = text.replace(/¨D/g, '$$');

    // attacklab: Restore tremas
    text = text.replace(/¨T/g, '¨');

    // render a complete html document instead of a partial if the option is enabled
    text = showdown.subParser('completeHTMLDocument')(text, options, globals);

    // Run output modifiers
    showdown.helper.forEach(outputModifiers, function (ext) {
      text = showdown.subParser('runExtension')(ext, text, options, globals);
    });

    // update metadata
    metadata = globals.metadata;
    return text;
  };

  /**
   * Converts an HTML string into a markdown string
   * @param src
   * @param [HTMLParser] A WHATWG DOM and HTML parser, such as JSDOM. If none is supplied, window.document will be used.
   * @returns {string}
   */
  this.makeMarkdown = this.makeMd = function (src, HTMLParser) {

    // replace \r\n with \n
    src = src.replace(/\r\n/g, '\n');
    src = src.replace(/\r/g, '\n'); // old macs

    // due to an edge case, we need to find this: > <
    // to prevent removing of non silent white spaces
    // ex: <em>this is</em> <strong>sparta</strong>
    src = src.replace(/>[ \t]+</, '>¨NBSP;<');

    if (!HTMLParser) {
      if (window && window.document) {
        HTMLParser = window.document;
      } else {
        throw new Error('HTMLParser is undefined. If in a webworker or nodejs environment, you need to provide a WHATWG DOM and HTML such as JSDOM');
      }
    }

    var doc = HTMLParser.createElement('div');
    doc.innerHTML = src;

    var globals = {
      preList: substitutePreCodeTags(doc)
    };

    // remove all newlines and collapse spaces
    clean(doc);

    // some stuff, like accidental reference links must now be escaped
    // TODO
    // doc.innerHTML = doc.innerHTML.replace(/\[[\S\t ]]/);

    var nodes = doc.childNodes,
        mdDoc = '';

    for (var i = 0; i < nodes.length; i++) {
      mdDoc += showdown.subParser('makeMarkdown.node')(nodes[i], globals);
    }

    function clean (node) {
      for (var n = 0; n < node.childNodes.length; ++n) {
        var child = node.childNodes[n];
        if (child.nodeType === 3) {
          if (!/\S/.test(child.nodeValue)) {
            node.removeChild(child);
            --n;
          } else {
            child.nodeValue = child.nodeValue.split('\n').join(' ');
            child.nodeValue = child.nodeValue.replace(/(\s)+/g, '$1');
          }
        } else if (child.nodeType === 1) {
          clean(child);
        }
      }
    }

    // find all pre tags and replace contents with placeholder
    // we need this so that we can remove all indentation from html
    // to ease up parsing
    function substitutePreCodeTags (doc) {

      var pres = doc.querySelectorAll('pre'),
          presPH = [];

      for (var i = 0; i < pres.length; ++i) {

        if (pres[i].childElementCount === 1 && pres[i].firstChild.tagName.toLowerCase() === 'code') {
          var content = pres[i].firstChild.innerHTML.trim(),
              language = pres[i].firstChild.getAttribute('data-language') || '';

          // if data-language attribute is not defined, then we look for class language-*
          if (language === '') {
            var classes = pres[i].firstChild.className.split(' ');
            for (var c = 0; c < classes.length; ++c) {
              var matches = classes[c].match(/^language-(.+)$/);
              if (matches !== null) {
                language = matches[1];
                break;
              }
            }
          }

          // unescape html entities in content
          content = showdown.helper.unescapeHTMLEntities(content);

          presPH.push(content);
          pres[i].outerHTML = '<precode language="' + language + '" precodenum="' + i.toString() + '"></precode>';
        } else {
          presPH.push(pres[i].innerHTML);
          pres[i].innerHTML = '';
          pres[i].setAttribute('prenum', i.toString());
        }
      }
      return presPH;
    }

    return mdDoc;
  };

  /**
   * Set an option of this Converter instance
   * @param {string} key
   * @param {*} value
   */
  this.setOption = function (key, value) {
    options[key] = value;
  };

  /**
   * Get the option of this Converter instance
   * @param {string} key
   * @returns {*}
   */
  this.getOption = function (key) {
    return options[key];
  };

  /**
   * Get the options of this Converter instance
   * @returns {{}}
   */
  this.getOptions = function () {
    return options;
  };

  /**
   * Add extension to THIS converter
   * @param {{}} extension
   * @param {string} [name=null]
   */
  this.addExtension = function (extension, name) {
    name = name || null;
    _parseExtension(extension, name);
  };

  /**
   * Use a global registered extension with THIS converter
   * @param {string} extensionName Name of the previously registered extension
   */
  this.useExtension = function (extensionName) {
    _parseExtension(extensionName);
  };

  /**
   * Set the flavor THIS converter should use
   * @param {string} name
   */
  this.setFlavor = function (name) {
    if (!flavor.hasOwnProperty(name)) {
      throw Error(name + ' flavor was not found');
    }
    var preset = flavor[name];
    setConvFlavor = name;
    for (var option in preset) {
      if (preset.hasOwnProperty(option)) {
        options[option] = preset[option];
      }
    }
  };

  /**
   * Get the currently set flavor of this converter
   * @returns {string}
   */
  this.getFlavor = function () {
    return setConvFlavor;
  };

  /**
   * Remove an extension from THIS converter.
   * Note: This is a costly operation. It's better to initialize a new converter
   * and specify the extensions you wish to use
   * @param {Array} extension
   */
  this.removeExtension = function (extension) {
    if (!showdown.helper.isArray(extension)) {
      extension = [extension];
    }
    for (var a = 0; a < extension.length; ++a) {
      var ext = extension[a];
      for (var i = 0; i < langExtensions.length; ++i) {
        if (langExtensions[i] === ext) {
          langExtensions[i].splice(i, 1);
        }
      }
      for (var ii = 0; ii < outputModifiers.length; ++i) {
        if (outputModifiers[ii] === ext) {
          outputModifiers[ii].splice(i, 1);
        }
      }
    }
  };

  /**
   * Get all extension of THIS converter
   * @returns {{language: Array, output: Array}}
   */
  this.getAllExtensions = function () {
    return {
      language: langExtensions,
      output: outputModifiers
    };
  };

  /**
   * Get the metadata of the previously parsed document
   * @param raw
   * @returns {string|{}}
   */
  this.getMetadata = function (raw) {
    if (raw) {
      return metadata.raw;
    } else {
      return metadata.parsed;
    }
  };

  /**
   * Get the metadata format of the previously parsed document
   * @returns {string}
   */
  this.getMetadataFormat = function () {
    return metadata.format;
  };

  /**
   * Private: set a single key, value metadata pair
   * @param {string} key
   * @param {string} value
   */
  this._setMetadataPair = function (key, value) {
    metadata.parsed[key] = value;
  };

  /**
   * Private: set metadata format
   * @param {string} format
   */
  this._setMetadataFormat = function (format) {
    metadata.format = format;
  };

  /**
   * Private: set metadata raw text
   * @param {string} raw
   */
  this._setMetadataRaw = function (raw) {
    metadata.raw = raw;
  };
};

/**
 * Turn Markdown link shortcuts into XHTML <a> tags.
 */
showdown.subParser('anchors', function (text, options, globals) {

  text = globals.converter._dispatch('anchors.before', text, options, globals);

  var writeAnchorTag = function (wholeMatch, linkText, linkId, url, m5, m6, title) {
    if (showdown.helper.isUndefined(title)) {
      title = '';
    }
    linkId = linkId.toLowerCase();

    // Special case for explicit empty url
    if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) {
      url = '';
    } else if (!url) {
      if (!linkId) {
        // lower-case and turn embedded newlines into spaces
        linkId = linkText.toLowerCase().replace(/ ?\n/g, ' ');
      }
      url = '#' + linkId;

      if (!showdown.helper.isUndefined(globals.gUrls[linkId])) {
        url = globals.gUrls[linkId];
        if (!showdown.helper.isUndefined(globals.gTitles[linkId])) {
          title = globals.gTitles[linkId];
        }
      } else {
        return wholeMatch;
      }
    }

    //url = showdown.helper.escapeCharacters(url, '*_', false); // replaced line to improve performance
    url = url.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);

    var result = '<a href="' + url + '"';

    if (title !== '' && title !== null) {
      title = title.replace(/"/g, '&quot;');
      //title = showdown.helper.escapeCharacters(title, '*_', false); // replaced line to improve performance
      title = title.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
      result += ' title="' + title + '"';
    }

    // optionLinksInNewWindow only applies
    // to external links. Hash links (#) open in same page
    if (options.openLinksInNewWindow && !/^#/.test(url)) {
      // escaped _
      result += ' rel="noopener noreferrer" target="¨E95Eblank"';
    }

    result += '>' + linkText + '</a>';

    return result;
  };

  // First, handle reference-style links: [link text] [id]
  text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)] ?(?:\n *)?\[(.*?)]()()()()/g, writeAnchorTag);

  // Next, inline-style links: [link text](url "optional title")
  // cases with crazy urls like ./image/cat1).png
  text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<([^>]*)>(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g,
    writeAnchorTag);

  // normal cases
  text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g,
    writeAnchorTag);

  // handle reference-style shortcuts: [link text]
  // These must come last in case you've also got [link test][1]
  // or [link test](/foo)
  text = text.replace(/\[([^\[\]]+)]()()()()()/g, writeAnchorTag);

  // Lastly handle GithubMentions if option is enabled
  if (options.ghMentions) {
    text = text.replace(/(^|\s)(\\)?(@([a-z\d]+(?:[a-z\d.-]+?[a-z\d]+)*))/gmi, function (wm, st, escape, mentions, username) {
      if (escape === '\\') {
        return st + mentions;
      }

      //check if options.ghMentionsLink is a string
      if (!showdown.helper.isString(options.ghMentionsLink)) {
        throw new Error('ghMentionsLink option must be a string');
      }
      var lnk = options.ghMentionsLink.replace(/\{u}/g, username),
          target = '';
      if (options.openLinksInNewWindow) {
        target = ' rel="noopener noreferrer" target="¨E95Eblank"';
      }
      return st + '<a href="' + lnk + '"' + target + '>' + mentions + '</a>';
    });
  }

  text = globals.converter._dispatch('anchors.after', text, options, globals);
  return text;
});

// url allowed chars [a-z\d_.~:/?#[]@!$&'()*+,;=-]

var simpleURLRegex  = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+?\.[^'">\s]+?)()(\1)?(?=\s|$)(?!["<>])/gi,
    simpleURLRegex2 = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+\.[^'">\s]+?)([.!?,()\[\]])?(\1)?(?=\s|$)(?!["<>])/gi,
    delimUrlRegex   = /()<(((https?|ftp|dict):\/\/|www\.)[^'">\s]+)()>()/gi,
    simpleMailRegex = /(^|\s)(?:mailto:)?([A-Za-z0-9!#$%&'*+-/=?^_`{|}~.]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)(?=$|\s)/gmi,
    delimMailRegex  = /<()(?:mailto:)?([-.\w]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)>/gi,

    replaceLink = function (options) {
      return function (wm, leadingMagicChars, link, m2, m3, trailingPunctuation, trailingMagicChars) {
        link = link.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
        var lnkTxt = link,
            append = '',
            target = '',
            lmc    = leadingMagicChars || '',
            tmc    = trailingMagicChars || '';
        if (/^www\./i.test(link)) {
          link = link.replace(/^www\./i, 'http://www.');
        }
        if (options.excludeTrailingPunctuationFromURLs && trailingPunctuation) {
          append = trailingPunctuation;
        }
        if (options.openLinksInNewWindow) {
          target = ' rel="noopener noreferrer" target="¨E95Eblank"';
        }
        return lmc + '<a href="' + link + '"' + target + '>' + lnkTxt + '</a>' + append + tmc;
      };
    },

    replaceMail = function (options, globals) {
      return function (wholeMatch, b, mail) {
        var href = 'mailto:';
        b = b || '';
        mail = showdown.subParser('unescapeSpecialChars')(mail, options, globals);
        if (options.encodeEmails) {
          href = showdown.helper.encodeEmailAddress(href + mail);
          mail = showdown.helper.encodeEmailAddress(mail);
        } else {
          href = href + mail;
        }
        return b + '<a href="' + href + '">' + mail + '</a>';
      };
    };

showdown.subParser('autoLinks', function (text, options, globals) {

  text = globals.converter._dispatch('autoLinks.before', text, options, globals);

  text = text.replace(delimUrlRegex, replaceLink(options));
  text = text.replace(delimMailRegex, replaceMail(options, globals));

  text = globals.converter._dispatch('autoLinks.after', text, options, globals);

  return text;
});

showdown.subParser('simplifiedAutoLinks', function (text, options, globals) {

  if (!options.simplifiedAutoLink) {
    return text;
  }

  text = globals.converter._dispatch('simplifiedAutoLinks.before', text, options, globals);

  if (options.excludeTrailingPunctuationFromURLs) {
    text = text.replace(simpleURLRegex2, replaceLink(options));
  } else {
    text = text.replace(simpleURLRegex, replaceLink(options));
  }
  text = text.replace(simpleMailRegex, replaceMail(options, globals));

  text = globals.converter._dispatch('simplifiedAutoLinks.after', text, options, globals);

  return text;
});

/**
 * These are all the transformations that form block-level
 * tags like paragraphs, headers, and list items.
 */
showdown.subParser('blockGamut', function (text, options, globals) {

  text = globals.converter._dispatch('blockGamut.before', text, options, globals);

  // we parse blockquotes first so that we can have headings and hrs
  // inside blockquotes
  text = showdown.subParser('blockQuotes')(text, options, globals);
  text = showdown.subParser('headers')(text, options, globals);

  // Do Horizontal Rules:
  text = showdown.subParser('horizontalRule')(text, options, globals);

  text = showdown.subParser('lists')(text, options, globals);
  text = showdown.subParser('codeBlocks')(text, options, globals);
  text = showdown.subParser('tables')(text, options, globals);

  // We already ran _HashHTMLBlocks() before, in Markdown(), but that
  // was to escape raw HTML in the original Markdown source. This time,
  // we're escaping the markup we've just created, so that we don't wrap
  // <p> tags around block-level tags.
  text = showdown.subParser('hashHTMLBlocks')(text, options, globals);
  text = showdown.subParser('paragraphs')(text, options, globals);

  text = globals.converter._dispatch('blockGamut.after', text, options, globals);

  return text;
});

showdown.subParser('blockQuotes', function (text, options, globals) {

  text = globals.converter._dispatch('blockQuotes.before', text, options, globals);

  // add a couple extra lines after the text and endtext mark
  text = text + '\n\n';

  var rgx = /(^ {0,3}>[ \t]?.+\n(.+\n)*\n*)+/gm;

  if (options.splitAdjacentBlockquotes) {
    rgx = /^ {0,3}>[\s\S]*?(?:\n\n)/gm;
  }

  text = text.replace(rgx, function (bq) {
    // attacklab: hack around Konqueror 3.5.4 bug:
    // "----------bug".replace(/^-/g,"") == "bug"
    bq = bq.replace(/^[ \t]*>[ \t]?/gm, ''); // trim one level of quoting

    // attacklab: clean up hack
    bq = bq.replace(/¨0/g, '');

    bq = bq.replace(/^[ \t]+$/gm, ''); // trim whitespace-only lines
    bq = showdown.subParser('githubCodeBlocks')(bq, options, globals);
    bq = showdown.subParser('blockGamut')(bq, options, globals); // recurse

    bq = bq.replace(/(^|\n)/g, '$1  ');
    // These leading spaces screw with <pre> content, so we need to fix that:
    bq = bq.replace(/(\s*<pre>[^\r]+?<\/pre>)/gm, function (wholeMatch, m1) {
      var pre = m1;
      // attacklab: hack around Konqueror 3.5.4 bug:
      pre = pre.replace(/^  /mg, '¨0');
      pre = pre.replace(/¨0/g, '');
      return pre;
    });

    return showdown.subParser('hashBlock')('<blockquote>\n' + bq + '\n</blockquote>', options, globals);
  });

  text = globals.converter._dispatch('blockQuotes.after', text, options, globals);
  return text;
});

/**
 * Process Markdown `<pre><code>` blocks.
 */
showdown.subParser('codeBlocks', function (text, options, globals) {

  text = globals.converter._dispatch('codeBlocks.before', text, options, globals);

  // sentinel workarounds for lack of \A and \Z, safari\khtml bug
  text += '¨0';

  var pattern = /(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=¨0))/g;
  text = text.replace(pattern, function (wholeMatch, m1, m2) {
    var codeblock = m1,
        nextChar = m2,
        end = '\n';

    codeblock = showdown.subParser('outdent')(codeblock, options, globals);
    codeblock = showdown.subParser('encodeCode')(codeblock, options, globals);
    codeblock = showdown.subParser('detab')(codeblock, options, globals);
    codeblock = codeblock.replace(/^\n+/g, ''); // trim leading newlines
    codeblock = codeblock.replace(/\n+$/g, ''); // trim trailing newlines

    if (options.omitExtraWLInCodeBlocks) {
      end = '';
    }

    codeblock = '<pre><code>' + codeblock + end + '</code></pre>';

    return showdown.subParser('hashBlock')(codeblock, options, globals) + nextChar;
  });

  // strip sentinel
  text = text.replace(/¨0/, '');

  text = globals.converter._dispatch('codeBlocks.after', text, options, globals);
  return text;
});

/**
 *
 *   *  Backtick quotes are used for <code></code> spans.
 *
 *   *  You can use multiple backticks as the delimiters if you want to
 *     include literal backticks in the code span. So, this input:
 *
 *         Just type ``foo `bar` baz`` at the prompt.
 *
 *       Will translate to:
 *
 *         <p>Just type <code>foo `bar` baz</code> at the prompt.</p>
 *
 *    There's no arbitrary limit to the number of backticks you
 *    can use as delimters. If you need three consecutive backticks
 *    in your code, use four for delimiters, etc.
 *
 *  *  You can use spaces to get literal backticks at the edges:
 *
 *         ... type `` `bar` `` ...
 *
 *       Turns to:
 *
 *         ... type <code>`bar`</code> ...
 */
showdown.subParser('codeSpans', function (text, options, globals) {

  text = globals.converter._dispatch('codeSpans.before', text, options, globals);

  if (typeof text === 'undefined') {
    text = '';
  }
  text = text.replace(/(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm,
    function (wholeMatch, m1, m2, m3) {
      var c = m3;
      c = c.replace(/^([ \t]*)/g, '');	// leading whitespace
      c = c.replace(/[ \t]*$/g, '');	// trailing whitespace
      c = showdown.subParser('encodeCode')(c, options, globals);
      c = m1 + '<code>' + c + '</code>';
      c = showdown.subParser('hashHTMLSpans')(c, options, globals);
      return c;
    }
  );

  text = globals.converter._dispatch('codeSpans.after', text, options, globals);
  return text;
});

/**
 * Create a full HTML document from the processed markdown
 */
showdown.subParser('completeHTMLDocument', function (text, options, globals) {

  if (!options.completeHTMLDocument) {
    return text;
  }

  text = globals.converter._dispatch('completeHTMLDocument.before', text, options, globals);

  var doctype = 'html',
      doctypeParsed = '<!DOCTYPE HTML>\n',
      title = '',
      charset = '<meta charset="utf-8">\n',
      lang = '',
      metadata = '';

  if (typeof globals.metadata.parsed.doctype !== 'undefined') {
    doctypeParsed = '<!DOCTYPE ' +  globals.metadata.parsed.doctype + '>\n';
    doctype = globals.metadata.parsed.doctype.toString().toLowerCase();
    if (doctype === 'html' || doctype === 'html5') {
      charset = '<meta charset="utf-8">';
    }
  }

  for (var meta in globals.metadata.parsed) {
    if (globals.metadata.parsed.hasOwnProperty(meta)) {
      switch (meta.toLowerCase()) {
        case 'doctype':
          break;

        case 'title':
          title = '<title>' +  globals.metadata.parsed.title + '</title>\n';
          break;

        case 'charset':
          if (doctype === 'html' || doctype === 'html5') {
            charset = '<meta charset="' + globals.metadata.parsed.charset + '">\n';
          } else {
            charset = '<meta name="charset" content="' + globals.metadata.parsed.charset + '">\n';
          }
          break;

        case 'language':
        case 'lang':
          lang = ' lang="' + globals.metadata.parsed[meta] + '"';
          metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
          break;

        default:
          metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
      }
    }
  }

  text = doctypeParsed + '<html' + lang + '>\n<head>\n' + title + charset + metadata + '</head>\n<body>\n' + text.trim() + '\n</body>\n</html>';

  text = globals.converter._dispatch('completeHTMLDocument.after', text, options, globals);
  return text;
});

/**
 * Convert all tabs to spaces
 */
showdown.subParser('detab', function (text, options, globals) {
  text = globals.converter._dispatch('detab.before', text, options, globals);

  // expand first n-1 tabs
  text = text.replace(/\t(?=\t)/g, '    '); // g_tab_width

  // replace the nth with two sentinels
  text = text.replace(/\t/g, '¨A¨B');

  // use the sentinel to anchor our regex so it doesn't explode
  text = text.replace(/¨B(.+?)¨A/g, function (wholeMatch, m1) {
    var leadingText = m1,
        numSpaces = 4 - leadingText.length % 4;  // g_tab_width

    // there *must* be a better way to do this:
    for (var i = 0; i < numSpaces; i++) {
      leadingText += ' ';
    }

    return leadingText;
  });

  // clean up sentinels
  text = text.replace(/¨A/g, '    ');  // g_tab_width
  text = text.replace(/¨B/g, '');

  text = globals.converter._dispatch('detab.after', text, options, globals);
  return text;
});

showdown.subParser('ellipsis', function (text, options, globals) {

  text = globals.converter._dispatch('ellipsis.before', text, options, globals);

  text = text.replace(/\.\.\./g, '…');

  text = globals.converter._dispatch('ellipsis.after', text, options, globals);

  return text;
});

/**
 * Turn emoji codes into emojis
 *
 * List of supported emojis: https://github.com/showdownjs/showdown/wiki/Emojis
 */
showdown.subParser('emoji', function (text, options, globals) {

  if (!options.emoji) {
    return text;
  }

  text = globals.converter._dispatch('emoji.before', text, options, globals);

  var emojiRgx = /:([\S]+?):/g;

  text = text.replace(emojiRgx, function (wm, emojiCode) {
    if (showdown.helper.emojis.hasOwnProperty(emojiCode)) {
      return showdown.helper.emojis[emojiCode];
    }
    return wm;
  });

  text = globals.converter._dispatch('emoji.after', text, options, globals);

  return text;
});

/**
 * Smart processing for ampersands and angle brackets that need to be encoded.
 */
showdown.subParser('encodeAmpsAndAngles', function (text, options, globals) {
  text = globals.converter._dispatch('encodeAmpsAndAngles.before', text, options, globals);

  // Ampersand-encoding based entirely on Nat Irons's Amputator MT plugin:
  // http://bumppo.net/projects/amputator/
  text = text.replace(/&(?!#?[xX]?(?:[0-9a-fA-F]+|\w+);)/g, '&amp;');

  // Encode naked <'s
  text = text.replace(/<(?![a-z\/?$!])/gi, '&lt;');

  // Encode <
  text = text.replace(/</g, '&lt;');

  // Encode >
  text = text.replace(/>/g, '&gt;');

  text = globals.converter._dispatch('encodeAmpsAndAngles.after', text, options, globals);
  return text;
});

/**
 * Returns the string, with after processing the following backslash escape sequences.
 *
 * attacklab: The polite way to do this is with the new escapeCharacters() function:
 *
 *    text = escapeCharacters(text,"\\",true);
 *    text = escapeCharacters(text,"`*_{}[]()>#+-.!",true);
 *
 * ...but we're sidestepping its use of the (slow) RegExp constructor
 * as an optimization for Firefox.  This function gets called a LOT.
 */
showdown.subParser('encodeBackslashEscapes', function (text, options, globals) {
  text = globals.converter._dispatch('encodeBackslashEscapes.before', text, options, globals);

  text = text.replace(/\\(\\)/g, showdown.helper.escapeCharactersCallback);
  text = text.replace(/\\([`*_{}\[\]()>#+.!~=|-])/g, showdown.helper.escapeCharactersCallback);

  text = globals.converter._dispatch('encodeBackslashEscapes.after', text, options, globals);
  return text;
});

/**
 * Encode/escape certain characters inside Markdown code runs.
 * The point is that in code, these characters are literals,
 * and lose their special Markdown meanings.
 */
showdown.subParser('encodeCode', function (text, options, globals) {

  text = globals.converter._dispatch('encodeCode.before', text, options, globals);

  // Encode all ampersands; HTML entities are not
  // entities within a Markdown code span.
  text = text
    .replace(/&/g, '&amp;')
  // Do the angle bracket song and dance:
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
  // Now, escape characters that are magic in Markdown:
    .replace(/([*_{}\[\]\\=~-])/g, showdown.helper.escapeCharactersCallback);

  text = globals.converter._dispatch('encodeCode.after', text, options, globals);
  return text;
});

/**
 * Within tags -- meaning between < and > -- encode [\ ` * _ ~ =] so they
 * don't conflict with their use in Markdown for code, italics and strong.
 */
showdown.subParser('escapeSpecialCharsWithinTagAttributes', function (text, options, globals) {
  text = globals.converter._dispatch('escapeSpecialCharsWithinTagAttributes.before', text, options, globals);

  // Build a regex to find HTML tags.
  var tags     = /<\/?[a-z\d_:-]+(?:[\s]+[\s\S]+?)?>/gi,
      comments = /<!(--(?:(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>/gi;

  text = text.replace(tags, function (wholeMatch) {
    return wholeMatch
      .replace(/(.)<\/?code>(?=.)/g, '$1`')
      .replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
  });

  text = text.replace(comments, function (wholeMatch) {
    return wholeMatch
      .replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
  });

  text = globals.converter._dispatch('escapeSpecialCharsWithinTagAttributes.after', text, options, globals);
  return text;
});

/**
 * Handle github codeblocks prior to running HashHTML so that
 * HTML contained within the codeblock gets escaped properly
 * Example:
 * ```ruby
 *     def hello_world(x)
 *       puts "Hello, #{x}"
 *     end
 * ```
 */
showdown.subParser('githubCodeBlocks', function (text, options, globals) {

  // early exit if option is not enabled
  if (!options.ghCodeBlocks) {
    return text;
  }

  text = globals.converter._dispatch('githubCodeBlocks.before', text, options, globals);

  text += '¨0';

  text = text.replace(/(?:^|\n)(?: {0,3})(```+|~~~+)(?: *)([^\s`~]*)\n([\s\S]*?)\n(?: {0,3})\1/g, function (wholeMatch, delim, language, codeblock) {
    var end = (options.omitExtraWLInCodeBlocks) ? '' : '\n';

    // First parse the github code block
    codeblock = showdown.subParser('encodeCode')(codeblock, options, globals);
    codeblock = showdown.subParser('detab')(codeblock, options, globals);
    codeblock = codeblock.replace(/^\n+/g, ''); // trim leading newlines
    codeblock = codeblock.replace(/\n+$/g, ''); // trim trailing whitespace

    codeblock = '<pre><code' + (language ? ' class="' + language + ' language-' + language + '"' : '') + '>' + codeblock + end + '</code></pre>';

    codeblock = showdown.subParser('hashBlock')(codeblock, options, globals);

    // Since GHCodeblocks can be false positives, we need to
    // store the primitive text and the parsed text in a global var,
    // and then return a token
    return '\n\n¨G' + (globals.ghCodeBlocks.push({text: wholeMatch, codeblock: codeblock}) - 1) + 'G\n\n';
  });

  // attacklab: strip sentinel
  text = text.replace(/¨0/, '');

  return globals.converter._dispatch('githubCodeBlocks.after', text, options, globals);
});

showdown.subParser('hashBlock', function (text, options, globals) {
  text = globals.converter._dispatch('hashBlock.before', text, options, globals);
  text = text.replace(/(^\n+|\n+$)/g, '');
  text = '\n\n¨K' + (globals.gHtmlBlocks.push(text) - 1) + 'K\n\n';
  text = globals.converter._dispatch('hashBlock.after', text, options, globals);
  return text;
});

/**
 * Hash and escape <code> elements that should not be parsed as markdown
 */
showdown.subParser('hashCodeTags', function (text, options, globals) {
  text = globals.converter._dispatch('hashCodeTags.before', text, options, globals);

  var repFunc = function (wholeMatch, match, left, right) {
    var codeblock = left + showdown.subParser('encodeCode')(match, options, globals) + right;
    return '¨C' + (globals.gHtmlSpans.push(codeblock) - 1) + 'C';
  };

  // Hash naked <code>
  text = showdown.helper.replaceRecursiveRegExp(text, repFunc, '<code\\b[^>]*>', '</code>', 'gim');

  text = globals.converter._dispatch('hashCodeTags.after', text, options, globals);
  return text;
});

showdown.subParser('hashElement', function (text, options, globals) {

  return function (wholeMatch, m1) {
    var blockText = m1;

    // Undo double lines
    blockText = blockText.replace(/\n\n/g, '\n');
    blockText = blockText.replace(/^\n/, '');

    // strip trailing blank lines
    blockText = blockText.replace(/\n+$/g, '');

    // Replace the element text with a marker ("¨KxK" where x is its key)
    blockText = '\n\n¨K' + (globals.gHtmlBlocks.push(blockText) - 1) + 'K\n\n';

    return blockText;
  };
});

showdown.subParser('hashHTMLBlocks', function (text, options, globals) {
  text = globals.converter._dispatch('hashHTMLBlocks.before', text, options, globals);

  var blockTags = [
        'pre',
        'div',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'blockquote',
        'table',
        'dl',
        'ol',
        'ul',
        'script',
        'noscript',
        'form',
        'fieldset',
        'iframe',
        'math',
        'style',
        'section',
        'header',
        'footer',
        'nav',
        'article',
        'aside',
        'address',
        'audio',
        'canvas',
        'figure',
        'hgroup',
        'output',
        'video',
        'p'
      ],
      repFunc = function (wholeMatch, match, left, right) {
        var txt = wholeMatch;
        // check if this html element is marked as markdown
        // if so, it's contents should be parsed as markdown
        if (left.search(/\bmarkdown\b/) !== -1) {
          txt = left + globals.converter.makeHtml(match) + right;
        }
        return '\n\n¨K' + (globals.gHtmlBlocks.push(txt) - 1) + 'K\n\n';
      };

  if (options.backslashEscapesHTMLTags) {
    // encode backslash escaped HTML tags
    text = text.replace(/\\<(\/?[^>]+?)>/g, function (wm, inside) {
      return '&lt;' + inside + '&gt;';
    });
  }

  // hash HTML Blocks
  for (var i = 0; i < blockTags.length; ++i) {

    var opTagPos,
        rgx1     = new RegExp('^ {0,3}(<' + blockTags[i] + '\\b[^>]*>)', 'im'),
        patLeft  = '<' + blockTags[i] + '\\b[^>]*>',
        patRight = '</' + blockTags[i] + '>';
    // 1. Look for the first position of the first opening HTML tag in the text
    while ((opTagPos = showdown.helper.regexIndexOf(text, rgx1)) !== -1) {

      // if the HTML tag is \ escaped, we need to escape it and break


      //2. Split the text in that position
      var subTexts = showdown.helper.splitAtIndex(text, opTagPos),
          //3. Match recursively
          newSubText1 = showdown.helper.replaceRecursiveRegExp(subTexts[1], repFunc, patLeft, patRight, 'im');

      // prevent an infinite loop
      if (newSubText1 === subTexts[1]) {
        break;
      }
      text = subTexts[0].concat(newSubText1);
    }
  }
  // HR SPECIAL CASE
  text = text.replace(/(\n {0,3}(<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g,
    showdown.subParser('hashElement')(text, options, globals));

  // Special case for standalone HTML comments
  text = showdown.helper.replaceRecursiveRegExp(text, function (txt) {
    return '\n\n¨K' + (globals.gHtmlBlocks.push(txt) - 1) + 'K\n\n';
  }, '^ {0,3}<!--', '-->', 'gm');

  // PHP and ASP-style processor instructions (<?...?> and <%...%>)
  text = text.replace(/(?:\n\n)( {0,3}(?:<([?%])[^\r]*?\2>)[ \t]*(?=\n{2,}))/g,
    showdown.subParser('hashElement')(text, options, globals));

  text = globals.converter._dispatch('hashHTMLBlocks.after', text, options, globals);
  return text;
});

/**
 * Hash span elements that should not be parsed as markdown
 */
showdown.subParser('hashHTMLSpans', function (text, options, globals) {
  text = globals.converter._dispatch('hashHTMLSpans.before', text, options, globals);

  function hashHTMLSpan (html) {
    return '¨C' + (globals.gHtmlSpans.push(html) - 1) + 'C';
  }

  // Hash Self Closing tags
  text = text.replace(/<[^>]+?\/>/gi, function (wm) {
    return hashHTMLSpan(wm);
  });

  // Hash tags without properties
  text = text.replace(/<([^>]+?)>[\s\S]*?<\/\1>/g, function (wm) {
    return hashHTMLSpan(wm);
  });

  // Hash tags with properties
  text = text.replace(/<([^>]+?)\s[^>]+?>[\s\S]*?<\/\1>/g, function (wm) {
    return hashHTMLSpan(wm);
  });

  // Hash self closing tags without />
  text = text.replace(/<[^>]+?>/gi, function (wm) {
    return hashHTMLSpan(wm);
  });

  /*showdown.helper.matchRecursiveRegExp(text, '<code\\b[^>]*>', '</code>', 'gi');*/

  text = globals.converter._dispatch('hashHTMLSpans.after', text, options, globals);
  return text;
});

/**
 * Unhash HTML spans
 */
showdown.subParser('unhashHTMLSpans', function (text, options, globals) {
  text = globals.converter._dispatch('unhashHTMLSpans.before', text, options, globals);

  for (var i = 0; i < globals.gHtmlSpans.length; ++i) {
    var repText = globals.gHtmlSpans[i],
        // limiter to prevent infinite loop (assume 10 as limit for recurse)
        limit = 0;

    while (/¨C(\d+)C/.test(repText)) {
      var num = RegExp.$1;
      repText = repText.replace('¨C' + num + 'C', globals.gHtmlSpans[num]);
      if (limit === 10) {
        console.error('maximum nesting of 10 spans reached!!!');
        break;
      }
      ++limit;
    }
    text = text.replace('¨C' + i + 'C', repText);
  }

  text = globals.converter._dispatch('unhashHTMLSpans.after', text, options, globals);
  return text;
});

/**
 * Hash and escape <pre><code> elements that should not be parsed as markdown
 */
showdown.subParser('hashPreCodeTags', function (text, options, globals) {
  text = globals.converter._dispatch('hashPreCodeTags.before', text, options, globals);

  var repFunc = function (wholeMatch, match, left, right) {
    // encode html entities
    var codeblock = left + showdown.subParser('encodeCode')(match, options, globals) + right;
    return '\n\n¨G' + (globals.ghCodeBlocks.push({text: wholeMatch, codeblock: codeblock}) - 1) + 'G\n\n';
  };

  // Hash <pre><code>
  text = showdown.helper.replaceRecursiveRegExp(text, repFunc, '^ {0,3}<pre\\b[^>]*>\\s*<code\\b[^>]*>', '^ {0,3}</code>\\s*</pre>', 'gim');

  text = globals.converter._dispatch('hashPreCodeTags.after', text, options, globals);
  return text;
});

showdown.subParser('headers', function (text, options, globals) {

  text = globals.converter._dispatch('headers.before', text, options, globals);

  var headerLevelStart = (isNaN(parseInt(options.headerLevelStart))) ? 1 : parseInt(options.headerLevelStart),

      // Set text-style headers:
      //	Header 1
      //	========
      //
      //	Header 2
      //	--------
      //
      setextRegexH1 = (options.smoothLivePreview) ? /^(.+)[ \t]*\n={2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n=+[ \t]*\n+/gm,
      setextRegexH2 = (options.smoothLivePreview) ? /^(.+)[ \t]*\n-{2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n-+[ \t]*\n+/gm;

  text = text.replace(setextRegexH1, function (wholeMatch, m1) {

    var spanGamut = showdown.subParser('spanGamut')(m1, options, globals),
        hID = (options.noHeaderId) ? '' : ' id="' + headerId(m1) + '"',
        hLevel = headerLevelStart,
        hashBlock = '<h' + hLevel + hID + '>' + spanGamut + '</h' + hLevel + '>';
    return showdown.subParser('hashBlock')(hashBlock, options, globals);
  });

  text = text.replace(setextRegexH2, function (matchFound, m1) {
    var spanGamut = showdown.subParser('spanGamut')(m1, options, globals),
        hID = (options.noHeaderId) ? '' : ' id="' + headerId(m1) + '"',
        hLevel = headerLevelStart + 1,
        hashBlock = '<h' + hLevel + hID + '>' + spanGamut + '</h' + hLevel + '>';
    return showdown.subParser('hashBlock')(hashBlock, options, globals);
  });

  // atx-style headers:
  //  # Header 1
  //  ## Header 2
  //  ## Header 2 with closing hashes ##
  //  ...
  //  ###### Header 6
  //
  var atxStyle = (options.requireSpaceBeforeHeadingText) ? /^(#{1,6})[ \t]+(.+?)[ \t]*#*\n+/gm : /^(#{1,6})[ \t]*(.+?)[ \t]*#*\n+/gm;

  text = text.replace(atxStyle, function (wholeMatch, m1, m2) {
    var hText = m2;
    if (options.customizedHeaderId) {
      hText = m2.replace(/\s?\{([^{]+?)}\s*$/, '');
    }

    var span = showdown.subParser('spanGamut')(hText, options, globals),
        hID = (options.noHeaderId) ? '' : ' id="' + headerId(m2) + '"',
        hLevel = headerLevelStart - 1 + m1.length,
        header = '<h' + hLevel + hID + '>' + span + '</h' + hLevel + '>';

    return showdown.subParser('hashBlock')(header, options, globals);
  });

  function headerId (m) {
    var title,
        prefix;

    // It is separate from other options to allow combining prefix and customized
    if (options.customizedHeaderId) {
      var match = m.match(/\{([^{]+?)}\s*$/);
      if (match && match[1]) {
        m = match[1];
      }
    }

    title = m;

    // Prefix id to prevent causing inadvertent pre-existing style matches.
    if (showdown.helper.isString(options.prefixHeaderId)) {
      prefix = options.prefixHeaderId;
    } else if (options.prefixHeaderId === true) {
      prefix = 'section-';
    } else {
      prefix = '';
    }

    if (!options.rawPrefixHeaderId) {
      title = prefix + title;
    }

    if (options.ghCompatibleHeaderId) {
      title = title
        .replace(/ /g, '-')
        // replace previously escaped chars (&, ¨ and $)
        .replace(/&amp;/g, '')
        .replace(/¨T/g, '')
        .replace(/¨D/g, '')
        // replace rest of the chars (&~$ are repeated as they might have been escaped)
        // borrowed from github's redcarpet (some they should produce similar results)
        .replace(/[&+$,\/:;=?@"#{}|^¨~\[\]`\\*)(%.!'<>]/g, '')
        .toLowerCase();
    } else if (options.rawHeaderId) {
      title = title
        .replace(/ /g, '-')
        // replace previously escaped chars (&, ¨ and $)
        .replace(/&amp;/g, '&')
        .replace(/¨T/g, '¨')
        .replace(/¨D/g, '$')
        // replace " and '
        .replace(/["']/g, '-')
        .toLowerCase();
    } else {
      title = title
        .replace(/[^\w]/g, '')
        .toLowerCase();
    }

    if (options.rawPrefixHeaderId) {
      title = prefix + title;
    }

    if (globals.hashLinkCounts[title]) {
      title = title + '-' + (globals.hashLinkCounts[title]++);
    } else {
      globals.hashLinkCounts[title] = 1;
    }
    return title;
  }

  text = globals.converter._dispatch('headers.after', text, options, globals);
  return text;
});

/**
 * Turn Markdown link shortcuts into XHTML <a> tags.
 */
showdown.subParser('horizontalRule', function (text, options, globals) {
  text = globals.converter._dispatch('horizontalRule.before', text, options, globals);

  var key = showdown.subParser('hashBlock')('<hr />', options, globals);
  text = text.replace(/^ {0,2}( ?-){3,}[ \t]*$/gm, key);
  text = text.replace(/^ {0,2}( ?\*){3,}[ \t]*$/gm, key);
  text = text.replace(/^ {0,2}( ?_){3,}[ \t]*$/gm, key);

  text = globals.converter._dispatch('horizontalRule.after', text, options, globals);
  return text;
});

/**
 * Turn Markdown image shortcuts into <img> tags.
 */
showdown.subParser('images', function (text, options, globals) {

  text = globals.converter._dispatch('images.before', text, options, globals);

  var inlineRegExp      = /!\[([^\]]*?)][ \t]*()\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g,
      crazyRegExp       = /!\[([^\]]*?)][ \t]*()\([ \t]?<([^>]*)>(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(?:(["'])([^"]*?)\6))?[ \t]?\)/g,
      base64RegExp      = /!\[([^\]]*?)][ \t]*()\([ \t]?<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g,
      referenceRegExp   = /!\[([^\]]*?)] ?(?:\n *)?\[([\s\S]*?)]()()()()()/g,
      refShortcutRegExp = /!\[([^\[\]]+)]()()()()()/g;

  function writeImageTagBase64 (wholeMatch, altText, linkId, url, width, height, m5, title) {
    url = url.replace(/\s/g, '');
    return writeImageTag (wholeMatch, altText, linkId, url, width, height, m5, title);
  }

  function writeImageTag (wholeMatch, altText, linkId, url, width, height, m5, title) {

    var gUrls   = globals.gUrls,
        gTitles = globals.gTitles,
        gDims   = globals.gDimensions;

    linkId = linkId.toLowerCase();

    if (!title) {
      title = '';
    }
    // Special case for explicit empty url
    if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) {
      url = '';

    } else if (url === '' || url === null) {
      if (linkId === '' || linkId === null) {
        // lower-case and turn embedded newlines into spaces
        linkId = altText.toLowerCase().replace(/ ?\n/g, ' ');
      }
      url = '#' + linkId;

      if (!showdown.helper.isUndefined(gUrls[linkId])) {
        url = gUrls[linkId];
        if (!showdown.helper.isUndefined(gTitles[linkId])) {
          title = gTitles[linkId];
        }
        if (!showdown.helper.isUndefined(gDims[linkId])) {
          width = gDims[linkId].width;
          height = gDims[linkId].height;
        }
      } else {
        return wholeMatch;
      }
    }

    altText = altText
      .replace(/"/g, '&quot;')
    //altText = showdown.helper.escapeCharacters(altText, '*_', false);
      .replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
    //url = showdown.helper.escapeCharacters(url, '*_', false);
    url = url.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
    var result = '<img src="' + url + '" alt="' + altText + '"';

    if (title && showdown.helper.isString(title)) {
      title = title
        .replace(/"/g, '&quot;')
      //title = showdown.helper.escapeCharacters(title, '*_', false);
        .replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
      result += ' title="' + title + '"';
    }

    if (width && height) {
      width  = (width === '*') ? 'auto' : width;
      height = (height === '*') ? 'auto' : height;

      result += ' width="' + width + '"';
      result += ' height="' + height + '"';
    }

    result += ' />';

    return result;
  }

  // First, handle reference-style labeled images: ![alt text][id]
  text = text.replace(referenceRegExp, writeImageTag);

  // Next, handle inline images:  ![alt text](url =<width>x<height> "optional title")

  // base64 encoded images
  text = text.replace(base64RegExp, writeImageTagBase64);

  // cases with crazy urls like ./image/cat1).png
  text = text.replace(crazyRegExp, writeImageTag);

  // normal cases
  text = text.replace(inlineRegExp, writeImageTag);

  // handle reference-style shortcuts: ![img text]
  text = text.replace(refShortcutRegExp, writeImageTag);

  text = globals.converter._dispatch('images.after', text, options, globals);
  return text;
});

showdown.subParser('italicsAndBold', function (text, options, globals) {

  text = globals.converter._dispatch('italicsAndBold.before', text, options, globals);

  // it's faster to have 3 separate regexes for each case than have just one
  // because of backtracing, in some cases, it could lead to an exponential effect
  // called "catastrophic backtrace". Ominous!

  function parseInside (txt, left, right) {
    /*
    if (options.simplifiedAutoLink) {
      txt = showdown.subParser('simplifiedAutoLinks')(txt, options, globals);
    }
    */
    return left + txt + right;
  }

  // Parse underscores
  if (options.literalMidWordUnderscores) {
    text = text.replace(/\b___(\S[\s\S]*?)___\b/g, function (wm, txt) {
      return parseInside (txt, '<strong><em>', '</em></strong>');
    });
    text = text.replace(/\b__(\S[\s\S]*?)__\b/g, function (wm, txt) {
      return parseInside (txt, '<strong>', '</strong>');
    });
    text = text.replace(/\b_(\S[\s\S]*?)_\b/g, function (wm, txt) {
      return parseInside (txt, '<em>', '</em>');
    });
  } else {
    text = text.replace(/___(\S[\s\S]*?)___/g, function (wm, m) {
      return (/\S$/.test(m)) ? parseInside (m, '<strong><em>', '</em></strong>') : wm;
    });
    text = text.replace(/__(\S[\s\S]*?)__/g, function (wm, m) {
      return (/\S$/.test(m)) ? parseInside (m, '<strong>', '</strong>') : wm;
    });
    text = text.replace(/_([^\s_][\s\S]*?)_/g, function (wm, m) {
      // !/^_[^_]/.test(m) - test if it doesn't start with __ (since it seems redundant, we removed it)
      return (/\S$/.test(m)) ? parseInside (m, '<em>', '</em>') : wm;
    });
  }

  // Now parse asterisks
  if (options.literalMidWordAsterisks) {
    text = text.replace(/([^*]|^)\B\*\*\*(\S[\s\S]*?)\*\*\*\B(?!\*)/g, function (wm, lead, txt) {
      return parseInside (txt, lead + '<strong><em>', '</em></strong>');
    });
    text = text.replace(/([^*]|^)\B\*\*(\S[\s\S]*?)\*\*\B(?!\*)/g, function (wm, lead, txt) {
      return parseInside (txt, lead + '<strong>', '</strong>');
    });
    text = text.replace(/([^*]|^)\B\*(\S[\s\S]*?)\*\B(?!\*)/g, function (wm, lead, txt) {
      return parseInside (txt, lead + '<em>', '</em>');
    });
  } else {
    text = text.replace(/\*\*\*(\S[\s\S]*?)\*\*\*/g, function (wm, m) {
      return (/\S$/.test(m)) ? parseInside (m, '<strong><em>', '</em></strong>') : wm;
    });
    text = text.replace(/\*\*(\S[\s\S]*?)\*\*/g, function (wm, m) {
      return (/\S$/.test(m)) ? parseInside (m, '<strong>', '</strong>') : wm;
    });
    text = text.replace(/\*([^\s*][\s\S]*?)\*/g, function (wm, m) {
      // !/^\*[^*]/.test(m) - test if it doesn't start with ** (since it seems redundant, we removed it)
      return (/\S$/.test(m)) ? parseInside (m, '<em>', '</em>') : wm;
    });
  }


  text = globals.converter._dispatch('italicsAndBold.after', text, options, globals);
  return text;
});

/**
 * Form HTML ordered (numbered) and unordered (bulleted) lists.
 */
showdown.subParser('lists', function (text, options, globals) {

  /**
   * Process the contents of a single ordered or unordered list, splitting it
   * into individual list items.
   * @param {string} listStr
   * @param {boolean} trimTrailing
   * @returns {string}
   */
  function processListItems (listStr, trimTrailing) {
    // The $g_list_level global keeps track of when we're inside a list.
    // Each time we enter a list, we increment it; when we leave a list,
    // we decrement. If it's zero, we're not in a list anymore.
    //
    // We do this because when we're not inside a list, we want to treat
    // something like this:
    //
    //    I recommend upgrading to version
    //    8. Oops, now this line is treated
    //    as a sub-list.
    //
    // As a single paragraph, despite the fact that the second line starts
    // with a digit-period-space sequence.
    //
    // Whereas when we're inside a list (or sub-list), that line will be
    // treated as the start of a sub-list. What a kludge, huh? This is
    // an aspect of Markdown's syntax that's hard to parse perfectly
    // without resorting to mind-reading. Perhaps the solution is to
    // change the syntax rules such that sub-lists must start with a
    // starting cardinal number; e.g. "1." or "a.".
    globals.gListLevel++;

    // trim trailing blank lines:
    listStr = listStr.replace(/\n{2,}$/, '\n');

    // attacklab: add sentinel to emulate \z
    listStr += '¨0';

    var rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0| {0,3}([*+-]|\d+[.])[ \t]+))/gm,
        isParagraphed = (/\n[ \t]*\n(?!¨0)/.test(listStr));

    // Since version 1.5, nesting sublists requires 4 spaces (or 1 tab) indentation,
    // which is a syntax breaking change
    // activating this option reverts to old behavior
    if (options.disableForced4SpacesIndentedSublists) {
      rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0|\2([*+-]|\d+[.])[ \t]+))/gm;
    }

    listStr = listStr.replace(rgx, function (wholeMatch, m1, m2, m3, m4, taskbtn, checked) {
      checked = (checked && checked.trim() !== '');

      var item = showdown.subParser('outdent')(m4, options, globals),
          bulletStyle = '';

      // Support for github tasklists
      if (taskbtn && options.tasklists) {
        bulletStyle = ' class="task-list-item" style="list-style-type: none;"';
        item = item.replace(/^[ \t]*\[(x|X| )?]/m, function () {
          var otp = '<input type="checkbox" disabled style="margin: 0px 0.35em 0.25em -1.6em; vertical-align: middle;"';
          if (checked) {
            otp += ' checked';
          }
          otp += '>';
          return otp;
        });
      }

      // ISSUE #312
      // This input: - - - a
      // causes trouble to the parser, since it interprets it as:
      // <ul><li><li><li>a</li></li></li></ul>
      // instead of:
      // <ul><li>- - a</li></ul>
      // So, to prevent it, we will put a marker (¨A)in the beginning of the line
      // Kind of hackish/monkey patching, but seems more effective than overcomplicating the list parser
      item = item.replace(/^([-*+]|\d\.)[ \t]+[\S\n ]*/g, function (wm2) {
        return '¨A' + wm2;
      });

      // m1 - Leading line or
      // Has a double return (multi paragraph) or
      // Has sublist
      if (m1 || (item.search(/\n{2,}/) > -1)) {
        item = showdown.subParser('githubCodeBlocks')(item, options, globals);
        item = showdown.subParser('blockGamut')(item, options, globals);
      } else {
        // Recursion for sub-lists:
        item = showdown.subParser('lists')(item, options, globals);
        item = item.replace(/\n$/, ''); // chomp(item)
        item = showdown.subParser('hashHTMLBlocks')(item, options, globals);

        // Colapse double linebreaks
        item = item.replace(/\n\n+/g, '\n\n');
        if (isParagraphed) {
          item = showdown.subParser('paragraphs')(item, options, globals);
        } else {
          item = showdown.subParser('spanGamut')(item, options, globals);
        }
      }

      // now we need to remove the marker (¨A)
      item = item.replace('¨A', '');
      // we can finally wrap the line in list item tags
      item =  '<li' + bulletStyle + '>' + item + '</li>\n';

      return item;
    });

    // attacklab: strip sentinel
    listStr = listStr.replace(/¨0/g, '');

    globals.gListLevel--;

    if (trimTrailing) {
      listStr = listStr.replace(/\s+$/, '');
    }

    return listStr;
  }

  function styleStartNumber (list, listType) {
    // check if ol and starts by a number different than 1
    if (listType === 'ol') {
      var res = list.match(/^ *(\d+)\./);
      if (res && res[1] !== '1') {
        return ' start="' + res[1] + '"';
      }
    }
    return '';
  }

  /**
   * Check and parse consecutive lists (better fix for issue #142)
   * @param {string} list
   * @param {string} listType
   * @param {boolean} trimTrailing
   * @returns {string}
   */
  function parseConsecutiveLists (list, listType, trimTrailing) {
    // check if we caught 2 or more consecutive lists by mistake
    // we use the counterRgx, meaning if listType is UL we look for OL and vice versa
    var olRgx = (options.disableForced4SpacesIndentedSublists) ? /^ ?\d+\.[ \t]/gm : /^ {0,3}\d+\.[ \t]/gm,
        ulRgx = (options.disableForced4SpacesIndentedSublists) ? /^ ?[*+-][ \t]/gm : /^ {0,3}[*+-][ \t]/gm,
        counterRxg = (listType === 'ul') ? olRgx : ulRgx,
        result = '';

    if (list.search(counterRxg) !== -1) {
      (function parseCL (txt) {
        var pos = txt.search(counterRxg),
            style = styleStartNumber(list, listType);
        if (pos !== -1) {
          // slice
          result += '\n\n<' + listType + style + '>\n' + processListItems(txt.slice(0, pos), !!trimTrailing) + '</' + listType + '>\n';

          // invert counterType and listType
          listType = (listType === 'ul') ? 'ol' : 'ul';
          counterRxg = (listType === 'ul') ? olRgx : ulRgx;

          //recurse
          parseCL(txt.slice(pos));
        } else {
          result += '\n\n<' + listType + style + '>\n' + processListItems(txt, !!trimTrailing) + '</' + listType + '>\n';
        }
      })(list);
    } else {
      var style = styleStartNumber(list, listType);
      result = '\n\n<' + listType + style + '>\n' + processListItems(list, !!trimTrailing) + '</' + listType + '>\n';
    }

    return result;
  }

  /** Start of list parsing **/
  text = globals.converter._dispatch('lists.before', text, options, globals);
  // add sentinel to hack around khtml/safari bug:
  // http://bugs.webkit.org/show_bug.cgi?id=11231
  text += '¨0';

  if (globals.gListLevel) {
    text = text.replace(/^(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm,
      function (wholeMatch, list, m2) {
        var listType = (m2.search(/[*+-]/g) > -1) ? 'ul' : 'ol';
        return parseConsecutiveLists(list, listType, true);
      }
    );
  } else {
    text = text.replace(/(\n\n|^\n?)(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm,
      function (wholeMatch, m1, list, m3) {
        var listType = (m3.search(/[*+-]/g) > -1) ? 'ul' : 'ol';
        return parseConsecutiveLists(list, listType, false);
      }
    );
  }

  // strip sentinel
  text = text.replace(/¨0/, '');
  text = globals.converter._dispatch('lists.after', text, options, globals);
  return text;
});

/**
 * Parse metadata at the top of the document
 */
showdown.subParser('metadata', function (text, options, globals) {

  if (!options.metadata) {
    return text;
  }

  text = globals.converter._dispatch('metadata.before', text, options, globals);

  function parseMetadataContents (content) {
    // raw is raw so it's not changed in any way
    globals.metadata.raw = content;

    // escape chars forbidden in html attributes
    // double quotes
    content = content
      // ampersand first
      .replace(/&/g, '&amp;')
      // double quotes
      .replace(/"/g, '&quot;');

    content = content.replace(/\n {4}/g, ' ');
    content.replace(/^([\S ]+): +([\s\S]+?)$/gm, function (wm, key, value) {
      globals.metadata.parsed[key] = value;
      return '';
    });
  }

  text = text.replace(/^\s*«««+(\S*?)\n([\s\S]+?)\n»»»+\n/, function (wholematch, format, content) {
    parseMetadataContents(content);
    return '¨M';
  });

  text = text.replace(/^\s*---+(\S*?)\n([\s\S]+?)\n---+\n/, function (wholematch, format, content) {
    if (format) {
      globals.metadata.format = format;
    }
    parseMetadataContents(content);
    return '¨M';
  });

  text = text.replace(/¨M/g, '');

  text = globals.converter._dispatch('metadata.after', text, options, globals);
  return text;
});

/**
 * Remove one level of line-leading tabs or spaces
 */
showdown.subParser('outdent', function (text, options, globals) {
  text = globals.converter._dispatch('outdent.before', text, options, globals);

  // attacklab: hack around Konqueror 3.5.4 bug:
  // "----------bug".replace(/^-/g,"") == "bug"
  text = text.replace(/^(\t|[ ]{1,4})/gm, '¨0'); // attacklab: g_tab_width

  // attacklab: clean up hack
  text = text.replace(/¨0/g, '');

  text = globals.converter._dispatch('outdent.after', text, options, globals);
  return text;
});

/**
 *
 */
showdown.subParser('paragraphs', function (text, options, globals) {

  text = globals.converter._dispatch('paragraphs.before', text, options, globals);
  // Strip leading and trailing lines:
  text = text.replace(/^\n+/g, '');
  text = text.replace(/\n+$/g, '');

  var grafs = text.split(/\n{2,}/g),
      grafsOut = [],
      end = grafs.length; // Wrap <p> tags

  for (var i = 0; i < end; i++) {
    var str = grafs[i];
    // if this is an HTML marker, copy it
    if (str.search(/¨(K|G)(\d+)\1/g) >= 0) {
      grafsOut.push(str);

    // test for presence of characters to prevent empty lines being parsed
    // as paragraphs (resulting in undesired extra empty paragraphs)
    } else if (str.search(/\S/) >= 0) {
      str = showdown.subParser('spanGamut')(str, options, globals);
      str = str.replace(/^([ \t]*)/g, '<p>');
      str += '</p>';
      grafsOut.push(str);
    }
  }

  /** Unhashify HTML blocks */
  end = grafsOut.length;
  for (i = 0; i < end; i++) {
    var blockText = '',
        grafsOutIt = grafsOut[i],
        codeFlag = false;
    // if this is a marker for an html block...
    // use RegExp.test instead of string.search because of QML bug
    while (/¨(K|G)(\d+)\1/.test(grafsOutIt)) {
      var delim = RegExp.$1,
          num   = RegExp.$2;

      if (delim === 'K') {
        blockText = globals.gHtmlBlocks[num];
      } else {
        // we need to check if ghBlock is a false positive
        if (codeFlag) {
          // use encoded version of all text
          blockText = showdown.subParser('encodeCode')(globals.ghCodeBlocks[num].text, options, globals);
        } else {
          blockText = globals.ghCodeBlocks[num].codeblock;
        }
      }
      blockText = blockText.replace(/\$/g, '$$$$'); // Escape any dollar signs

      grafsOutIt = grafsOutIt.replace(/(\n\n)?¨(K|G)\d+\2(\n\n)?/, blockText);
      // Check if grafsOutIt is a pre->code
      if (/^<pre\b[^>]*>\s*<code\b[^>]*>/.test(grafsOutIt)) {
        codeFlag = true;
      }
    }
    grafsOut[i] = grafsOutIt;
  }
  text = grafsOut.join('\n');
  // Strip leading and trailing lines:
  text = text.replace(/^\n+/g, '');
  text = text.replace(/\n+$/g, '');
  return globals.converter._dispatch('paragraphs.after', text, options, globals);
});

/**
 * Run extension
 */
showdown.subParser('runExtension', function (ext, text, options, globals) {

  if (ext.filter) {
    text = ext.filter(text, globals.converter, options);

  } else if (ext.regex) {
    // TODO remove this when old extension loading mechanism is deprecated
    var re = ext.regex;
    if (!(re instanceof RegExp)) {
      re = new RegExp(re, 'g');
    }
    text = text.replace(re, ext.replace);
  }

  return text;
});

/**
 * These are all the transformations that occur *within* block-level
 * tags like paragraphs, headers, and list items.
 */
showdown.subParser('spanGamut', function (text, options, globals) {

  text = globals.converter._dispatch('spanGamut.before', text, options, globals);
  text = showdown.subParser('codeSpans')(text, options, globals);
  text = showdown.subParser('escapeSpecialCharsWithinTagAttributes')(text, options, globals);
  text = showdown.subParser('encodeBackslashEscapes')(text, options, globals);

  // Process anchor and image tags. Images must come first,
  // because ![foo][f] looks like an anchor.
  text = showdown.subParser('images')(text, options, globals);
  text = showdown.subParser('anchors')(text, options, globals);

  // Make links out of things like `<http://example.com/>`
  // Must come after anchors, because you can use < and >
  // delimiters in inline links like [this](<url>).
  text = showdown.subParser('autoLinks')(text, options, globals);
  text = showdown.subParser('simplifiedAutoLinks')(text, options, globals);
  text = showdown.subParser('emoji')(text, options, globals);
  text = showdown.subParser('underline')(text, options, globals);
  text = showdown.subParser('italicsAndBold')(text, options, globals);
  text = showdown.subParser('strikethrough')(text, options, globals);
  text = showdown.subParser('ellipsis')(text, options, globals);

  // we need to hash HTML tags inside spans
  text = showdown.subParser('hashHTMLSpans')(text, options, globals);

  // now we encode amps and angles
  text = showdown.subParser('encodeAmpsAndAngles')(text, options, globals);

  // Do hard breaks
  if (options.simpleLineBreaks) {
    // GFM style hard breaks
    // only add line breaks if the text does not contain a block (special case for lists)
    if (!/\n\n¨K/.test(text)) {
      text = text.replace(/\n+/g, '<br />\n');
    }
  } else {
    // Vanilla hard breaks
    text = text.replace(/  +\n/g, '<br />\n');
  }

  text = globals.converter._dispatch('spanGamut.after', text, options, globals);
  return text;
});

showdown.subParser('strikethrough', function (text, options, globals) {

  function parseInside (txt) {
    if (options.simplifiedAutoLink) {
      txt = showdown.subParser('simplifiedAutoLinks')(txt, options, globals);
    }
    return '<del>' + txt + '</del>';
  }

  if (options.strikethrough) {
    text = globals.converter._dispatch('strikethrough.before', text, options, globals);
    text = text.replace(/(?:~){2}([\s\S]+?)(?:~){2}/g, function (wm, txt) { return parseInside(txt); });
    text = globals.converter._dispatch('strikethrough.after', text, options, globals);
  }

  return text;
});

/**
 * Strips link definitions from text, stores the URLs and titles in
 * hash references.
 * Link defs are in the form: ^[id]: url "optional title"
 */
showdown.subParser('stripLinkDefinitions', function (text, options, globals) {

  var regex       = /^ {0,3}\[(.+)]:[ \t]*\n?[ \t]*<?([^>\s]+)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n+|(?=¨0))/gm,
      base64Regex = /^ {0,3}\[(.+)]:[ \t]*\n?[ \t]*<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n\n|(?=¨0)|(?=\n\[))/gm;

  // attacklab: sentinel workarounds for lack of \A and \Z, safari\khtml bug
  text += '¨0';

  var replaceFunc = function (wholeMatch, linkId, url, width, height, blankLines, title) {
    linkId = linkId.toLowerCase();
    if (url.match(/^data:.+?\/.+?;base64,/)) {
      // remove newlines
      globals.gUrls[linkId] = url.replace(/\s/g, '');
    } else {
      globals.gUrls[linkId] = showdown.subParser('encodeAmpsAndAngles')(url, options, globals);  // Link IDs are case-insensitive
    }

    if (blankLines) {
      // Oops, found blank lines, so it's not a title.
      // Put back the parenthetical statement we stole.
      return blankLines + title;

    } else {
      if (title) {
        globals.gTitles[linkId] = title.replace(/"|'/g, '&quot;');
      }
      if (options.parseImgDimensions && width && height) {
        globals.gDimensions[linkId] = {
          width:  width,
          height: height
        };
      }
    }
    // Completely remove the definition from the text
    return '';
  };

  // first we try to find base64 link references
  text = text.replace(base64Regex, replaceFunc);

  text = text.replace(regex, replaceFunc);

  // attacklab: strip sentinel
  text = text.replace(/¨0/, '');

  return text;
});

showdown.subParser('tables', function (text, options, globals) {

  if (!options.tables) {
    return text;
  }

  var tableRgx       = /^ {0,3}\|?.+\|.+\n {0,3}\|?[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*:?[ \t]*(?:[-=]){2,}[\s\S]+?(?:\n\n|¨0)/gm,
      //singeColTblRgx = /^ {0,3}\|.+\|\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n(?: {0,3}\|.+\|\n)+(?:\n\n|¨0)/gm;
      singeColTblRgx = /^ {0,3}\|.+\|[ \t]*\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n( {0,3}\|.+\|[ \t]*\n)*(?:\n|¨0)/gm;

  function parseStyles (sLine) {
    if (/^:[ \t]*--*$/.test(sLine)) {
      return ' style="text-align:left;"';
    } else if (/^--*[ \t]*:[ \t]*$/.test(sLine)) {
      return ' style="text-align:right;"';
    } else if (/^:[ \t]*--*[ \t]*:$/.test(sLine)) {
      return ' style="text-align:center;"';
    } else {
      return '';
    }
  }

  function parseHeaders (header, style) {
    var id = '';
    header = header.trim();
    // support both tablesHeaderId and tableHeaderId due to error in documentation so we don't break backwards compatibility
    if (options.tablesHeaderId || options.tableHeaderId) {
      id = ' id="' + header.replace(/ /g, '_').toLowerCase() + '"';
    }
    header = showdown.subParser('spanGamut')(header, options, globals);

    return '<th' + id + style + '>' + header + '</th>\n';
  }

  function parseCells (cell, style) {
    var subText = showdown.subParser('spanGamut')(cell, options, globals);
    return '<td' + style + '>' + subText + '</td>\n';
  }

  function buildTable (headers, cells) {
    var tb = '<table>\n<thead>\n<tr>\n',
        tblLgn = headers.length;

    for (var i = 0; i < tblLgn; ++i) {
      tb += headers[i];
    }
    tb += '</tr>\n</thead>\n<tbody>\n';

    for (i = 0; i < cells.length; ++i) {
      tb += '<tr>\n';
      for (var ii = 0; ii < tblLgn; ++ii) {
        tb += cells[i][ii];
      }
      tb += '</tr>\n';
    }
    tb += '</tbody>\n</table>\n';
    return tb;
  }

  function parseTable (rawTable) {
    var i, tableLines = rawTable.split('\n');

    for (i = 0; i < tableLines.length; ++i) {
      // strip wrong first and last column if wrapped tables are used
      if (/^ {0,3}\|/.test(tableLines[i])) {
        tableLines[i] = tableLines[i].replace(/^ {0,3}\|/, '');
      }
      if (/\|[ \t]*$/.test(tableLines[i])) {
        tableLines[i] = tableLines[i].replace(/\|[ \t]*$/, '');
      }
      // parse code spans first, but we only support one line code spans
      tableLines[i] = showdown.subParser('codeSpans')(tableLines[i], options, globals);
    }

    var rawHeaders = tableLines[0].split('|').map(function (s) { return s.trim();}),
        rawStyles = tableLines[1].split('|').map(function (s) { return s.trim();}),
        rawCells = [],
        headers = [],
        styles = [],
        cells = [];

    tableLines.shift();
    tableLines.shift();

    for (i = 0; i < tableLines.length; ++i) {
      if (tableLines[i].trim() === '') {
        continue;
      }
      rawCells.push(
        tableLines[i]
          .split('|')
          .map(function (s) {
            return s.trim();
          })
      );
    }

    if (rawHeaders.length < rawStyles.length) {
      return rawTable;
    }

    for (i = 0; i < rawStyles.length; ++i) {
      styles.push(parseStyles(rawStyles[i]));
    }

    for (i = 0; i < rawHeaders.length; ++i) {
      if (showdown.helper.isUndefined(styles[i])) {
        styles[i] = '';
      }
      headers.push(parseHeaders(rawHeaders[i], styles[i]));
    }

    for (i = 0; i < rawCells.length; ++i) {
      var row = [];
      for (var ii = 0; ii < headers.length; ++ii) {
        if (showdown.helper.isUndefined(rawCells[i][ii])) ;
        row.push(parseCells(rawCells[i][ii], styles[ii]));
      }
      cells.push(row);
    }

    return buildTable(headers, cells);
  }

  text = globals.converter._dispatch('tables.before', text, options, globals);

  // find escaped pipe characters
  text = text.replace(/\\(\|)/g, showdown.helper.escapeCharactersCallback);

  // parse multi column tables
  text = text.replace(tableRgx, parseTable);

  // parse one column tables
  text = text.replace(singeColTblRgx, parseTable);

  text = globals.converter._dispatch('tables.after', text, options, globals);

  return text;
});

showdown.subParser('underline', function (text, options, globals) {

  if (!options.underline) {
    return text;
  }

  text = globals.converter._dispatch('underline.before', text, options, globals);

  if (options.literalMidWordUnderscores) {
    text = text.replace(/\b___(\S[\s\S]*?)___\b/g, function (wm, txt) {
      return '<u>' + txt + '</u>';
    });
    text = text.replace(/\b__(\S[\s\S]*?)__\b/g, function (wm, txt) {
      return '<u>' + txt + '</u>';
    });
  } else {
    text = text.replace(/___(\S[\s\S]*?)___/g, function (wm, m) {
      return (/\S$/.test(m)) ? '<u>' + m + '</u>' : wm;
    });
    text = text.replace(/__(\S[\s\S]*?)__/g, function (wm, m) {
      return (/\S$/.test(m)) ? '<u>' + m + '</u>' : wm;
    });
  }

  // escape remaining underscores to prevent them being parsed by italic and bold
  text = text.replace(/(_)/g, showdown.helper.escapeCharactersCallback);

  text = globals.converter._dispatch('underline.after', text, options, globals);

  return text;
});

/**
 * Swap back in all the special characters we've hidden.
 */
showdown.subParser('unescapeSpecialChars', function (text, options, globals) {
  text = globals.converter._dispatch('unescapeSpecialChars.before', text, options, globals);

  text = text.replace(/¨E(\d+)E/g, function (wholeMatch, m1) {
    var charCodeToReplace = parseInt(m1);
    return String.fromCharCode(charCodeToReplace);
  });

  text = globals.converter._dispatch('unescapeSpecialChars.after', text, options, globals);
  return text;
});

showdown.subParser('makeMarkdown.blockquote', function (node, globals) {

  var txt = '';
  if (node.hasChildNodes()) {
    var children = node.childNodes,
        childrenLength = children.length;

    for (var i = 0; i < childrenLength; ++i) {
      var innerTxt = showdown.subParser('makeMarkdown.node')(children[i], globals);

      if (innerTxt === '') {
        continue;
      }
      txt += innerTxt;
    }
  }
  // cleanup
  txt = txt.trim();
  txt = '> ' + txt.split('\n').join('\n> ');
  return txt;
});

showdown.subParser('makeMarkdown.codeBlock', function (node, globals) {

  var lang = node.getAttribute('language'),
      num  = node.getAttribute('precodenum');
  return '```' + lang + '\n' + globals.preList[num] + '\n```';
});

showdown.subParser('makeMarkdown.codeSpan', function (node) {

  return '`' + node.innerHTML + '`';
});

showdown.subParser('makeMarkdown.emphasis', function (node, globals) {

  var txt = '';
  if (node.hasChildNodes()) {
    txt += '*';
    var children = node.childNodes,
        childrenLength = children.length;
    for (var i = 0; i < childrenLength; ++i) {
      txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
    }
    txt += '*';
  }
  return txt;
});

showdown.subParser('makeMarkdown.header', function (node, globals, headerLevel) {

  var headerMark = new Array(headerLevel + 1).join('#'),
      txt = '';

  if (node.hasChildNodes()) {
    txt = headerMark + ' ';
    var children = node.childNodes,
        childrenLength = children.length;

    for (var i = 0; i < childrenLength; ++i) {
      txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
    }
  }
  return txt;
});

showdown.subParser('makeMarkdown.hr', function () {

  return '---';
});

showdown.subParser('makeMarkdown.image', function (node) {

  var txt = '';
  if (node.hasAttribute('src')) {
    txt += '![' + node.getAttribute('alt') + '](';
    txt += '<' + node.getAttribute('src') + '>';
    if (node.hasAttribute('width') && node.hasAttribute('height')) {
      txt += ' =' + node.getAttribute('width') + 'x' + node.getAttribute('height');
    }

    if (node.hasAttribute('title')) {
      txt += ' "' + node.getAttribute('title') + '"';
    }
    txt += ')';
  }
  return txt;
});

showdown.subParser('makeMarkdown.links', function (node, globals) {

  var txt = '';
  if (node.hasChildNodes() && node.hasAttribute('href')) {
    var children = node.childNodes,
        childrenLength = children.length;
    txt = '[';
    for (var i = 0; i < childrenLength; ++i) {
      txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
    }
    txt += '](';
    txt += '<' + node.getAttribute('href') + '>';
    if (node.hasAttribute('title')) {
      txt += ' "' + node.getAttribute('title') + '"';
    }
    txt += ')';
  }
  return txt;
});

showdown.subParser('makeMarkdown.list', function (node, globals, type) {

  var txt = '';
  if (!node.hasChildNodes()) {
    return '';
  }
  var listItems       = node.childNodes,
      listItemsLenght = listItems.length,
      listNum = node.getAttribute('start') || 1;

  for (var i = 0; i < listItemsLenght; ++i) {
    if (typeof listItems[i].tagName === 'undefined' || listItems[i].tagName.toLowerCase() !== 'li') {
      continue;
    }

    // define the bullet to use in list
    var bullet = '';
    if (type === 'ol') {
      bullet = listNum.toString() + '. ';
    } else {
      bullet = '- ';
    }

    // parse list item
    txt += bullet + showdown.subParser('makeMarkdown.listItem')(listItems[i], globals);
    ++listNum;
  }

  // add comment at the end to prevent consecutive lists to be parsed as one
  txt += '\n<!-- -->\n';
  return txt.trim();
});

showdown.subParser('makeMarkdown.listItem', function (node, globals) {

  var listItemTxt = '';

  var children = node.childNodes,
      childrenLenght = children.length;

  for (var i = 0; i < childrenLenght; ++i) {
    listItemTxt += showdown.subParser('makeMarkdown.node')(children[i], globals);
  }
  // if it's only one liner, we need to add a newline at the end
  if (!/\n$/.test(listItemTxt)) {
    listItemTxt += '\n';
  } else {
    // it's multiparagraph, so we need to indent
    listItemTxt = listItemTxt
      .split('\n')
      .join('\n    ')
      .replace(/^ {4}$/gm, '')
      .replace(/\n\n+/g, '\n\n');
  }

  return listItemTxt;
});



showdown.subParser('makeMarkdown.node', function (node, globals, spansOnly) {

  spansOnly = spansOnly || false;

  var txt = '';

  // edge case of text without wrapper paragraph
  if (node.nodeType === 3) {
    return showdown.subParser('makeMarkdown.txt')(node, globals);
  }

  // HTML comment
  if (node.nodeType === 8) {
    return '<!--' + node.data + '-->\n\n';
  }

  // process only node elements
  if (node.nodeType !== 1) {
    return '';
  }

  var tagName = node.tagName.toLowerCase();

  switch (tagName) {

    //
    // BLOCKS
    //
    case 'h1':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, globals, 1) + '\n\n'; }
      break;
    case 'h2':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, globals, 2) + '\n\n'; }
      break;
    case 'h3':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, globals, 3) + '\n\n'; }
      break;
    case 'h4':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, globals, 4) + '\n\n'; }
      break;
    case 'h5':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, globals, 5) + '\n\n'; }
      break;
    case 'h6':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, globals, 6) + '\n\n'; }
      break;

    case 'p':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.paragraph')(node, globals) + '\n\n'; }
      break;

    case 'blockquote':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.blockquote')(node, globals) + '\n\n'; }
      break;

    case 'hr':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.hr')(node, globals) + '\n\n'; }
      break;

    case 'ol':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.list')(node, globals, 'ol') + '\n\n'; }
      break;

    case 'ul':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.list')(node, globals, 'ul') + '\n\n'; }
      break;

    case 'precode':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.codeBlock')(node, globals) + '\n\n'; }
      break;

    case 'pre':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.pre')(node, globals) + '\n\n'; }
      break;

    case 'table':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.table')(node, globals) + '\n\n'; }
      break;

    //
    // SPANS
    //
    case 'code':
      txt = showdown.subParser('makeMarkdown.codeSpan')(node, globals);
      break;

    case 'em':
    case 'i':
      txt = showdown.subParser('makeMarkdown.emphasis')(node, globals);
      break;

    case 'strong':
    case 'b':
      txt = showdown.subParser('makeMarkdown.strong')(node, globals);
      break;

    case 'del':
      txt = showdown.subParser('makeMarkdown.strikethrough')(node, globals);
      break;

    case 'a':
      txt = showdown.subParser('makeMarkdown.links')(node, globals);
      break;

    case 'img':
      txt = showdown.subParser('makeMarkdown.image')(node, globals);
      break;

    default:
      txt = node.outerHTML + '\n\n';
  }

  // common normalization
  // TODO eventually

  return txt;
});

showdown.subParser('makeMarkdown.paragraph', function (node, globals) {

  var txt = '';
  if (node.hasChildNodes()) {
    var children = node.childNodes,
        childrenLength = children.length;
    for (var i = 0; i < childrenLength; ++i) {
      txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
    }
  }

  // some text normalization
  txt = txt.trim();

  return txt;
});

showdown.subParser('makeMarkdown.pre', function (node, globals) {

  var num  = node.getAttribute('prenum');
  return '<pre>' + globals.preList[num] + '</pre>';
});

showdown.subParser('makeMarkdown.strikethrough', function (node, globals) {

  var txt = '';
  if (node.hasChildNodes()) {
    txt += '~~';
    var children = node.childNodes,
        childrenLength = children.length;
    for (var i = 0; i < childrenLength; ++i) {
      txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
    }
    txt += '~~';
  }
  return txt;
});

showdown.subParser('makeMarkdown.strong', function (node, globals) {

  var txt = '';
  if (node.hasChildNodes()) {
    txt += '**';
    var children = node.childNodes,
        childrenLength = children.length;
    for (var i = 0; i < childrenLength; ++i) {
      txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
    }
    txt += '**';
  }
  return txt;
});

showdown.subParser('makeMarkdown.table', function (node, globals) {

  var txt = '',
      tableArray = [[], []],
      headings   = node.querySelectorAll('thead>tr>th'),
      rows       = node.querySelectorAll('tbody>tr'),
      i, ii;
  for (i = 0; i < headings.length; ++i) {
    var headContent = showdown.subParser('makeMarkdown.tableCell')(headings[i], globals),
        allign = '---';

    if (headings[i].hasAttribute('style')) {
      var style = headings[i].getAttribute('style').toLowerCase().replace(/\s/g, '');
      switch (style) {
        case 'text-align:left;':
          allign = ':---';
          break;
        case 'text-align:right;':
          allign = '---:';
          break;
        case 'text-align:center;':
          allign = ':---:';
          break;
      }
    }
    tableArray[0][i] = headContent.trim();
    tableArray[1][i] = allign;
  }

  for (i = 0; i < rows.length; ++i) {
    var r = tableArray.push([]) - 1,
        cols = rows[i].getElementsByTagName('td');

    for (ii = 0; ii < headings.length; ++ii) {
      var cellContent = ' ';
      if (typeof cols[ii] !== 'undefined') {
        cellContent = showdown.subParser('makeMarkdown.tableCell')(cols[ii], globals);
      }
      tableArray[r].push(cellContent);
    }
  }

  var cellSpacesCount = 3;
  for (i = 0; i < tableArray.length; ++i) {
    for (ii = 0; ii < tableArray[i].length; ++ii) {
      var strLen = tableArray[i][ii].length;
      if (strLen > cellSpacesCount) {
        cellSpacesCount = strLen;
      }
    }
  }

  for (i = 0; i < tableArray.length; ++i) {
    for (ii = 0; ii < tableArray[i].length; ++ii) {
      if (i === 1) {
        if (tableArray[i][ii].slice(-1) === ':') {
          tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii].slice(-1), cellSpacesCount - 1, '-') + ':';
        } else {
          tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount, '-');
        }
      } else {
        tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount);
      }
    }
    txt += '| ' + tableArray[i].join(' | ') + ' |\n';
  }

  return txt.trim();
});

showdown.subParser('makeMarkdown.tableCell', function (node, globals) {

  var txt = '';
  if (!node.hasChildNodes()) {
    return '';
  }
  var children = node.childNodes,
      childrenLength = children.length;

  for (var i = 0; i < childrenLength; ++i) {
    txt += showdown.subParser('makeMarkdown.node')(children[i], globals, true);
  }
  return txt.trim();
});

showdown.subParser('makeMarkdown.txt', function (node) {

  var txt = node.nodeValue;

  // multiple spaces are collapsed
  txt = txt.replace(/ +/g, ' ');

  // replace the custom ¨NBSP; with a space
  txt = txt.replace(/¨NBSP;/g, ' ');

  // ", <, > and & should replace escaped html entities
  txt = showdown.helper.unescapeHTMLEntities(txt);

  // escape markdown magic characters
  // emphasis, strong and strikethrough - can appear everywhere
  // we also escape pipe (|) because of tables
  // and escape ` because of code blocks and spans
  txt = txt.replace(/([*_~|`])/g, '\\$1');

  // escape > because of blockquotes
  txt = txt.replace(/^(\s*)>/g, '\\$1>');

  // hash character, only troublesome at the beginning of a line because of headers
  txt = txt.replace(/^#/gm, '\\#');

  // horizontal rules
  txt = txt.replace(/^(\s*)([-=]{3,})(\s*)$/, '$1\\$2$3');

  // dot, because of ordered lists, only troublesome at the beginning of a line when preceded by an integer
  txt = txt.replace(/^( {0,3}\d+)\./gm, '$1\\.');

  // +, * and -, at the beginning of a line becomes a list, so we need to escape them also (asterisk was already escaped)
  txt = txt.replace(/^( {0,3})([+-])/gm, '$1\\$2');

  // images and links, ] followed by ( is problematic, so we escape it
  txt = txt.replace(/]([\s]*)\(/g, '\\]$1\\(');

  // reference URIs must also be escaped
  txt = txt.replace(/^ {0,3}\[([\S \t]*?)]:/gm, '\\[$1]:');

  return txt;
});

var root = this;

// AMD Loader
if ( module.exports) {
  module.exports = showdown;

// Regular Browser loader
} else {
  root.showdown = showdown;
}
}).call(commonjsGlobal);


});

var _templateObject$6, _templateObject2$3;
var converter = new showdown.Converter({
  tables: true,
  noHeaderId: true,
  headerLevelStart: 1,
  simpleLineBreaks: true,
  extensions: []
});
var SMALL_LOOKUP = {
  body: 'bodySmall',
  bodyHeading: 'bodySmallHeading',
  finePrint: 'legal',
  bodySmallHeading: 'finePrintHeading',
  bodySmall: 'finePrint'
};
var getFontType = function getFontType(smallFontSizes, targetFontType) {
  if (smallFontSizes) {
    return SMALL_LOOKUP[targetFontType];
  }
  return targetFontType;
};
var headings = [1, 2, 3, 4, 5, 6].reduce(function (acc, level) {
  return css(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n        ", "\n        h", " {\n            ", "\n        }\n    "])), acc, level, function (props) {
    return typographyMixin(Object.assign({}, props, {
      fontType: "h" + level
    }));
  });
}, '');
var StyledMarkdown = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n    ", "\n    ul {\n        list-style-type: disc;\n    }\n    ", "\n    strong {\n        ", "\n    }\n    sub {\n        ", "\n    }\n    ol {\n        list-style-type: decimal;\n        ol {\n            list-style-type: lower-alpha;\n            margin-bottom: ", ";\n        }\n    }\n    ul,\n    ol {\n        padding-left: ", ";\n        padding-bottom: ", ";\n    }\n    a {\n        ", "\n    }\n    p {\n        margin-bottom: ", ";\n        ", "\n    }\n    table {\n        ", ";\n    }\n    th {\n        ", ";\n    }\n    td {\n        ", "\n    }\n    ", "\n    &&& {\n        td,\n        th {\n            padding: ", "px ", "px;\n            border: ", "px solid ", ";\n        }\n    }\n"])), headings, function (_ref) {
  var smallFontSizes = _ref.smallFontSizes,
    props = _objectWithoutProperties(_ref, ["smallFontSizes"]);
  return typographyMixin(Object.assign({}, props, {
    fontType: getFontType(smallFontSizes, 'body')
  }));
}, function (_ref2) {
  var smallFontSizes = _ref2.smallFontSizes,
    props = _objectWithoutProperties(_ref2, ["smallFontSizes"]);
  return typographyMixin(Object.assign({}, props, {
    fontType: getFontType(smallFontSizes, 'bodyHeading')
  }));
}, function (_ref3) {
  var smallFontSizes = _ref3.smallFontSizes,
    props = _objectWithoutProperties(_ref3, ["smallFontSizes"]);
  return typographyMixin(Object.assign({}, props, {
    fontType: getFontType(smallFontSizes, 'fineprint')
  }));
}, spaceMixin('sm'), spaceMixin('lg'), spaceMixin('md'), AnchorMixin, spaceMixin('sm'), function (_ref4) {
  var smallFontSizes = _ref4.smallFontSizes,
    props = _objectWithoutProperties(_ref4, ["smallFontSizes"]);
  return typographyMixin(Object.assign({}, props, {
    fontType: getFontType(smallFontSizes, 'body')
  }));
}, function (props) {
  return TableMixin(Object.assign({}, props, {
    alignments: [],
    appearance: 'grid',
    size: 'md'
  }));
}, function (_ref5) {
  var smallFontSizes = _ref5.smallFontSizes,
    props = _objectWithoutProperties(_ref5, ["smallFontSizes"]);
  return typographyMixin(Object.assign({}, props, {
    fontType: getFontType(smallFontSizes, 'bodySmallHeading')
  }));
}, function (_ref6) {
  var smallFontSizes = _ref6.smallFontSizes,
    props = _objectWithoutProperties(_ref6, ["smallFontSizes"]);
  return typographyMixin(Object.assign({}, props, {
    fontType: getFontType(smallFontSizes, 'bodySmall')
  }));
},
/*
  Unfortunately this is necessary because the styles for cells are managed by the TableMixin and rely
  on the CSS selectors of the React components, which we cannot get in target via markdown.
*/
'', token('Table.verticalPadding.md'), token('Table.horizontalPadding.md'), token('Table.borderWidth'), token('Table.borderColor'));
var RenderMarkdownWithConstellation = function RenderMarkdownWithConstellation(_ref7) {
  var markdown = _ref7.markdown,
    smallFontSizes = _ref7.smallFontSizes;
  return /*#__PURE__*/React.createElement(StyledMarkdown, {
    smallFontSizes: smallFontSizes
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: converter.makeHtml(markdown)
    }
  });
};
RenderMarkdownWithConstellation.propTypes = process.env.NODE_ENV !== "production" ? {
  markdown: propTypes.string,
  smallFontSizes: propTypes.bool
} : {};

var getMarkdownCMSDocument = function getMarkdownCMSDocument() {
  return new Promise(function ($return, $error) {
    var $Try_1_Catch = function (e) {
      try {
        return $return({
          content: '',
          hasApiError: true
        });
      } catch ($boundEx) {
        return $error($boundEx);
      }
    };
    try {
      return Promise.resolve(API.MAX.GET({
        action: 'getMarkdownCMSDocument',
        input: {
          id: 'affiliate-business-arrangement-disclosure'
        }
      })).then($return, $Try_1_Catch);
    } catch (e) {
      $Try_1_Catch();
    }
  });
};
var PAABADModal = function PAABADModal(_ref) {
  var onClose = _ref.onClose,
    restProps = _objectWithoutProperties(_ref, ["onClose"]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    content = _useState4[0],
    setContent = _useState4[1];
  useEffect(function () {
    setError(false);
    getMarkdownCMSDocument().then(function (response) {
      if (response.hasApiError) {
        setError(true);
      } else {
        setContent(response.content);
        event(generateAbadModalViewEvent(response.content, '', true));
      }
    });
  }, []);
  useEffect(function () {
    trackEvent({
      category: ' Mortgages',
      action: 'PA ABAD modal open'
    });
  }, []);
  var handleClose = useCallback(function () {
    trackEvent({
      category: ' Mortgages',
      action: 'PA ABAD modal close'
    });
    event(generateAbadModalCloseEvent(content, '', true));
    onClose();
  }, [onClose, content]);
  return /*#__PURE__*/React.createElement(ModalDialog, _extends({}, restProps, {
    shouldCloseOnOutsideClick: false,
    onClose: handleClose,
    wide: true,
    renderHeader: /*#__PURE__*/React.createElement(Heading, {
      level: 2,
      marginX: "md",
      marginY: "xs"
    }, "Affiliated Business Arrangement Disclosure"),
    renderBody: /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(Spacer, {
      marginY: "sm"
    }, /*#__PURE__*/React.createElement(Alert, {
      appearance: "error",
      body: "Unable to fetch document. Please try again later"
    })), /*#__PURE__*/React.createElement(RenderMarkdownWithConstellation, {
      markdown: content
    })),
    renderFooter: /*#__PURE__*/React.createElement(Button, {
      buttonType: BUTTON_TYPES.primary,
      fluid: {
        default: true,
        md: false
      },
      onClick: handleClose
    }, "Close")
  }));
};
PAABADModal.propTypes = process.env.NODE_ENV !== "production" ? {
  onClose: propTypes.func.isRequired
} : {};

var PAName = function PAName(_ref) {
  var answers = _ref.answers,
    context = _ref.context,
    componentProps = _objectWithoutProperties(_ref, ["answers", "context"]);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showABAD = _useState2[0],
    setShowABAD = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PAABADModal, {
    onClose: function onClose() {
      return setShowABAD(false);
    },
    isOpen: showABAD
  }), /*#__PURE__*/React.createElement(SingleLineName, _extends({}, componentProps, {
    title: "Sounds good \u2013 what\u2019s your first and last name?"
  })));
};
PAName.propTypes = process.env.NODE_ENV !== "production" ? {
  answers: propTypes.object,
  context: propTypes.object
} : {};

var _templateObject$7;
var ESIGNATURE_CONSENT_DOC_URL = 'https://zillowdocs.com/u/g2mZY537ouFKvRZ2Ds867W';
var StyledZDocsDocumentViewerDialog = styled(ModalDialog)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n    ", " {\n        ", " {\n            padding: 0;\n        }\n\n        iframe {\n            width: 100%;\n            height: 75vh;\n            border: 0;\n        }\n    }\n"])), StyledDialog, StyledDialogBody);
var ZDocsDocumentViewerDialog = function ZDocsDocumentViewerDialog(_ref) {
  var props = _extends({}, _ref);
  return /*#__PURE__*/React.createElement(StyledZDocsDocumentViewerDialog, _extends({
    body: /*#__PURE__*/React.createElement("iframe", {
      src: ESIGNATURE_CONSENT_DOC_URL
    }),
    wide: true
  }, props));
};
var ZDocESignatureConsent = function ZDocESignatureConsent(_ref2) {
  var ctaText = _ref2.ctaText;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isConsentDocOpen = _useState2[0],
    setIsConsentDocOpen = _useState2[1];
  var onOpenConsentDoc = useCallback(function () {
    setIsConsentDocOpen(true);
  }, []);
  var onCloseConsentDoc = useCallback(function () {
    setIsConsentDocOpen(false);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ZDocsDocumentViewerDialog, {
    isOpen: isConsentDocOpen,
    onClose: onCloseConsentDoc
  }), /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "finePrint",
    fontColor: "textMedium",
    marginTop: "sm"
  }, "By selecting \"", ctaText, "\", I provide consent and agree to the", ' ', /*#__PURE__*/React.createElement(Anchor, {
    onClick: onOpenConsentDoc
  }, "Use of Electronic Signatures and Records"), "."));
};
ZDocESignatureConsent.propTypes = process.env.NODE_ENV !== "production" ? {
  ctaText: propTypes.string
} : {};
ZDocESignatureConsent.defaultProps = {
  ctaText: PHONENUMBER_CTA_TEXT
};

// TODO: API.MAX.POST parsePhoneNumber
var PhoneNumber = function PhoneNumber(_ref) {
  var _data$primaryLender$c, _data$primaryLender, _ref2, _uxConfiguration$data, _uxConfiguration$data2;
  var name = _ref.name,
    value = _ref.value,
    context = _ref.context,
    answers = _ref.answers,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  var _useState = useState(function () {
      return {
        primaryLender: context === null || context === void 0 ? void 0 : context.primaryLender
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var lenderName = (_data$primaryLender$c = (_data$primaryLender = data.primaryLender) === null || _data$primaryLender === void 0 ? void 0 : _data$primaryLender.companyName) !== null && _data$primaryLender$c !== void 0 ? _data$primaryLender$c : '';
  var ctaText = "Contact " + lenderName;
  var onSubmit = useCallback(function () {
    return new Promise(function ($return, $error) {
      var _response$primaryLend, _data$primaryLender2, response;
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      var $Try_1_Catch = function (_unused) {
        try {
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(getLongFormContactPossible(answers, context)).then(function ($await_2) {
          try {
            response = $await_2;
            if (((_response$primaryLend = response.primaryLender) === null || _response$primaryLend === void 0 ? void 0 : _response$primaryLend.nmlsId) !== ((_data$primaryLender2 = data.primaryLender) === null || _data$primaryLender2 === void 0 ? void 0 : _data$primaryLender2.nmlsId)) {
              setData({
                primaryLender: response === null || response === void 0 ? void 0 : response.primaryLender
              });
              setContext({
                primaryLender: response === null || response === void 0 ? void 0 : response.primaryLender
              });
            } else {
              onNext();
            }
            // eslint-disable-next-line no-empty
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (_unused) {
        $Try_1_Catch();
      }
    });
  }, [answers, context, onNext, data]);
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: PHONENUMBER_QUESTION_TEXT
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value, _ref2),
    hasFormActions: true,
    formActionLabel: ctaText,
    onChange: onChange,
    onSubmit: onSubmit,
    validationSchema: getPhoneNumberSchema()
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledField, {
      field: fields[name],
      placeholder: "(XXX) XXX-XXXX",
      autoComplete: "off",
      "data-dd-privacy": "mask-user-input"
    });
  }), /*#__PURE__*/React.createElement(Text, {
    fontType: "finePrint",
    fontColor: "textMedium",
    as: "p",
    marginTop: "lg"
  }, "By selecting \u201C", ctaText, "\u201D, I authorize ZGMI to send the information I provided to ", lenderName, ". By selecting \u201C", ctaText, "\u201D, I authorize ", lenderName, " to deliver or cause to be delivered to me at my phone number, telemarketing calls which may use an automatic telephone dialing system, an artificial or prerecorded voice or text message. I understand that I am not required to provide this consent and authorization and it is not a condition to qualify for a loan or receive any good or services."), (uxConfiguration === null || uxConfiguration === void 0 ? void 0 : uxConfiguration.dataShareList) && (uxConfiguration === null || uxConfiguration === void 0 ? void 0 : (_uxConfiguration$data = uxConfiguration.dataShareList) === null || _uxConfiguration$data === void 0 ? void 0 : (_uxConfiguration$data2 = _uxConfiguration$data.indexOf) === null || _uxConfiguration$data2 === void 0 ? void 0 : _uxConfiguration$data2.call(_uxConfiguration$data, answers.location.state)) !== -1 && /*#__PURE__*/React.createElement(Text, {
    fontType: "finePrint",
    fontColor: "textMedium",
    as: "p",
    marginTop: "sm"
  }, "Further, I authorize the participating lender who receives the information I provided to share information regarding my loan request or application with ZGMI for the sole purpose of analytics and market research concerning ZGMI's lender advertising program."), /*#__PURE__*/React.createElement(ZDocESignatureConsent, {
    ctaText: ctaText
  }));
};
PhoneNumber.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.any,
  context: propTypes.shape({
    primaryLender: propTypes.shape({
      nmlsId: propTypes.string
    })
  }),
  answers: propTypes.shape({
    hasAgent: propTypes.bool,
    loanType: propTypes.string,
    location: propTypes.shape({
      state: propTypes.string
    }),
    needs: propTypes.string
  }),
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var PROPERTY_TYPE_OPTIONS = {
  SingleFamilyHome: 'Single family home',
  TownHouse: 'Townhome',
  CondoFourOrFewerStories: 'Condominium',
  MobileOrManufactured: 'Mobile or manufactured'
};

/**
 * How is the home being used.
 */

var PROPERTY_USAGE_OPTIONS = {
  Primary: 'Primary residence',
  SecondaryOrVacation: 'Secondary / vacation',
  InvestmentOrRental: 'Investment property'
};
var PROPERTY_COUNT_OPTIONS = {
  One: '1',
  TwoToFour: '2 to 4',
  FiveOrMore: '5 or more'
};

var validationSchema$b = zgmYup.object({
  propertyCount: zgmYup.string().enumeration(PROPERTY_COUNT_OPTIONS)
});
var PropertyCount = function PropertyCount(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Not counting your primary residence, how many total properties do you own?"
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value, _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$b
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value, _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
PropertyCount.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.string,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var validationSchema$c = zgmYup.object({
  propertyType: zgmYup.string().enumeration(PROPERTY_TYPE_OPTIONS)
});
var PropertyType = function PropertyType(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    answers = _ref.answers,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: answers.loanType === 'purchase' ? 'What kind of home are you looking for?' : 'What kind of home do you currently own?',
    description: "It can make a difference in the interest rate you get."
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value, _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$c
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value, _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
PropertyType.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.string,
  answers: propTypes.shape({
    loanType: propTypes.string
  }),
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var validationSchema$d = zgmYup.object({
  propertyUsage: zgmYup.string().enumeration(PROPERTY_USAGE_OPTIONS)
});
var PropertyUsage = function PropertyUsage(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    answers = _ref.answers,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: answers.loanType === 'purchase' ? 'How will you use your new home?' : 'How are you using this home?',
    description: "It'll affect your home loan options."
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value, _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$d
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value, _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
PropertyUsage.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.string,
  answers: propTypes.shape({
    loanType: propTypes.string
  }),
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var validationSchema$e = zgmYup.object({
  propertyValue: zgmYup.float().positive().min(HOME_PRICE_MIN).max(DOLLARS_MAX).dollar().round().convertEmptyToNull().nullable().required()
});
var getLayoutCopy = function getLayoutCopy(loanType, context) {
  return {
    title: loanType === 'purchase' ? "What's your " + (context.entry === 'connect' ? 'target ' : '') + "purchase price?" : "What's the estimated value of your home?",
    description: loanType === 'purchase' ? context.entry === 'connect' ? "It's ok to estimate." : 'Your loan amount can affect your loan program and rate.' : context.entry === 'connect' ? 'Estimated value:' : 'This is used to calculate your LTV (loan-to-value) ratio.'
  };
};
var PropertyValue = function PropertyValue(_ref) {
  var _answers$location, _ref2;
  var name = _ref.name,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    answers = _ref.answers,
    context = _ref.context,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  var defaultStatePropertyValue = uxConfiguration.defaultPropertyValuesByState[answers === null || answers === void 0 ? void 0 : (_answers$location = answers.location) === null || _answers$location === void 0 ? void 0 : _answers$location.state] || defaultValue;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, getLayoutCopy(answers.loanType, context), /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value !== null && value !== void 0 ? value : context.entry !== 'connect' ? defaultStatePropertyValue : 400000, _ref2),
    hasFormActions: true,
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$e
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledField, {
      field: fields[name],
      focus: true
    });
  }));
};
PropertyValue.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.any,
  defaultValue: propTypes.any,
  answers: propTypes.shape({
    loanType: propTypes.string,
    location: propTypes.shape({
      state: propTypes.string
    })
  }),
  context: propTypes.shape({
    entry: propTypes.string.isRequired
  }),
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var validationSchema$f = zgmYup.object({
  secondMortgage: zgmYup.string().enumeration(NO_YES_OPTIONS)
});
var SecondMortgage = function SecondMortgage(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Do you have a second mortgage or a home equity line of credit on this property?"
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value === null || value === void 0 ? void 0 : value.toString(), _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$f
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      vertical: false,
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value === 'true', _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
SecondMortgage.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.bool,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var validationSchema$g = zgmYup.object({
  selling: zgmYup.string().enumeration(NO_YES_OPTIONS)
});
var Selling = function Selling(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Do you plan on selling this home?"
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value === null || value === void 0 ? void 0 : value.toString(), _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$g
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      vertical: false,
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value === 'true', _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
Selling.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.bool,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var selfEmployed = tooltipContent.selfEmployed;
var validationSchema$h = zgmYup.object({
  selfEmployed: zgmYup.string().enumeration(NO_YES_OPTIONS)
});
var SelfEmployed = function SelfEmployed(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Are you ", /*#__PURE__*/React.createElement(TooltipWithTrigger, selfEmployed), "?")
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value === null || value === void 0 ? void 0 : value.toString(), _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$h
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      field: fields[name],
      vertical: false,
      required: false,
      onClick: function onClick(event) {
        var _onChange;
        return event.target.value && onChange((_onChange = {}, _onChange[name] = event.target.value === 'true', _onChange)).then(function (_ref4) {
          var _onNext;
          var key = _ref4.key,
            answer = _ref4.value;
          return onNext((_onNext = {}, _onNext[key] = answer, _onNext));
        });
      }
    });
  }));
};
SelfEmployed.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.bool,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var StartTheProcess = function StartTheProcess(_ref) {
  var onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Start the Pre\u2011Qualification Process",
    description: "If you need a home loan, it's best to get pre-qualified early. Quickly find a local lender on Zillow who can help you get pre-qualified for a loan."
  }, /*#__PURE__*/React.createElement(Button, {
    buttonType: "primary",
    onClick: onNext
  }, "Let's get started"));
};
StartTheProcess.propTypes = process.env.NODE_ENV !== "production" ? {
  onNext: propTypes.func.isRequired
} : {};

var validationSchema$i = zgmYup.object({
  vaEligible: zgmYup.string().enumeration(NO_YES_OPTIONS)
});
var getDescriptionCopy$1 = function getDescriptionCopy(loanType) {
  return loanType === 'purchase' ? 'If so, you may qualify for a VA loan with $0 down and no PMI.' : 'If so, you may qualify for a VA Interest Rate Reduction Refinance Loan (IRRRL).';
};
var VaEligible = function VaEligible(_ref) {
  var _ref2;
  var name = _ref.name,
    value = _ref.value,
    answers = _ref.answers,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  var handleClick = useCallback(function (event) {
    return new Promise(function ($return, $error) {
      var _onChange, _onNext, _await$onChange, key, answer;
      if (!event.target.value) {
        return $return();
      }
      return Promise.resolve(onChange((_onChange = {}, _onChange[name] = event.target.value === 'true', _onChange))).then(function ($await_1) {
        try {
          _await$onChange = $await_1, key = _await$onChange.key, answer = _await$onChange.value;
          onNext((_onNext = {}, _onNext[key] = answer, _onNext));
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }, [name, onChange, onNext]);
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: VA_QUESTION_TEXT,
    description: getDescriptionCopy$1(answers.loanType)
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    defaultValues: (_ref2 = {}, _ref2[name] = value === null || value === void 0 ? void 0 : value.toString(), _ref2),
    onChange: onChange,
    onSubmit: onNext,
    validationSchema: validationSchema$i
  }, function (_ref3) {
    var fields = _ref3.fields;
    return /*#__PURE__*/React.createElement(StyledToggleButtonGroup, {
      "aria-label": "VA eligible",
      field: fields[name],
      vertical: false,
      required: false,
      onClick: handleClick
    });
  }));
};
VaEligible.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  value: propTypes.bool,
  answers: propTypes.shape({
    loanType: propTypes.string
  }),
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var VAModeShortCircuit = function VAModeShortCircuit(_ref) {
  var onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "No Lenders Found"
  }, /*#__PURE__*/React.createElement(Paragraph, {
    marginBottom: "sm"
  }, "VA loans can only be used for your primary residence."), /*#__PURE__*/React.createElement(Paragraph, null, "You can", ' ', /*#__PURE__*/React.createElement(Anchor, {
    as: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      window.history.back();
    }
  }, "go back"), ' ', "and update your answer or", ' ', /*#__PURE__*/React.createElement(Anchor, {
    as: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      onChange({
        key: 'vaEligible',
        value: false
      }).then(function () {
        return onNext({
          vaEligible: false
        });
      });
    }
  }, "continue"), ' ', "with a non-VA loan."));
};
VAModeShortCircuit.propTypes = process.env.NODE_ENV !== "production" ? {
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var VermontAgreement = function VermontAgreement(_ref) {
  var name = _ref.name,
    onChange = _ref.onChange,
    onNext = _ref.onNext;
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: "Disclosure for Vermont Customers"
  }, /*#__PURE__*/React.createElement(Paragraph, {
    marginBottom: "lg"
  }, "THIS IS A LOAN SOLICITATION ONLY. ZILLOW GROUP MARKETPLACE, INC. IS NOT THE LENDER. INFORMATION RECEIVED WILL BE SHARED WITH ONE OR MORE THIRD PARTIES IN CONNECTION WITH YOUR LOAN INQUIRY. THE LENDER MAY NOT BE SUBJECT TO ALL VERMONT LENDING LAWS. THE LENDER MAY BE SUBJECT TO FEDERAL LENDING LAWS."), /*#__PURE__*/React.createElement(Button, {
    buttonType: "primary",
    marginBottom: "xs",
    onClick: function onClick() {
      var _onChange;
      if (isLocalStorageSupported()) {
        localStorage.setItem(VERMONT_DISCLAIMER_LOCAL_STORAGE_KEY, true);
      }
      trackEvent({
        category: 'Mortgages',
        action: 'Accept Vermont Disclaimer',
        label: getTrackingLabel()
      });
      return onChange((_onChange = {}, _onChange[name] = true, _onChange)).then(function () {
        var _onNext;
        return onNext((_onNext = {}, _onNext[name] = true, _onNext));
      });
    }
  }, "Continue"));
};
VermontAgreement.propTypes = process.env.NODE_ENV !== "production" ? {
  name: propTypes.string.isRequired,
  onChange: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired
} : {};

var defaultComponents = {
  CashOut: CashOut,
  CreditHistory: CreditHistory,
  CreditScore: CreditScore,
  Email: Email,
  FinalPage: FinalPage,
  FirstTime: FirstTime,
  DownPayment: DownPayment,
  HasAgent: HasAgent,
  HelocAmount: HelocAmount,
  HomeOwner: HomeOwner,
  Income: Income,
  JourneyStage: JourneyStage,
  Language: Language,
  LenderNotFound: LenderNotFound,
  LoanBalance: LoanBalance,
  Location: LocationQuestion,
  LoanType: LoanType,
  Name: Name,
  NeedAgent: NeedAgent,
  PAContact: PAContact,
  PAName: PAName,
  PhoneNumber: PhoneNumber,
  PropertyCount: PropertyCount,
  PropertyType: PropertyType,
  PropertyUsage: PropertyUsage,
  PropertyValue: PropertyValue,
  SecondMortgage: SecondMortgage,
  SelfEmployed: SelfEmployed,
  Selling: Selling,
  StartTheProcess: StartTheProcess,
  VaEligible: VaEligible,
  VAModeShortCircuit: VAModeShortCircuit,
  VermontAgreement: VermontAgreement
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      error: undefined
    };
    return _this;
  }
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      error: error
    };
  };
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    var _global$DD_RUM, _global$DD_RUM$addErr;
    (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addErr = _global$DD_RUM.addError) === null || _global$DD_RUM$addErr === void 0 ? void 0 : _global$DD_RUM$addErr.call(_global$DD_RUM, new Error('mortgage-questionnaire: rendering error'), {
      query: location.search,
      hash: location.hash,
      error: error,
      errorInfo: errorInfo
    });
  };
  _proto.render = function render() {
    if (this.state.error) {
      var _this$state$error$toS, _this$state$error;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
        level: "3",
        as: "h1",
        marginBottom: "md"
      }, "Connection has been lost"), /*#__PURE__*/React.createElement(Paragraph, null, "We are sorry, but we could not communicate with the server. Please wait a few moments and refresh this page."), process.env.ENV !== 'production' && /*#__PURE__*/React.createElement(Paragraph, {
        marginTop: "md",
        fontColor: "red500",
        fontType: FONT_TYPES.bodySmall
      }, "Debugging info: ", (_this$state$error$toS = (_this$state$error = this.state.error).toString) === null || _this$state$error$toS === void 0 ? void 0 : _this$state$error$toS.call(_this$state$error)));
    }
    return this.props.children;
  };
  return ErrorBoundary;
}(React.Component);
ErrorBoundary.propTypes = process.env.NODE_ENV !== "production" ? {
  children: propTypes.node
} : {};
var withErrorBoundary = function withErrorBoundary(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Component, props));
  };
};

var lastQuestion;

/**
 * This is the main component for clients.
 * Question answers are managed internally, and are only exposed in onChange and onSubmit handlers,
 * where logging and tracking need to be handled in event handlers
 * As a react component, schema and context props can be changed on the fly, hence AB tests can start both on page load or on specific question answer
 * It is up to the hosting app to pass AB test flags as context fields.
 */
var Questionnaire = function Questionnaire(_ref) {
  var _lenders$offeredLende, _lenders$offeredLende2;
  var schema = _ref.schema,
    externalContext = _ref.context,
    onChange = _ref.onChange,
    onRouteChange = _ref.onRouteChange,
    onSubmit = _ref.onSubmit,
    components = _ref.components,
    storageKey = _ref.storageKey,
    showProgress = _ref.showProgress,
    showLanding = _ref.showLanding,
    onStartOver = _ref.onStartOver,
    onUpdatedResults = _ref.onUpdatedResults,
    resultsUrl = _ref.resultsUrl;
  var context = useQuestionnaireContext(externalContext);

  // NOTE: trustedAnswers(won't be asked again) and targetedRoute(show on page load) is a ZGMI specific URL parsing behavior, while
  // useRouter and useAnswersStore are generic behavior for the mortgage-questionnaire package itself
  var targetRouteName = getTargetRouteName(schema);
  var trustedAnswers = useMemo(function () {
    return getTrustedAnswers(schema);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var initialAnswers = useMemo(function () {
    // NOTE: additional tabs share answers when initially open
    var isReloaded = getItem('reloaded') && !!targetRouteName;
    setItem('reloaded', true);
    return isReloaded ? Object.assign({}, trustedAnswers, userDataService.getCurrentSession(storageKey)) : trustedAnswers;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  var _useAnswersStore = useAnswersStore(storageKey, initialAnswers),
    answers = _useAnswersStore.answers,
    setAnswers = _useAnswersStore.setAnswers,
    prepopulate = _useAnswersStore.prepopulate;
  var _useRouter = useRouter$1(schema, targetRouteName, Object.keys(trustedAnswers), initialAnswers),
    currentQuestion = _useRouter.currentQuestion,
    isLanding = _useRouter.isLanding,
    submitted = _useRouter.submitted,
    goNext = _useRouter.goNext,
    startOver = _useRouter.startOver;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    isCompletedRequestScreenRendered = _useState2[0],
    setCompletedRequestScreenRenderState = _useState2[1];
  var handleCompletedRequestScreenRender = function handleCompletedRequestScreenRender(renderState) {
    setCompletedRequestScreenRenderState(renderState);
  };
  var validateAndPublishChange = function validateAndPublishChange(formData) {
    return new Promise(function ($return, $error) {
      var _ref2, _formData$key, _Object$assign, key, value, newAnswers, eventPayload;
      key = formData.key || currentQuestion.name;
      value = (_ref2 = (_formData$key = formData[key]) !== null && _formData$key !== void 0 ? _formData$key : formData.value) !== null && _ref2 !== void 0 ? _ref2 : formData;
      newAnswers = Object.assign({}, answers, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
      // TODO: ZGMIAIR-686 define all validation rule in schema so change validation could run here
      setAnswers(newAnswers);
      eventPayload = {
        key: key,
        value: value,
        answers: newAnswers,
        schema: schema
      };
      return Promise.resolve(onChange(eventPayload)).then(function ($await_1) {
        try {
          return $return(eventPayload);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var lenders = getLendersFromLocalStorage();
  // the 1 refers to lenders.primaryLender
  var numLenderMatches = ((_lenders$offeredLende = lenders === null || lenders === void 0 ? void 0 : (_lenders$offeredLende2 = lenders.offeredLenders) === null || _lenders$offeredLende2 === void 0 ? void 0 : _lenders$offeredLende2.length) !== null && _lenders$offeredLende !== void 0 ? _lenders$offeredLende : 0) + 1;
  useEffect(function () {
    //only fire when in questionnaire
    if (context.entry === 'cq' && !isLanding && isCompletedRequestScreenRendered !== undefined && !isCompletedRequestScreenRendered) {
      var _generateCQViewQuesti;
      event(generateCQViewQuestionEvent(currentQuestion.name, (_generateCQViewQuesti = {}, _generateCQViewQuesti[currentQuestion.name] = prepopulate(currentQuestion.name), _generateCQViewQuesti)));
    }
  }, [currentQuestion, isCompletedRequestScreenRendered]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (lastQuestion && currentQuestion !== lastQuestion) {
      trackPageView({
        questionConfig: currentQuestion,
        value: answers[currentQuestion.name],
        context: context
      });
      onRouteChange({
        key: currentQuestion.name,
        value: answers[currentQuestion.name],
        lastKey: lastQuestion.name,
        lastValue: answers[lastQuestion.name],
        answers: answers,
        schema: schema,
        isLanding: isLanding
      });
    }
    lastQuestion = currentQuestion;
    if (context.entry === 'connect' && !isLanding) {
      event(generateZgmiConnectQuestionViewEvent(currentQuestion.name, answers, context.landingPage, lenders === null || lenders === void 0 ? void 0 : lenders.contactId, numLenderMatches));
    }
  }, [currentQuestion]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    initializeEligibilityRequirements();
    initializeUxConfiguration();
    onRouteChange({
      key: currentQuestion.name,
      value: answers[currentQuestion.name],
      lastKey: lastQuestion.name,
      lastValue: answers[lastQuestion.name],
      answers: answers,
      schema: schema,
      isLanding: isLanding,
      isInit: true
    });
    track({
      category: 'Mortgages',
      action: "page view: " + context.landingPage,
      label: getTrackingLabel()
    });
    trackPageView({
      questionConfig: currentQuestion,
      value: answers[currentQuestion.name],
      context: context
    });
    if (answers.loanType) {
      track({
        category: 'Mortgages',
        action: "loan type inferred: " + answers.loanType,
        label: getTrackingLabel()
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (submitted) {
      var _global$DD_RUM, _global$DD_RUM$addErr;
      (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addErr = _global$DD_RUM.addError) === null || _global$DD_RUM$addErr === void 0 ? void 0 : _global$DD_RUM$addErr.call(_global$DD_RUM, 'mortgage-questionnaire:submitted-at-end-of-route-unexpectedly', {
        entry: context.entry,
        originalEntry: context.originalEntry,
        loanType: answers.loanType
      });
      onSubmit(answers);
    }
  }, [submitted]); // eslint-disable-line react-hooks/exhaustive-deps

  var onNext = function onNext(newAnswers) {
    var _global$DD_RUM2, _global$DD_RUM2$addAc;
    (_global$DD_RUM2 = global.DD_RUM) === null || _global$DD_RUM2 === void 0 ? void 0 : (_global$DD_RUM2$addAc = _global$DD_RUM2.addAction) === null || _global$DD_RUM2$addAc === void 0 ? void 0 : _global$DD_RUM2$addAc.call(_global$DD_RUM2, 'mortgage-questionnaire:answered', {
      entry: context.entry,
      name: currentQuestion.name,
      value: currentQuestion.eventLabel || currentQuestion.eventLabelForConnect ? answers[currentQuestion.name] : undefined // only send labeled values
    });
    track({
      category: 'Mortgages',
      action: "next click: " + currentQuestion.eventLabel,
      label: getTrackingLabel()
    });
    if (context.entry === 'cq' && currentQuestion.name !== 'location') {
      event(generateCQSubmitQuestionEvent(currentQuestion.name, Object.assign({}, answers, newAnswers)));
      if (currentQuestion.name === 'vaEligible') {
        event(generateCQLoanRequestEvent(EVENT_TRIGGER.cqFunnel, EVENT_TRIGGER.answerButton, EVENT_TRIGGER.vaEligible, Object.assign({}, answers, newAnswers)));
      }
    } else if (context.entry === 'connect' && !isLanding) {
      event(generateSubmitZgmiConnectQuestionPageEvent(currentQuestion.name, answers, context.landingPage, lenders === null || lenders === void 0 ? void 0 : lenders.contactId, numLenderMatches));
    }
    // TODO: ZGMIAIR-999: track each question in more standardized format
    if (currentQuestion.name === 'loanType' && newAnswers['loanType']) {
      track({
        category: 'Mortgages',
        action: "loan type answered: " + newAnswers['loanType'].toLowerCase(),
        label: getTrackingLabel()
      });
    }
    return goNext({
      answers: Object.assign({}, answers, newAnswers)
    });
  };
  var handleStartOver = useCallback(function () {
    var minimumTrustedAnswers = getTrustedAnswers(schema);
    startOver(Object.keys(minimumTrustedAnswers));
    setAnswers(minimumTrustedAnswers);
    var startOverContext = getContext();
    if (startOverContext.originalEntry && startOverContext.entry !== startOverContext.originalEntry) {
      setContext({
        entry: startOverContext.originalEntry
      });
    }
  }, [onStartOver, startOver]); // eslint-disable-line react-hooks/exhaustive-deps

  var questionComponents = Object.assign({}, defaultComponents, components);
  var QuestionComponent = questionComponents[currentQuestion.component] || questionComponents['PlaceHolderQuestion'];
  if (!QuestionComponent) {
    throw new Error("Component \"" + currentQuestion.component + "\" not found! Note a temporary PlaceHolderQuestion can be provided for debugging purpose.");
  }
  var question = /*#__PURE__*/React.createElement(QuestionComponent, {
    key: currentQuestion.name,
    name: currentQuestion.name,
    value: prepopulate(currentQuestion.name),
    defaultValue: currentQuestion.defaultValue,
    answers: answers,
    context: context,
    config: currentQuestion,
    onChange: validateAndPublishChange,
    onNext: onNext,
    showLanding: showLanding,
    isLanding: isLanding,
    components: questionComponents
  });
  return showLanding ? /*#__PURE__*/React.createElement(QuestionnaireLayout, {
    onStartOver: handleStartOver,
    onUpdatedResults: onUpdatedResults,
    showProgress: showProgress,
    schema: schema,
    answers: answers,
    context: context,
    currentQuestion: currentQuestion,
    isLanding: isLanding,
    onCompletedRequestScreenRender: handleCompletedRequestScreenRender,
    resultsUrl: resultsUrl
  }, question) : question;
};
Questionnaire.propTypes = process.env.NODE_ENV !== "production" ? {
  /** questionnaire schema **/
  schema: propTypes.arrayOf(propTypes.shape({
    /** unique name of the question identifier, also used as routing URL hash name **/
    name: propTypes.string.isRequired,
    /** React component to render the question **/
    component: propTypes.isRequired,
    /** if presented, step to the question only when condition is met, @param {{schema, answers, context}} **/
    /** NOTE: a route is always skipped if context[name] is provided **/
    condition: propTypes.func,
    /** if presented, this function is called with {{answers, context}} before route happens. **/
    /** @returns { [key], value} to supply additional answers fields, and route to desired path if 'path' field is returned **/
    onNext: propTypes.func,
    /** if present, validate the question answer before accepting changes (including skipping questions initially when URL query presents) @param {{schema, answers, validator}} **/
    validate: propTypes.func,
    /** if present, use the question is taken into account for current step and total steps, use with showProgress prop **/
    index: propTypes.number
    /** consumers are free to add other fields, which will be passed down to custom components **/
  })).isRequired,
  /** context from external config, eg known answers in the form of { <question.name>: <question.answer>, ...} **/
  context: propTypes.object,
  /** called whenever data change is committed (answered by user and validated), @returns { key: <changed question name>, value: <changed question value>, answers: <all committed answers>, schema } **/
  onChange: propTypes.func,
  /** called whenever route to next/previous question, or brower back/forward is clicked, @returns { key: <changed question name>, value: <changed question value>, lastKey, lastValue, answers: <all committed answers>, schema } **/
  onRouteChange: propTypes.func,
  /** called questionnaire is completed, @returns committed answer object (same format as internal `answers` map) **/
  onSubmit: propTypes.func,
  /** custom components **/
  components: propTypes.objectOf(propTypes.elementType),
  storageKey: propTypes.string.isRequired,
  /** show a progress bar below the question, schema config must include "indexed" routes to calculate progress deterministically **/
  showProgress: propTypes.bool,
  /** show a different landing view when this is set, including an already completed screen with restart buttons **/
  showLanding: propTypes.bool,
  /** called when showLanding is set to true and user clicks "start over" button to restart the questionnaire **/
  onStartOver: propTypes.func,
  /** called when showLanding is set to true and user clicks "Get updated results" button to view refreshed results **/
  onUpdatedResults: propTypes.func,
  /** when showLanding is set to true, this is the URL to redirect to when user clicks "Get updated results" button **/
  resultsUrl: propTypes.string
} : {};
Questionnaire.defaultProps = {
  schema: jsArrayConfig,
  context: {},
  onChange: function onChange(updatedData) {
    return updatedData;
  },
  // TODO: add unit test to make sure onRouteChange is called when and only when route is changed
  onRouteChange: function onRouteChange(nextpageData) {
    return nextpageData;
  },
  storageKey: 'mortgage-questionnaire'
};

// OK to optimize because data change impacts routing even without re-render
var arePropsEffectivelyEqual = function arePropsEffectivelyEqual(_ref3, _ref4) {
  var schema = _ref3.schema;
  var newSchema = _ref4.schema;
  return newSchema === schema;
};
var PlaceHolderComponent = function PlaceHolderComponent() {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
var Questionnaire$1 = typeof window === 'undefined' ? PlaceHolderComponent : /*#__PURE__*/React.memo(withErrorBoundary(Questionnaire), arePropsEffectivelyEqual);

var _templateObject$8;
var LOADING_DELAY = 5000;
var LOADING_POINTS = ['Licensed and serving your area', 'Offers loans for your situation'];
var AnimatedListItem = styled(List.Item)(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    ", " {\n        animation: icon 0.5s ease-in-out 1s forwards;\n    }\n\n    ", " {\n        color: ", ";\n        animation: text 0.5s ease-in-out 1s forwards;\n    }\n\n    :nth-of-type(2) {\n        ", ", ", " {\n            animation-delay: 2s;\n        }\n    }\n\n    :nth-of-type(3) {\n        ", ", ", " {\n            animation-delay: 3s;\n        }\n    }\n\n    :nth-of-type(4) {\n        ", ", ", " {\n            animation-delay: 4s;\n        }\n    }\n\n    @keyframes icon {\n        0% {\n            transform: scale(1);\n        }\n        50% {\n            transform: scale(1.5);\n        }\n        100% {\n            transform: scale(1);\n            color: ", ";\n        }\n    }\n\n    @keyframes text {\n        100% {\n            color: ", ";\n        }\n    }\n"])), StyledIcon, StyledText, token('colors.textLight'), StyledIcon, StyledText, StyledIcon, StyledText, StyledIcon, StyledText, token('colors.backgroundDarkGreen'), token('colors.textDark'));
var LenderSearching = function LenderSearching(_ref) {
  var onDone = _ref.onDone,
    primaryLenderName = _ref.primaryLenderName;
  useEffect(function () {
    var id = setTimeout(function () {
      onDone();
    }, LOADING_DELAY);
    return function () {
      clearTimeout(id);
    };
    // perform once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(BaseQuestionLayout, {
    title: !primaryLenderName ? 'Connecting you with a lender' : "Connecting you with " + primaryLenderName,
    description: !primaryLenderName ? "We're searching our database of participating lenders to find a lender who can help with loans for your situation." : ''
  }, /*#__PURE__*/React.createElement(List, {
    appearance: "none"
  }, LOADING_POINTS.map(function (label) {
    return /*#__PURE__*/React.createElement(AnimatedListItem, {
      key: label
    }, /*#__PURE__*/React.createElement(IconCheckmark, {
      marginRight: "xs"
    }), /*#__PURE__*/React.createElement(Text, null, label));
  })));
};
LenderSearching.propTypes = process.env.NODE_ENV !== "production" ? {
  onDone: propTypes.func,
  primaryLenderName: propTypes.string
} : {};
LenderSearching.defaultProps = {
  onDone: function onDone() {},
  primaryLenderName: ''
};
LenderSearching.LOADING_DELAY = LOADING_DELAY;

export default Questionnaire$1;
export { BaseQuestionLayout, LenderSearching, ZDocESignatureConsent, getConnectFunnelBlock, getLendersFromLocalStorage, premierAgentExperiment };
